var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany1Dark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1921,
    height: 369,
    viewBox: "0 0 1921 369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_950_17312",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1921,
    height: 369
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1920.86 0H0.859375V369H1920.86V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_950_17312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1920.86 0H0.859375V369H1920.86V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.049 122.86C829.549 123.73 829.549 125.13 828.049 126C826.539 126.87 824.109 126.87 822.609 126C821.109 125.13 821.109 123.73 822.609 122.86C824.109 121.99 826.539 121.99 828.049 122.86Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.29 110.3C807.8 111.17 807.8 112.57 806.29 113.44C804.79 114.31 802.36 114.31 800.85 113.44C799.35 112.57 799.35 111.17 800.85 110.3C802.36 109.43 804.79 109.43 806.29 110.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.29 135.42C807.8 136.29 807.8 137.69 806.29 138.56C804.79 139.43 802.36 139.43 800.85 138.56C799.35 137.69 799.35 136.29 800.85 135.42C802.36 134.55 804.79 134.55 806.29 135.42Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.54 97.7399C786.05 98.6099 786.05 100.01 784.54 100.88C783.04 101.75 780.6 101.75 779.1 100.88C777.6 100.01 777.6 98.6099 779.1 97.7399C780.6 96.8699 783.04 96.8699 784.54 97.7399Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.54 122.86C786.04 123.73 786.04 125.13 784.54 126C783.04 126.87 780.6 126.87 779.1 126C777.6 125.13 777.6 123.73 779.1 122.86C780.6 121.99 783.04 121.99 784.54 122.86Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.54 147.98C786.04 148.85 786.04 150.25 784.54 151.12C783.04 151.99 780.6 151.99 779.1 151.12C777.6 150.25 777.6 148.85 779.1 147.98C780.6 147.11 783.04 147.11 784.54 147.98Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.79 110.3C764.29 111.17 764.29 112.57 762.79 113.44C761.29 114.31 758.85 114.31 757.35 113.44C755.85 112.57 755.85 111.17 757.35 110.3C758.85 109.43 761.29 109.43 762.79 110.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.79 135.42C764.29 136.29 764.29 137.69 762.79 138.56C761.29 139.43 758.85 139.43 757.35 138.56C755.85 137.69 755.85 136.29 757.35 135.42C758.85 134.55 761.29 134.55 762.79 135.42Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.03 122.86C742.53 123.73 742.53 125.13 741.03 126C739.53 126.87 737.09 126.87 735.59 126C734.09 125.13 734.09 123.73 735.59 122.86C737.09 121.99 739.53 121.99 741.03 122.86Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.049 122.86C829.549 123.73 829.549 125.13 828.049 126C826.539 126.87 824.109 126.87 822.609 126C821.109 125.13 821.109 123.73 822.609 122.86C824.109 121.99 826.539 121.99 828.049 122.86Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.29 135.42C807.8 136.29 807.8 137.69 806.29 138.56C804.79 139.43 802.36 139.43 800.85 138.56C799.35 137.69 799.35 136.29 800.85 135.42C802.36 134.55 804.79 134.55 806.29 135.42Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.54 147.98C786.04 148.85 786.04 150.25 784.54 151.12C783.04 151.99 780.6 151.99 779.1 151.12C777.6 150.25 777.6 148.85 779.1 147.98C780.6 147.11 783.04 147.11 784.54 147.98Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.29 110.3C807.8 111.17 807.8 112.57 806.29 113.44C804.79 114.31 802.36 114.31 800.85 113.44C799.35 112.57 799.35 111.17 800.85 110.3C802.36 109.43 804.79 109.43 806.29 110.3Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.54 122.86C786.04 123.73 786.04 125.13 784.54 126C783.04 126.87 780.6 126.87 779.1 126C777.6 125.13 777.6 123.73 779.1 122.86C780.6 121.99 783.04 121.99 784.54 122.86Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.79 135.42C764.29 136.29 764.29 137.69 762.79 138.56C761.29 139.43 758.85 139.43 757.35 138.56C755.85 137.69 755.85 136.29 757.35 135.42C758.85 134.55 761.29 134.55 762.79 135.42Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.54 97.7399C786.05 98.6099 786.05 100.01 784.54 100.88C783.04 101.75 780.6 101.75 779.1 100.88C777.6 100.01 777.6 98.6099 779.1 97.7399C780.6 96.8699 783.04 96.8699 784.54 97.7399Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.79 110.3C764.29 111.17 764.29 112.57 762.79 113.44C761.29 114.31 758.85 114.31 757.35 113.44C755.85 112.57 755.85 111.17 757.35 110.3C758.85 109.43 761.29 109.43 762.79 110.3Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.03 122.86C742.53 123.73 742.53 125.13 741.03 126C739.53 126.87 737.09 126.87 735.59 126C734.09 125.13 734.09 123.73 735.59 122.86C737.09 121.99 739.53 121.99 741.03 122.86Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.049 122.04C276.549 122.91 276.549 124.31 275.049 125.18C273.539 126.05 271.109 126.05 269.609 125.18C268.109 124.31 268.109 122.91 269.609 122.04C271.109 121.17 273.539 121.17 275.049 122.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.29 109.48C254.8 110.35 254.8 111.75 253.29 112.62C251.79 113.49 249.36 113.49 247.85 112.62C246.35 111.75 246.35 110.35 247.85 109.48C249.36 108.61 251.79 108.61 253.29 109.48Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.29 134.6C254.8 135.47 254.8 136.87 253.29 137.74C251.79 138.61 249.36 138.61 247.85 137.74C246.35 136.87 246.35 135.47 247.85 134.6C249.36 133.73 251.79 133.73 253.29 134.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.53 96.9201C233.04 97.7901 233.04 99.1901 231.53 100.06C230.03 100.93 227.59 100.93 226.09 100.06C224.59 99.1901 224.59 97.7901 226.09 96.9201C227.59 96.0501 230.03 96.0501 231.53 96.9201Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.53 122.04C233.03 122.91 233.03 124.31 231.53 125.18C230.03 126.05 227.59 126.05 226.09 125.18C224.59 124.31 224.59 122.91 226.09 122.04C227.59 121.17 230.03 121.17 231.53 122.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.53 147.16C233.03 148.03 233.03 149.43 231.53 150.3C230.03 151.17 227.59 151.17 226.09 150.3C224.59 149.43 224.59 148.03 226.09 147.16C227.59 146.29 230.03 146.29 231.53 147.16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.78 109.48C211.28 110.35 211.28 111.75 209.78 112.62C208.28 113.49 205.84 113.49 204.34 112.62C202.84 111.75 202.84 110.35 204.34 109.48C205.84 108.61 208.28 108.61 209.78 109.48Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.78 134.6C211.28 135.47 211.28 136.87 209.78 137.74C208.28 138.61 205.84 138.61 204.34 137.74C202.84 136.87 202.84 135.47 204.34 134.6C205.84 133.73 208.28 133.73 209.78 134.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.03 122.04C189.53 122.91 189.53 124.31 188.03 125.18C186.53 126.05 184.09 126.05 182.59 125.18C181.09 124.31 181.09 122.91 182.59 122.04C184.09 121.17 186.53 121.17 188.03 122.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.049 122.04C276.549 122.91 276.549 124.31 275.049 125.18C273.539 126.05 271.109 126.05 269.609 125.18C268.109 124.31 268.109 122.91 269.609 122.04C271.109 121.17 273.539 121.17 275.049 122.04Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.29 134.6C254.8 135.47 254.8 136.87 253.29 137.74C251.79 138.61 249.36 138.61 247.85 137.74C246.35 136.87 246.35 135.47 247.85 134.6C249.36 133.73 251.79 133.73 253.29 134.6Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.53 147.16C233.03 148.03 233.03 149.43 231.53 150.3C230.03 151.17 227.59 151.17 226.09 150.3C224.59 149.43 224.59 148.03 226.09 147.16C227.59 146.29 230.03 146.29 231.53 147.16Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.29 109.48C254.8 110.35 254.8 111.75 253.29 112.62C251.79 113.49 249.36 113.49 247.85 112.62C246.35 111.75 246.35 110.35 247.85 109.48C249.36 108.61 251.79 108.61 253.29 109.48Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.53 122.04C233.03 122.91 233.03 124.31 231.53 125.18C230.03 126.05 227.59 126.05 226.09 125.18C224.59 124.31 224.59 122.91 226.09 122.04C227.59 121.17 230.03 121.17 231.53 122.04Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.78 134.6C211.28 135.47 211.28 136.87 209.78 137.74C208.28 138.61 205.84 138.61 204.34 137.74C202.84 136.87 202.84 135.47 204.34 134.6C205.84 133.73 208.28 133.73 209.78 134.6Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.53 96.9201C233.04 97.7901 233.04 99.1901 231.53 100.06C230.03 100.93 227.59 100.93 226.09 100.06C224.59 99.1901 224.59 97.7901 226.09 96.9201C227.59 96.0501 230.03 96.0501 231.53 96.9201Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.78 109.48C211.28 110.35 211.28 111.75 209.78 112.62C208.28 113.49 205.84 113.49 204.34 112.62C202.84 111.75 202.84 110.35 204.34 109.48C205.84 108.61 208.28 108.61 209.78 109.48Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.03 122.04C189.53 122.91 189.53 124.31 188.03 125.18C186.53 126.05 184.09 126.05 182.59 125.18C181.09 124.31 181.09 122.91 182.59 122.04C184.09 121.17 186.53 121.17 188.03 122.04Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.591 -25.3297C655.391 -25.2697 656.161 -25.2597 656.911 -25.3097L651.391 -15.2897L660.721 -20.8697C660.771 -20.6597 660.821 -20.4497 660.861 -20.2397C661.601 -16.7597 662.101 -13.0997 662.071 -9.56969C661.961 4.22031 661.171 34.3803 661.281 42.6803C661.381 49.6203 661.781 54.6003 662.501 57.2203C660.471 58.6903 657.121 58.6303 654.441 57.7803C654.381 56.3403 654.251 54.4903 653.891 51.8903C652.931 44.7403 649.011 31.4603 648.391 23.8303C647.771 16.2003 649.011 15.4403 648.871 9.2503C648.771 4.8603 645.841 -7.3197 644.141 -14.0197C644.221 -14.7397 644.261 -15.1297 644.261 -15.1297C644.261 -15.1297 648.321 -20.2497 650.081 -26.4397C651.861 -25.8397 653.421 -25.4197 654.591 -25.3297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.141 -14.0397C643.601 -8.95974 641.321 12.2103 639.701 23.4403C638.151 34.1903 636.331 62.9303 635.781 71.9603C635.721 72.8803 635.811 73.7903 636.041 74.6603C633.711 76.4203 629.711 75.6203 626.921 73.9903C626.931 71.2603 626.921 68.3003 626.891 66.6403C626.811 63.0202 623.431 45.8102 623.351 38.8903C623.271 31.9703 625.991 27.7703 626.401 22.9903C626.731 19.2703 624.711 7.50026 623.711 2.49026C620.181 -15.2897 624.041 -24.1597 627.321 -32.1997C628.071 -33.9597 628.731 -35.5297 629.151 -36.9897C630.011 -36.0197 631.041 -35.2097 632.211 -34.5897C636.751 -32.2297 644.511 -28.3497 650.091 -26.4397C648.331 -20.2597 644.271 -15.1297 644.271 -15.1297C644.271 -15.1297 644.231 -14.7397 644.151 -14.0297L644.141 -14.0397Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.361 71.9603C671.791 72.3503 671.131 72.5403 670.471 72.5403C670.001 72.5403 669.531 72.4403 669.101 72.2503C665.111 70.4903 655.541 66.0303 654.941 63.5803C654.461 61.6103 654.561 60.3103 654.461 57.7803C657.141 58.6403 660.491 58.6903 662.521 57.2203C662.661 57.7303 662.811 58.1603 662.981 58.4903C663.741 60.0103 669.711 66.1003 672.651 69.0503C673.491 69.8903 673.351 71.2903 672.371 71.9703L672.361 71.9603Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.531 88.8902C643.611 90.4502 642.7 91.5302 638.99 90.4502C636.36 89.6902 631.36 84.8302 628.69 82.0602C627.54 80.8702 626.891 79.2803 626.901 77.6203C626.901 76.5803 626.92 75.3202 626.92 74.0002C629.71 75.6302 633.71 76.4302 636.04 74.6702C636.25 75.5002 636.59 76.3102 637.04 77.0502C639.3 80.7702 643.461 87.7502 643.531 88.8902Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.141 -14.0297C645.851 -7.31971 648.781 4.8503 648.871 9.2403C649.011 15.4303 647.771 16.1903 648.391 23.8203C649.011 31.4503 652.931 44.7303 653.891 51.8803C654.241 54.4803 654.381 56.3303 654.441 57.7703C654.551 60.3003 654.441 61.6003 654.921 63.5703C655.521 66.0203 665.091 70.4803 669.081 72.2403C669.521 72.4303 669.991 72.5303 670.451 72.5303C671.111 72.5303 671.771 72.3403 672.341 71.9503C673.321 71.2803 673.461 69.8803 672.621 69.0303C669.681 66.0803 663.701 59.9903 662.951 58.4703C662.781 58.1403 662.631 57.7203 662.491 57.2003C661.761 54.5803 661.361 49.6003 661.271 42.6603C661.161 34.3603 661.941 4.20029 662.061 -9.58971C662.091 -13.1297 661.591 -16.7897 660.851 -20.2597C660.801 -20.4697 660.761 -20.6797 660.711 -20.8897",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.129 -36.9797C628.719 -35.5097 628.059 -33.9497 627.299 -32.1897C624.029 -24.1497 620.159 -15.2797 623.689 2.50026C624.679 7.51026 626.699 19.2803 626.379 23.0003C625.969 27.7803 623.249 31.9803 623.329 38.9003C623.419 45.8203 626.789 63.0303 626.869 66.6503C626.909 68.3103 626.889 76.5903 626.889 77.6303C626.879 79.2903 627.519 80.8803 628.679 82.0703C631.359 84.8403 636.349 89.7003 638.979 90.4603C642.689 91.5303 643.599 90.4603 643.519 88.9003C643.459 87.7603 639.299 80.7803 637.029 77.0603C636.579 76.3203 636.249 75.5103 636.029 74.6803C635.809 73.8103 635.709 72.8903 635.769 71.9803C636.319 62.9403 638.139 34.2003 639.689 23.4603C641.309 12.2203 643.599 -8.94974 644.129 -14.0097C644.209 -14.7297 644.249 -15.1197 644.249 -15.1197C644.249 -15.1197 648.309 -20.2397 650.069 -26.4297",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.92 74.0103C629.71 75.6403 633.71 76.4403 636.04 74.6803",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.451 57.7803C657.131 58.6403 660.481 58.6903 662.511 57.2203",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.571 30.45V37.97C768.571 39.68 767.331 41.48 764.891 42.88L712.631 73.06C708.171 75.63 701.441 75.91 697.581 73.68L634.741 37.4C632.991 36.4 632.141 35.04 632.141 33.63V26.11C632.141 27.52 632.991 28.87 634.741 29.88L697.581 66.16C701.441 68.39 708.171 68.11 712.631 65.54L764.891 35.36C767.331 33.95 768.571 32.15 768.571 30.45Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.971 26.68C767.721 27.69 768.571 29.04 768.571 30.45C768.571 32.16 767.331 33.96 764.891 35.36L712.631 65.54C708.171 68.11 701.441 68.39 697.581 66.16L634.741 29.88C632.991 28.88 632.141 27.52 632.141 26.11C632.141 24.4 633.381 22.6 635.821 21.19L688.091 -8.98004C692.541 -11.56 699.271 -11.83 703.131 -9.61004L765.971 26.67V26.68Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.979 92.38C706.839 94.61 706.359 98.5 701.899 101.07L696.009 104.47C691.549 107.04 684.819 107.32 680.959 105.09L618.119 68.81C614.259 66.58 614.739 62.69 619.199 60.12L625.089 56.72C629.549 54.15 636.279 53.87 640.129 56.1L702.969 92.38H702.979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.35 120.81C678.21 123.03 677.72 126.92 673.27 129.49L667.37 132.89C662.92 135.46 656.18 135.74 652.33 133.52L589.49 97.24C585.63 95.01 586.12 91.12 590.58 88.55L596.47 85.15C600.93 82.58 607.66 82.3 611.51 84.52L674.35 120.81Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.72 149.24C649.58 151.47 649.09 155.36 644.64 157.93L638.74 161.33C634.29 163.9 627.55 164.18 623.7 161.95L560.86 125.67C557 123.44 557.49 119.55 561.94 116.98L567.84 113.58C572.29 111.01 579.03 110.73 582.88 112.96L645.72 149.24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.69 161.95L560.85 125.67C556.99 123.44 557.48 119.55 561.93 116.98L567.83 113.58C572.28 111.01 579.02 110.73 582.87 112.96L645.71 149.24C649.57 151.47 649.08 155.36 644.63 157.93L638.73 161.33C634.28 163.9 627.54 164.18 623.69 161.95Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.33 133.53L589.49 97.25C585.63 95.02 586.12 91.13 590.58 88.56L596.47 85.16C600.93 82.59 607.66 82.31 611.51 84.53L674.35 120.82C678.21 123.04 677.72 126.93 673.27 129.5L667.37 132.9C662.92 135.47 656.18 135.75 652.33 133.53Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.961 105.09L618.121 68.81C614.261 66.58 614.741 62.69 619.201 60.12L625.091 56.72C629.551 54.15 636.281 53.87 640.131 56.1L702.971 92.38C706.831 94.61 706.351 98.5 701.891 101.07L696.001 104.47C691.541 107.04 684.811 107.32 680.951 105.09H680.961Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.141 26.11C632.141 24.4 633.381 22.6 635.821 21.19L688.091 -8.98004C692.541 -11.56 699.271 -11.83 703.131 -9.61004L765.971 26.67C767.721 27.68 768.571 29.03 768.571 30.44C768.571 32.15 767.331 33.95 764.891 35.35L712.631 65.53C708.171 68.1 701.441 68.38 697.581 66.15L634.741 29.87C632.991 28.87 632.141 27.52 632.141 26.1V26.11Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.571 30.45V37.97C768.571 39.68 767.331 41.48 764.891 42.88L712.631 73.06C708.171 75.63 701.441 75.91 697.581 73.68L634.741 37.4C632.991 36.4 632.141 35.04 632.141 33.63V26.11",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.75 13.4199C1309.79 18.6399 1310.81 26.7299 1303.81 32.5999C1302.92 31.8499 1301.9 31.14 1300.75 30.48C1290.56 24.59 1274.04 24.59 1263.85 30.48C1262.7 31.14 1261.69 31.8399 1260.79 32.5999C1253.79 26.7399 1254.8 18.6399 1263.85 13.4199C1274.04 7.52994 1290.56 7.52994 1300.75 13.4199Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303.8 32.5999C1302.91 33.3499 1301.89 34.0699 1300.74 34.7199C1290.55 40.6099 1274.03 40.6099 1263.84 34.7199C1262.69 34.0599 1261.68 33.3499 1260.78 32.5999C1261.67 31.8499 1262.69 31.1399 1263.84 30.4799C1274.03 24.5899 1290.55 24.5899 1300.74 30.4799C1301.89 31.1399 1302.9 31.8399 1303.8 32.5999Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.79 32.5999C1253.8 26.7199 1254.8 18.6399 1263.85 13.4199C1274.04 7.52994 1290.56 7.52994 1300.75 13.4199C1309.79 18.6399 1310.8 26.7199 1303.81 32.5999C1302.92 33.3499 1301.9 34.0699 1300.75 34.7199C1290.56 40.6099 1274.04 40.6099 1263.85 34.7199C1262.7 34.0599 1261.69 33.3499 1260.79 32.5999Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.78 32.5999C1261.67 31.8499 1262.69 31.1399 1263.84 30.4799C1274.03 24.5899 1290.55 24.5899 1300.74 30.4799C1301.89 31.1399 1302.9 31.8399 1303.8 32.5999",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.68 -27.3V102.72L1216.56 131.66V1.63001L1266.68 -27.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.68 -27.3L1216.56 1.63L1166.44 -27.3L1188.66 -40.13V-27.25L1216.56 -11.14L1244.46 -27.25V-40.13L1266.68 -27.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.56 1.63001V131.66L1204.11 124.5V105.65L1179.03 91.2L1168.58 103.96L1166.44 102.72V-27.3L1216.56 1.63001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.11 105.65V124.5L1191.52 131.81V120.94L1204.11 105.65Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.11 105.65L1191.52 120.94L1166.5 106.5L1179.03 91.2L1204.11 105.65Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.52 120.94V131.81L1166.5 117.36V106.5L1191.52 120.94Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.46 -40.13L1266.68 -27.3L1216.56 1.63L1166.44 -27.3L1188.66 -40.13",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.56 1.63V131.66",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.68 -27.3V102.72L1216.56 131.66L1204.11 124.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.58 103.96L1166.44 102.72V-27.3",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.99 -5.60999V33.72",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.52 1.62V41.58",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.05 8.85999V48.19",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.99 43.77V83.11",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.52 51.01V90.96",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.05 58.24V97.57",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.12 -5.60999V33.72",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.6 1.62V41.58",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.07 8.85999V48.19",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.12 43.77V83.11",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.6 51.01V90.96",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.07 58.24V97.57",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.52 131.81V120.94L1204.11 105.65V124.5L1191.52 131.81Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.52 131.81L1166.5 117.36V106.5L1179.03 91.2L1204.11 105.65",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.5 106.5L1191.52 120.94",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.61 123.9C407.38 123.45 408.46 123.51 409.65 124.2L467.24 157.45C469.61 158.82 471.54 162.15 471.54 164.9V206.32C471.54 207.66 471.09 208.61 470.34 209.07L470.28 209.11C469.5 209.56 468.43 209.49 467.24 208.81L444.41 195.62L438.44 207.57L432.48 188.73L409.65 175.55C407.27 174.18 405.35 170.85 405.35 168.1V126.68C405.35 125.31 405.83 124.35 406.61 123.9ZM427.62 159.85C427.62 157.71 426.11 155.1 424.26 154.03C422.4 152.96 420.9 153.83 420.9 155.97C420.9 158.11 422.4 160.72 424.26 161.79C426.11 162.86 427.62 161.99 427.62 159.85ZM441.8 168.04C441.8 165.9 440.3 163.29 438.44 162.22C436.59 161.15 435.08 162.02 435.08 164.16C435.08 166.3 436.59 168.91 438.44 169.98C440.3 171.05 441.8 170.18 441.8 168.04ZM455.99 176.23C455.99 174.08 454.48 171.47 452.63 170.41C450.77 169.34 449.27 170.21 449.27 172.35C449.27 174.49 450.77 177.11 452.63 178.17C454.48 179.24 455.99 178.37 455.99 176.23Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.649 124.2L467.239 157.45C469.609 158.82 471.539 162.15 471.539 164.9V206.32C471.539 207.66 471.089 208.61 470.339 209.07L476.919 205.27C477.689 204.82 478.179 203.86 478.179 202.48V161.06C478.179 158.32 476.259 154.99 473.879 153.61L416.289 120.36C415.099 119.67 414.029 119.61 413.249 120.06L406.609 123.89C407.379 123.44 408.459 123.5 409.649 124.19V124.2Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.9 155.97C420.9 158.11 422.4 160.72 424.26 161.79C426.11 162.86 427.62 161.99 427.62 159.85C427.62 157.71 426.11 155.1 424.26 154.03C422.4 152.96 420.9 153.83 420.9 155.97Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.08 164.16C435.08 166.3 436.59 168.91 438.44 169.98C440.3 171.05 441.8 170.18 441.8 168.04C441.8 165.9 440.3 163.29 438.44 162.22C436.59 161.15 435.08 162.02 435.08 164.16Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.27 172.34C449.27 174.49 450.77 177.1 452.63 178.16C454.48 179.23 455.99 178.36 455.99 176.22C455.99 174.08 454.48 171.46 452.63 170.4C450.77 169.33 449.27 170.2 449.27 172.34Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.28 209.1C469.5 209.55 468.43 209.48 467.24 208.8L444.41 195.61L438.44 207.56L432.48 188.72L409.65 175.54C407.27 174.17 405.35 170.84 405.35 168.09V126.67C405.35 125.3 405.83 124.34 406.61 123.89C407.39 123.44 408.46 123.5 409.65 124.19L467.24 157.44C469.61 158.81 471.54 162.14 471.54 164.89V206.31C471.54 207.65 471.09 208.6 470.34 209.06",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.27 172.34C449.27 170.2 450.77 169.33 452.63 170.4C454.48 171.47 455.99 174.07 455.99 176.22C455.99 178.37 454.48 179.23 452.63 178.16C450.77 177.09 449.27 174.49 449.27 172.34Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.08 164.16C435.08 162.02 436.59 161.15 438.44 162.22C440.3 163.29 441.8 165.9 441.8 168.04C441.8 170.18 440.3 171.06 438.44 169.98C436.59 168.91 435.08 166.3 435.08 164.16Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.9 155.97C420.9 153.82 422.4 152.95 424.26 154.03C426.11 155.1 427.62 157.71 427.62 159.85C427.62 161.99 426.11 162.86 424.26 161.79C422.4 160.72 420.9 158.11 420.9 155.97Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.279 209.1L476.929 205.27C477.699 204.82 478.189 203.86 478.189 202.48V161.06C478.189 158.32 476.269 154.99 473.889 153.61L416.299 120.36C415.109 119.67 414.039 119.61 413.259 120.06L406.619 123.89",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.211 -97.5601V-0.330063L408.631 36.3699V-60.8601L472.211 -97.5601Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.211 -0.330063L408.631 36.3699V-60.8601L472.211 -97.5601V-0.330063Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.75 180.99L227.75 209.35L241.6 217.35L252.6 188.99L238.75 180.99Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.6 188.99L241.6 217.35L263.61 204.64L252.6 188.99Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.6 217.35L263.61 204.64L252.6 188.99L241.6 217.35Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.6 188.99L238.75 180.99L227.75 209.35L241.6 217.35",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.83 410.44L267.55 369.61L361.22 423.69",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491.3 146.25C1492.82 147.13 1494.32 147.86 1495.79 148.43C1493.64 162.72 1481.99 167.86 1467.93 159.74C1465.83 158.53 1463.78 157.08 1461.81 155.43C1450.83 146.29 1442.26 131.16 1440.2 117.13C1439.88 115.01 1439.72 112.91 1439.72 110.88C1439.72 96.71 1447.55 89.19 1458.49 91.02C1460.07 91.28 1461.74 91.74 1463.45 92.42C1463.21 93.97 1463.09 95.63 1463.09 97.4C1463.09 99.44 1463.26 101.53 1463.57 103.65C1465.63 117.67 1474.21 132.8 1485.18 141.95C1487.15 143.6 1489.2 145.05 1491.3 146.26V146.25Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.49 91.02L1450.82 61.66C1456.17 62.54 1461.93 64.67 1467.93 68.14C1482.05 76.29 1494.83 90.28 1504.08 106.3C1513.33 122.31 1519.05 140.38 1519.05 156.68C1519.05 172.98 1513.45 184.19 1504.37 189.6L1504.07 189.77C1494.82 195.11 1482.04 194.34 1467.92 186.2C1453.8 178.05 1441.03 164.06 1431.78 148.04C1424.63 135.66 1419.59 122.05 1417.66 108.99L1440.19 117.14C1442.25 131.16 1450.82 146.3 1461.8 155.44C1463.77 157.09 1465.82 158.54 1467.92 159.75C1481.98 167.86 1493.62 162.73 1495.78 148.44C1496.02 146.89 1496.14 145.23 1496.14 143.46C1496.14 141.04 1495.91 138.54 1495.47 136.01C1492.67 119.8 1481.4 102.38 1467.92 94.6C1466.4 93.72 1464.9 92.99 1463.43 92.42C1461.72 91.75 1460.06 91.29 1458.47 91.02H1458.49Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.49 91.01C1447.56 89.19 1439.72 96.72 1439.72 110.89C1439.72 112.93 1439.88 115.02 1440.2 117.14L1417.67 108.99C1417.1 105.15 1416.81 101.36 1416.81 97.67C1416.81 81.37 1422.53 69.92 1431.78 64.58H1431.81C1437.12 61.5 1443.6 60.47 1450.82 61.67L1458.49 91.02V91.01Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.82 61.66C1443.6 60.45 1437.13 61.49 1431.81 64.55L1455.15 51.07C1460.47 48 1466.95 46.95 1474.19 48.16C1479.53 49.04 1485.29 51.17 1491.3 54.64C1505.41 62.79 1518.19 76.78 1527.44 92.8C1536.69 108.82 1542.41 126.88 1542.41 143.18C1542.41 159.48 1536.69 170.93 1527.44 176.27L1504.37 189.59C1513.45 184.17 1519.05 172.8 1519.05 156.67C1519.05 140.54 1513.32 122.31 1504.08 106.29C1494.83 90.27 1482.05 76.28 1467.93 68.13C1461.93 64.66 1456.17 62.53 1450.82 61.65V61.66Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495.79 148.43C1494.33 147.86 1492.83 147.13 1491.3 146.25C1489.2 145.04 1487.15 143.59 1485.18 141.94C1474.21 132.79 1465.63 117.67 1463.57 103.64C1463.26 101.52 1463.09 99.42 1463.09 97.39C1463.09 95.62 1463.21 93.96 1463.45 92.41",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1431.81 64.55C1437.12 61.49 1443.6 60.46 1450.82 61.66C1456.17 62.55 1461.93 64.67 1467.93 68.14C1482.05 76.29 1494.83 90.28 1504.08 106.3C1513.33 122.31 1519.05 140.38 1519.05 156.68C1519.05 172.98 1513.45 184.19 1504.37 189.6",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1504.07 189.77C1494.82 195.11 1482.04 194.34 1467.92 186.2C1453.8 178.05 1441.03 164.06 1431.78 148.04C1424.63 135.66 1419.59 122.05 1417.66 108.99C1417.09 105.15 1416.8 101.36 1416.8 97.67C1416.8 81.37 1422.52 69.92 1431.77 64.58",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.49 91.02C1460.07 91.28 1461.74 91.74 1463.45 92.42C1464.91 93 1466.41 93.72 1467.94 94.6C1481.42 102.38 1492.69 119.8 1495.49 136.01C1495.93 138.54 1496.16 141.04 1496.16 143.46C1496.16 145.23 1496.04 146.89 1495.8 148.44C1493.64 162.73 1482 167.87 1467.94 159.75C1465.84 158.54 1463.79 157.09 1461.82 155.44C1450.84 146.3 1442.29 131.16 1440.21 117.14C1439.9 115.02 1439.73 112.92 1439.73 110.89C1439.73 96.72 1447.56 89.2 1458.5 91.03L1458.49 91.02Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440.2 117.14L1417.67 108.98",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.49 91.01L1450.82 61.66",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1431.78 64.57L1455.14 51.08C1460.46 48.01 1466.94 46.96 1474.18 48.17C1479.52 49.05 1485.28 51.18 1491.29 54.65C1505.4 62.8 1518.18 76.79 1527.43 92.81C1536.68 108.83 1542.4 126.89 1542.4 143.19C1542.4 159.49 1536.68 170.94 1527.43 176.28L1504.06 189.77",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1546.28 319.88C1546.2 324.15 1543.33 328.4 1537.69 331.66C1526.22 338.28 1507.65 338.28 1496.19 331.66C1490.46 328.35 1487.59 324.02 1487.59 319.68C1487.59 315.34 1490.45 311.01 1496.18 307.7C1507.65 301.08 1526.22 301.08 1537.69 307.7C1543.51 311.06 1546.38 315.48 1546.28 319.89V319.88Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1546.28 319.88V369.43C1546.28 373.76 1543.42 378.1 1537.69 381.41C1526.22 388.03 1507.65 388.03 1496.19 381.41C1490.46 378.1 1487.59 373.77 1487.59 369.43V319.68C1487.59 324.01 1490.45 328.35 1496.19 331.66C1507.65 338.28 1526.23 338.28 1537.69 331.66C1543.33 328.4 1546.2 324.15 1546.28 319.88Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1546.28 319.88C1546.19 324.15 1543.33 328.4 1537.69 331.66C1526.22 338.28 1507.65 338.28 1496.19 331.66C1490.46 328.35 1487.59 324.02 1487.59 319.68C1487.59 315.34 1490.45 311.01 1496.18 307.7C1507.65 301.08 1526.22 301.08 1537.69 307.7C1543.51 311.06 1546.37 315.48 1546.28 319.89V319.88Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1546.28 319.68V369.43C1546.28 373.76 1543.42 378.1 1537.69 381.41C1526.22 388.03 1507.65 388.03 1496.19 381.41C1490.46 378.1 1487.59 373.77 1487.59 369.43V319.68",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1590.61 375.65C1591.43 376.16 1592.31 376.68 1593.23 377.22C1590.76 377.93 1588.52 378.35 1587.12 378.35C1584.9 378.35 1582.62 377.95 1580.51 377.22C1580.35 376.34 1580.04 375.48 1579.59 374.69C1579.2 374.01 1578.73 373.17 1578.18 372.2C1580.1 371.74 1583.23 370.53 1586.01 367.45C1586.55 369.14 1587.05 370.61 1587.48 371.8C1588.06 373.4 1589.15 374.75 1590.6 375.65H1590.61Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.95 299L1554.67 313.05C1548.64 313.19 1542.68 313.47 1537.93 314L1552.86 302.52L1572.95 299Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1538.98 382.54C1542.56 369.85 1540.77 360.74 1544.03 351.62C1545.73 346.87 1547.6 342.96 1549.01 340.31C1550.21 338.04 1549.62 335.24 1547.61 333.65L1542.98 329.97C1548.64 329.22 1553.96 327.96 1558.21 326.54L1560.52 328.91C1563.67 332.15 1564.76 336.87 1563.36 341.17C1563.22 341.61 1563.07 342.05 1562.93 342.49C1558.19 357.37 1554.92 369.3 1551.74 385.11",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1538.98 382.54C1542.56 369.85 1540.77 360.74 1544.03 351.62C1545.73 346.87 1547.6 342.96 1549.01 340.31C1550.21 338.04 1549.62 335.24 1547.61 333.65L1542.98 329.97C1548.64 329.22 1553.96 327.96 1558.21 326.54L1560.52 328.91C1563.67 332.15 1564.76 336.87 1563.36 341.17C1563.22 341.61 1563.07 342.05 1562.93 342.49C1558.19 357.37 1554.92 369.3 1551.74 385.11",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1551.56 303.52L1546.86 307.13C1545.72 307.49 1544.59 307.82 1543.46 308.04C1544.62 304.67 1546.2 302.17 1548.64 300.35C1549.71 301.54 1550.7 302.61 1551.55 303.51L1551.56 303.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1548.65 300.36C1546.2 302.18 1544.63 304.67 1543.47 308.05C1543.13 308.11 1542.8 308.17 1542.46 308.22C1541.81 306.81 1541.2 305.34 1540.64 303.83C1538.87 299.04 1537.68 293.93 1537.68 289.71C1537.68 288 1537.83 287.01 1538.02 286.27C1540.54 290.9 1545.02 296.32 1548.65 300.36Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1546.86 307.13L1540.11 312.32C1536.99 312.95 1533.36 313.33 1529.62 313.47C1529.67 311.94 1529.83 309.48 1530.3 305.9C1532.92 306.58 1535.57 307.29 1538.05 307.98C1538.95 308.23 1539.84 308.34 1540.73 308.34C1541.31 308.34 1541.88 308.29 1542.45 308.21C1542.79 308.16 1543.12 308.11 1543.46 308.04C1544.59 307.83 1545.72 307.49 1546.86 307.13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540.63 303.82C1541.19 305.33 1541.8 306.8 1542.45 308.21C1541.88 308.29 1541.3 308.34 1540.73 308.34C1539.84 308.34 1538.95 308.23 1538.05 307.98C1535.57 307.29 1526.12 304.82 1524.17 304.34C1529.09 303.71 1534.32 301.89 1536.13 299.43C1536.59 300.27 1537.2 301.03 1537.94 301.66C1538.77 302.36 1539.7 303.13 1540.63 303.83V303.82Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540.97 235.34C1542.94 237.79 1542.22 241.99 1539.22 244.99C1537.88 246.34 1536.3 247.22 1534.74 247.61C1534.87 247.12 1534.97 246.61 1535.05 246.1C1535.56 242.88 1535.41 240.55 1534.2 238.71C1533.51 238.51 1532.79 238.44 1532 238.44C1526.87 238.44 1525.47 243.03 1522.78 245.4C1521.16 246.83 1520.05 248.74 1519.42 250.81C1519.36 250.99 1519.31 251.17 1519.26 251.35C1518.38 251.7 1517.43 251.89 1516.43 251.89C1512.2 251.89 1508.77 248.46 1508.77 244.22C1508.77 243.86 1508.8 243.52 1508.85 243.17C1507.19 242.35 1506.04 240.65 1506.04 238.67C1506.04 236.69 1507.2 234.96 1508.88 234.15C1508.7 233.49 1508.59 232.79 1508.59 232.06C1508.59 228.37 1511.12 225.37 1514.23 225.37C1514.88 225.37 1515.5 225.51 1516.08 225.75C1517.35 223.24 1519.96 221.87 1522.3 222.66C1523.19 222.96 1523.92 223.53 1524.46 224.28C1525.78 221.98 1528.26 220.77 1530.49 221.52C1531.63 221.9 1532.52 222.73 1533.07 223.8C1533.68 223.74 1534.3 223.79 1534.9 223.99C1537 224.69 1538.23 226.91 1538.1 229.36C1538.79 229.57 1539.42 229.92 1539.94 230.44C1541.19 231.69 1541.51 233.55 1540.98 235.34H1540.97Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537.93 314C1542.68 313.47 1548.64 313.19 1554.67 313.05C1557.69 312.98 1560.72 312.95 1563.63 312.94C1567.65 312.94 1571.18 315.62 1572.23 319.5C1575.93 333.02 1582.2 355.62 1586.01 367.44C1583.23 370.52 1580.1 371.73 1578.18 372.19C1577.05 372.47 1576.34 372.49 1576.34 372.49L1562.93 342.48C1563.07 342.04 1563.21 341.6 1563.36 341.16C1564.75 336.86 1563.67 332.14 1560.52 328.9L1558.21 326.53C1553.95 327.95 1548.64 329.21 1542.98 329.96C1530.81 331.57 1517.06 330.79 1508.83 324.07C1512.57 323.41 1516.58 319.98 1519.36 313.7C1524.78 315.02 1529.62 315.5 1529.62 315.5C1529.62 315.5 1529.57 314.87 1529.62 313.47C1533.36 313.34 1536.98 312.96 1540.11 312.32L1537.93 314Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537.67 289.7C1537.67 293.92 1538.87 299.03 1540.63 303.82C1539.7 303.12 1538.77 302.35 1537.94 301.65C1537.19 301.02 1536.59 300.26 1536.13 299.42C1535.5 298.28 1535.16 296.98 1535.15 295.64C1535.12 293.11 1535.09 289.25 1535 284.2C1534.88 277.06 1532.4 267.71 1528.61 260.27C1527.91 258.92 1527.18 257.63 1526.41 256.43C1526.62 255.47 1527.46 254.73 1528.45 254.74C1529.78 254.75 1530.97 254.14 1531.96 253.11C1532 253.11 1532.05 253.12 1532.09 253.13C1535.15 253.56 1537.35 256.3 1537.16 259.39C1536.93 263.01 1536.68 267.35 1536.46 271.88C1536.37 273.71 1536.77 275.54 1537.59 277.18C1538.32 278.64 1538.89 280.02 1538.89 282.08C1538.89 284.46 1538.37 284.89 1538.01 286.25C1537.82 286.98 1537.67 287.98 1537.67 289.69V289.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1535.15 295.65C1535.16 296.99 1535.5 298.29 1536.13 299.43C1534.32 301.88 1529.09 303.71 1524.17 304.34C1523.49 304.17 1522.82 304 1522.17 303.84C1522.49 301.82 1522.71 299.66 1522.83 297.34C1523.5 282.96 1518.6 270.23 1516.46 265.44C1516.04 264.49 1515.75 263.51 1515.58 262.5C1523.87 267.73 1527.81 268.01 1527.81 268.01C1527.81 268.01 1528.52 264.46 1528.61 260.28C1532.4 267.72 1534.88 277.07 1535 284.21C1535.09 289.26 1535.13 293.12 1535.15 295.65Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1526.41 256.43C1527.18 257.63 1527.91 258.92 1528.61 260.27C1528.53 264.45 1527.81 268 1527.81 268C1527.81 268 1523.87 267.72 1515.58 262.49C1515.36 261.14 1515.39 259.75 1515.7 258.41C1515.88 257.63 1516.15 256.86 1516.56 256.18L1516.54 256.15C1517.54 255.52 1518.29 254.55 1518.64 253.4C1518.85 252.7 1519.36 250.99 1519.41 250.81C1520.04 248.74 1521.14 246.83 1522.77 245.4C1525.46 243.03 1526.87 238.44 1531.99 238.44C1532.79 238.44 1533.5 238.51 1534.19 238.71C1535.39 240.55 1535.54 242.89 1535.04 246.1C1534.96 246.61 1534.86 247.12 1534.73 247.61C1534.17 249.84 1533.23 251.81 1531.96 253.11C1530.97 254.14 1529.78 254.75 1528.45 254.74C1527.45 254.74 1526.62 255.47 1526.41 256.43Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1517.7 313.28C1518.25 313.43 1518.8 313.57 1519.35 313.7C1516.57 319.97 1512.56 323.39 1508.82 324.07C1508.27 324.17 1507.74 324.21 1507.2 324.19C1501.61 323.99 1499.44 322.2 1496.17 315.34C1499.25 312.83 1501.54 309.79 1503.05 306.69C1504.16 308.96 1506.18 310.72 1508.7 311.44C1510.58 311.98 1512.72 312.41 1515.02 312.74C1515.92 312.87 1516.82 313.04 1517.69 313.28H1517.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1529.62 313.47C1529.56 314.87 1529.62 315.5 1529.62 315.5C1529.62 315.5 1524.78 315.01 1519.36 313.7C1518.81 313.57 1518.26 313.43 1517.71 313.28C1516.83 313.04 1515.93 312.87 1515.04 312.74C1512.74 312.41 1510.59 311.98 1508.72 311.44C1506.2 310.73 1504.18 308.96 1503.07 306.69C1502.53 305.59 1502.19 304.37 1502.12 303.09C1501.47 291.51 1501.83 282.64 1502.79 271.45C1503.2 266.74 1505.78 262.48 1509.77 259.95C1511.84 258.64 1513.95 257.44 1516.06 256.42C1516.23 256.34 1516.4 256.25 1516.55 256.15L1516.57 256.18C1516.16 256.86 1515.89 257.63 1515.71 258.41C1515.4 259.75 1515.37 261.13 1515.59 262.49C1515.75 263.5 1516.05 264.49 1516.47 265.43C1518.61 270.23 1523.51 282.95 1522.84 297.33C1522.73 299.65 1522.5 301.81 1522.18 303.83C1522.82 303.99 1528.21 305.35 1530.31 305.89C1529.84 309.47 1529.68 311.93 1529.63 313.46L1529.62 313.47Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1529.62 313.47C1533.36 313.34 1536.98 312.96 1540.11 312.32",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508.83 324.07C1517.06 330.79 1530.81 331.57 1542.98 329.96C1548.64 329.21 1553.96 327.97 1558.21 326.53C1559.08 326.24 1559.89 325.94 1560.66 325.65",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1503.06 306.67C1503.06 306.67 1503.06 306.68 1503.05 306.69C1501.54 309.78 1499.26 312.83 1496.17 315.34C1499.44 322.2 1501.61 323.99 1507.2 324.19C1507.73 324.21 1508.27 324.17 1508.82 324.07C1512.56 323.39 1516.43 319.91 1519.35 313.7C1519.35 313.69 1519.36 313.67 1519.37 313.66",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1522.17 303.83C1522.49 301.81 1522.71 299.65 1522.83 297.33C1523.5 282.95 1518.6 270.22 1516.46 265.43C1516.04 264.48 1515.75 263.5 1515.58 262.49C1515.36 261.14 1515.39 259.75 1515.7 258.41C1515.88 257.63 1516.15 256.86 1516.56 256.18",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543.46 308.04C1544.59 307.82 1545.72 307.49 1546.86 307.13",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.5 279.14C1512.74 285.82 1512.24 291.82 1512.6 298.96C1512.68 300.49 1513.76 301.78 1515.24 302.13C1516.93 302.54 1535.57 307.28 1538.05 307.97C1538.95 308.22 1539.84 308.33 1540.73 308.33C1541.31 308.33 1541.88 308.28 1542.45 308.2C1542.79 308.15 1543.12 308.1 1543.46 308.03",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.97 253.12C1531.97 253.12 1532.05 253.12 1532.1 253.13C1535.16 253.56 1537.36 256.3 1537.17 259.39C1536.94 263.01 1536.69 267.35 1536.47 271.88C1536.38 273.71 1536.78 275.54 1537.6 277.18C1538.33 278.64 1538.9 280.02 1538.9 282.08C1538.9 284.46 1538.38 284.88 1538.02 286.25C1537.83 286.98 1537.68 287.98 1537.68 289.69C1537.68 293.91 1538.87 299.02 1540.64 303.81C1541.2 305.32 1541.81 306.79 1542.46 308.2",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1554.67 313.05L1572.95 299L1552.86 302.52L1537.93 314",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1526.41 256.42C1527.18 257.63 1527.92 258.92 1528.61 260.28C1532.42 267.72 1534.88 277.07 1535 284.21C1535.09 289.26 1535.13 293.12 1535.15 295.65C1535.16 296.99 1535.5 298.28 1536.13 299.43C1536.59 300.27 1537.2 301.03 1537.94 301.66C1538.77 302.36 1539.7 303.13 1540.63 303.83",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1530.31 305.9C1529.84 309.48 1529.68 311.94 1529.63 313.47C1529.58 314.87 1529.63 315.5 1529.63 315.5C1529.63 315.5 1524.79 315.01 1519.37 313.7C1518.82 313.57 1518.27 313.43 1517.72 313.28C1516.84 313.04 1515.94 312.87 1515.05 312.74C1512.75 312.41 1510.6 311.98 1508.73 311.44C1506.21 310.73 1504.19 308.96 1503.08 306.69C1502.54 305.59 1502.2 304.37 1502.13 303.09C1501.48 291.51 1501.84 282.64 1502.8 271.45C1503.21 266.74 1505.79 262.48 1509.78 259.95C1511.85 258.64 1513.96 257.44 1516.07 256.42C1516.24 256.34 1516.41 256.25 1516.56 256.15C1517.56 255.52 1518.31 254.55 1518.66 253.4C1518.87 252.7 1519.38 250.99 1519.43 250.81C1520.06 248.74 1521.16 246.83 1522.79 245.4C1525.48 243.03 1526.89 238.44 1532.01 238.44C1532.81 238.44 1533.52 238.51 1534.21 238.71C1535.41 240.55 1535.56 242.89 1535.06 246.1C1534.98 246.61 1534.88 247.12 1534.75 247.61C1534.19 249.84 1533.24 251.81 1531.98 253.11C1530.99 254.13 1529.8 254.75 1528.47 254.74C1527.47 254.74 1526.64 255.47 1526.43 256.43",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1538.02 286.26C1540.54 290.89 1545.02 296.31 1548.65 300.35C1549.72 301.54 1550.71 302.61 1551.56 303.51",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1543.46 308.04C1544.62 304.67 1546.2 302.17 1548.64 300.35",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542.97 329.96L1547.6 333.64C1549.61 335.24 1550.2 338.03 1549 340.3C1547.59 342.95 1545.72 346.86 1544.02 351.61C1540.76 360.73 1542.55 369.84 1538.97 382.53",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1558.21 326.54L1560.52 328.91C1563.67 332.15 1564.76 336.87 1563.36 341.17C1563.22 341.61 1563.07 342.05 1562.93 342.49C1558.19 357.37 1554.91 369.3 1551.74 385.11",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1599.06 385.65C1601.66 385.7 1602.56 382.22 1600.24 381.02C1597.82 379.77 1595.4 378.47 1593.22 377.21C1592.29 376.68 1591.42 376.15 1590.6 375.64C1589.15 374.74 1588.06 373.39 1587.48 371.79C1587.05 370.6 1586.55 369.13 1586.01 367.44C1582.2 355.62 1575.93 333.01 1572.23 319.5C1571.17 315.62 1567.65 312.94 1563.63 312.94C1560.72 312.94 1557.69 312.98 1554.67 313.05C1548.64 313.19 1542.68 313.48 1537.93 314C1536.99 314.1 1536.1 314.22 1535.26 314.34",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1586.02 367.45C1583.24 370.53 1580.11 371.74 1578.19 372.2C1577.06 372.47 1576.35 372.5 1576.35 372.5L1562.94 342.49",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1524.17 304.33C1529.09 303.7 1534.32 301.88 1536.13 299.42",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1515.59 262.49C1523.88 267.72 1527.82 268 1527.82 268C1527.82 268 1528.53 264.45 1528.62 260.27",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.73 247.62C1536.29 247.23 1537.87 246.34 1539.21 245C1542.22 242 1542.94 237.8 1540.96 235.35C1541.49 233.56 1541.17 231.69 1539.92 230.45C1539.4 229.92 1538.77 229.57 1538.08 229.37C1538.21 226.92 1536.98 224.7 1534.88 224C1534.28 223.8 1533.66 223.75 1533.05 223.81C1532.5 222.74 1531.61 221.91 1530.47 221.53C1528.24 220.78 1525.76 221.99 1524.44 224.29C1523.9 223.54 1523.17 222.98 1522.28 222.67C1519.94 221.89 1517.33 223.25 1516.06 225.76C1515.48 225.52 1514.86 225.38 1514.21 225.38C1511.1 225.38 1508.57 228.38 1508.57 232.07C1508.57 232.8 1508.68 233.5 1508.86 234.16C1507.18 234.97 1506.02 236.69 1506.02 238.68C1506.02 240.67 1507.17 242.36 1508.83 243.18C1508.79 243.52 1508.75 243.87 1508.75 244.23C1508.75 248.47 1512.18 251.9 1516.41 251.9C1517.41 251.9 1518.36 251.71 1519.24 251.36",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.35 434.53C1139.98 412.23 1209.79 354.62 1209.79 289.89V316.83C1209.79 379.91 1143.48 436.23 1043.25 459.7",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.35 434.53C1139.98 412.23 1209.79 354.62 1209.79 289.89V316.83C1209.79 379.91 1143.48 436.23 1043.25 459.7",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.34 396.27C1096.04 377.94 1143.81 336.35 1143.81 289.89H1209.79C1209.79 354.61 1139.98 412.22 1035.35 434.53",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.779 425.01L1013.79 365.84L1023.34 396.27",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.34 396.27L1013.79 365.84L942.779 425.01",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.35 434.53C1139.98 412.23 1209.79 354.62 1209.79 289.89H1143.81C1143.81 336.35 1096.04 377.94 1023.34 396.27",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1209.79 289.89V316.83C1209.79 379.91 1143.48 436.23 1043.25 459.7",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.759 122.98V148.51L887.369 203V177.47L952.759 122.98Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.759 122.98L887.369 177.47L878.579 149.45C811.629 166.33 767.649 204.63 767.649 247.41H706.889C706.889 189.36 767.859 137.54 860.049 115.9C862.519 115.32 865.019 114.76 867.539 114.22L858.439 85.21L952.779 122.98H952.759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.368 177.47V203L878.578 174.98C811.628 191.86 767.648 230.16 767.648 272.94V247.41C767.648 204.63 811.638 166.33 878.578 149.45L887.368 177.47Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.418 85.21L867.518 114.22C864.998 114.76 862.498 115.32 860.028 115.9L858.418 110.74V85.21Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.639 247.41H706.879V272.94H767.639V247.41Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.419 85.21L867.519 114.22C864.999 114.76 862.499 115.32 860.029 115.9C767.839 137.56 706.869 189.36 706.869 247.41H767.629C767.629 204.63 811.619 166.33 878.559 149.45L887.349 177.47L952.739 122.98L858.399 85.21H858.419Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.639 247.41V272.94",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.42 85.21V110.74L860.04 115.9",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.369 177.47V203",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.759 122.98V148.51L887.369 203L878.579 174.98C811.629 191.86 767.649 230.16 767.649 272.94H706.889V247.41",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.07 218.37C1107.07 218.52 1107.07 218.66 1107.07 218.8C1087.91 223.66 1066.26 220.43 1050.56 214.5C1048.36 179.22 1049.56 156.04 1051.34 139.98C1051.78 136.04 1053.72 132.43 1056.77 129.88C1057.76 129.05 1058.71 128.24 1059.63 127.46C1064.13 123.56 1067.92 119.97 1071.2 116.59C1084.76 102.62 1089.28 92.1603 1094.49 79.8303C1094.56 79.8703 1094.64 79.9003 1094.71 79.9403C1112.42 88.4803 1127.97 97.3803 1129.9 113.08C1131.82 128.65 1134.72 174.78 1134.39 216.1C1127.26 222.22 1115.36 222.26 1107.65 218.65C1107.46 218.56 1107.27 218.47 1107.08 218.37H1107.07ZM1065.02 194.72C1065.18 194 1064.61 193.25 1063.76 193.07C1062.9 192.89 1062.09 193.34 1061.94 194.09C1061.77 194.81 1062.35 195.56 1063.19 195.74C1064.05 195.92 1064.86 195.47 1065.02 194.72ZM1063.92 168.96C1064.08 168.21 1063.51 167.47 1062.66 167.31C1061.8 167.13 1060.99 167.58 1060.84 168.31C1060.68 169.06 1061.25 169.79 1062.1 169.98C1062.96 170.16 1063.77 169.7 1063.92 168.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.64 218.65C1107.45 218.7 1107.26 218.75 1107.06 218.8C1107.06 218.66 1107.06 218.52 1107.06 218.37C1107.24 218.47 1107.44 218.56 1107.63 218.65H1107.64Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.77 15.4902C1082.65 15.9202 1094.99 18.8902 1094.77 35.4602C1094.7 40.4402 1094.11 44.6802 1093.38 48.9502C1092.08 47.2102 1090.36 46.1602 1088.05 46.1602C1087.38 46.1602 1086.68 46.2002 1085.98 46.2002C1074.58 46.2002 1082.04 32.5103 1071.3 32.5103C1066.99 32.5103 1060.93 34.4702 1056.17 34.4702C1054.91 34.4702 1053.77 34.3402 1052.75 34.0002C1052.31 33.8602 1051.9 33.6702 1051.52 33.4502C1050.26 32.7202 1049.34 31.4902 1048.9 29.5802C1048.91 29.3502 1048.91 29.1102 1048.91 28.8602V28.3703C1048.91 27.5403 1048.94 26.6802 1049.29 25.9902C1056.11 12.0202 1073.15 15.0903 1077.78 15.4803L1077.77 15.4902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.03 78.8203C1093.47 79.2003 1093.95 79.5503 1094.48 79.8203C1089.28 92.1503 1084.75 102.61 1071.19 116.58V82.7202C1077.42 84.5402 1085.1 84.0702 1093.03 78.8102V78.8203Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.38 48.9503C1092.19 55.8603 1090.68 62.8503 1090.57 73.2303C1090.55 75.3903 1091.46 77.4203 1093.04 78.8203C1085.11 84.0803 1077.44 84.5103 1071.2 82.7303C1070.57 82.5503 1069.89 82.3303 1069.28 82.1003C1067.21 81.3103 1065.33 80.2703 1063.71 79.0903C1071.62 74.3403 1078.56 64.3603 1080.49 58.6703C1064.44 63.9103 1056.41 64.1303 1052.04 61.1103C1052.04 60.7003 1051.94 51.8103 1051.86 48.6403C1051.73 43.8303 1051.68 38.7103 1052.75 34.0103C1053.77 34.3403 1054.91 34.4803 1056.17 34.4803C1060.93 34.4803 1066.99 32.5203 1071.3 32.5203C1082.04 32.5203 1074.59 46.2103 1085.98 46.2103C1086.68 46.2103 1087.38 46.1703 1088.05 46.1703C1090.36 46.1703 1092.08 47.2303 1093.38 48.9603V48.9503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.03 61.1003C1056.41 64.1203 1064.43 63.9003 1080.48 58.6603C1078.55 64.3503 1071.61 74.3303 1063.7 79.0803C1060.26 81.1303 1056.61 82.2003 1053.14 81.4903C1053.08 81.4903 1053.03 81.4703 1052.97 81.4503C1046.62 79.9703 1045.64 74.8703 1047.34 69.1303C1048.17 66.3103 1049.65 63.3603 1051.44 60.6803C1051.63 60.8303 1051.83 60.9803 1052.03 61.1003Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.19 82.7302V116.59C1067.9 119.98 1064.11 123.57 1059.62 127.45C1056.6 122.11 1054.72 116.52 1053.59 111.05C1058.97 100.94 1065.98 88.1202 1069.28 82.1002C1069.89 82.3402 1070.56 82.5602 1071.2 82.7302H1071.19Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.76 193.07C1064.61 193.25 1065.18 193.99 1065.02 194.72C1064.86 195.47 1064.05 195.92 1063.19 195.74C1062.36 195.56 1061.77 194.82 1061.94 194.09C1062.09 193.34 1062.9 192.89 1063.76 193.07Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.7 79.0803C1065.32 80.2603 1067.2 81.3103 1069.27 82.0903C1065.97 88.1103 1058.96 100.92 1053.58 111.04C1051.25 99.8303 1052.08 89.0503 1052.96 81.4503C1053.02 81.4603 1053.07 81.4803 1053.13 81.4903C1056.61 82.2103 1060.25 81.1403 1063.69 79.0803H1063.7Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.66 167.31C1063.51 167.47 1064.08 168.22 1063.92 168.96C1063.77 169.7 1062.96 170.16 1062.1 169.98C1061.25 169.8 1060.68 169.06 1060.84 168.31C1060.99 167.58 1061.8 167.13 1062.66 167.31Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033 190.1C1015.37 203.13 982.71 221.38 979.6 223.1C981.67 221.68 983.07 217.98 983.62 213.64C984.57 206.11 982.99 196.54 977.99 193.09C978 193.09 978 193.08 978.02 193.08C980.97 191.26 1004.59 173.92 1015.73 165.73C1019.32 163.09 1021.51 158.97 1021.69 154.5C1022.17 142.1 1023.75 115.64 1028.84 95.4803C1033.12 78.5803 1040.73 71.5903 1047.34 69.1403C1045.63 74.8803 1046.59 80.0703 1052.97 81.4603C1052.09 89.0603 1051.26 99.8403 1053.59 111.05C1054.72 116.53 1056.6 122.12 1059.62 127.45C1058.7 128.25 1057.74 129.06 1056.76 129.89C1053.72 132.44 1051.78 136.05 1051.33 139.99C1049.55 156.05 1048.35 179.22 1050.55 214.51C1042.73 211.56 1036.38 207.93 1032.56 204.3C1032.69 200.21 1032.83 195.39 1033 190.11V190.1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.02 59.8602C1052.02 60.2902 1052.02 60.7002 1052.02 61.1102C1051.82 60.9902 1051.62 60.8402 1051.43 60.6902C1051.62 60.4102 1051.82 60.1402 1052.01 59.8602H1052.02Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.99 193.09C982.99 196.54 984.57 206.11 983.62 213.64C978.92 216.14 961.89 225.09 961.89 225.09C951.75 231.56 942.24 228.06 942.24 221.24C942.24 216.72 947.53 211.48 951.75 208C954.39 205.84 954.54 201.88 952.08 199.51L949.46 197.01C948.58 196.17 949.44 194.73 950.6 195.07C965.31 199.37 974.45 195.26 977.99 193.11V193.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.611 213.63C983.061 217.98 981.621 221.62 979.591 223.09C979.491 223.16 979.411 223.2 979.381 223.22C979.371 223.23 979.351 223.23 979.351 223.23C979.031 223.43 978.701 223.58 978.351 223.66C975.481 224.33 973.111 222.58 971.281 220.15C974.711 218.35 978.911 216.13 983.611 213.63Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.74 34.0103C1051.67 38.7103 1051.72 43.8202 1051.85 48.6402C1051.93 51.8102 1052.03 61.1203 1052.03 61.1203",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.01 134.62C1107.16 155.12 1107.25 190.51 1107.07 218.38C1107.07 218.53 1107.07 218.67 1107.07 218.81",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.06 218.37C1107.24 218.47 1107.44 218.56 1107.63 218.65C1115.34 222.26 1127.24 222.22 1134.37 216.1C1134.7 174.78 1131.8 128.65 1129.88 113.08C1127.95 97.3803 1112.4 88.4803 1094.69 79.9403C1094.62 79.9003 1094.54 79.8703 1094.47 79.8303C1093.95 79.5503 1093.46 79.2103 1093.02 78.8303C1091.44 77.4403 1090.53 75.4003 1090.55 73.2403C1090.66 62.8603 1092.18 55.8703 1093.36 48.9603C1094.09 44.6903 1094.68 40.4503 1094.75 35.4703C1094.97 18.9003 1082.63 15.9303 1077.75 15.5003C1073.12 15.1003 1056.08 12.0403 1049.26 26.0103C1048.91 26.7003 1048.88 27.5503 1048.88 28.3903V28.8803C1048.88 29.1303 1048.88 29.3703 1048.87 29.6003C1049.31 31.5003 1050.23 32.7403 1051.49 33.4703C1051.87 33.6903 1052.29 33.8803 1052.72 34.0203C1053.74 34.3503 1054.88 34.4903 1056.14 34.4903C1060.9 34.4903 1066.96 32.5303 1071.27 32.5303C1082.01 32.5303 1074.56 46.2203 1085.95 46.2203C1086.65 46.2203 1087.35 46.1803 1088.02 46.1803C1090.33 46.1803 1092.05 47.2403 1093.35 48.9703",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.44 60.6803C1051.63 60.8303 1051.83 60.9803 1052.03 61.1003C1056.41 64.1203 1064.43 63.9003 1080.48 58.6603C1078.55 64.3503 1071.62 74.3403 1063.7 79.0803C1060.26 81.1403 1056.61 82.2003 1053.14 81.4903C1053.08 81.4903 1053.03 81.4703 1052.97 81.4503C1046.62 79.9703 1045.65 74.8703 1047.34 69.1303C1048.17 66.3103 1049.63 63.3503 1051.44 60.6803ZM1051.44 60.6803C1051.63 60.4003 1051.83 60.1303 1052.02 59.8503",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.34 69.1302C1040.73 71.5802 1033.12 78.5702 1028.84 95.4702C1023.75 115.63 1022.17 142.09 1021.69 154.49C1021.51 158.96 1019.32 163.08 1015.73 165.72C1004.59 173.92 980.97 191.26 978.02 193.07C978.01 193.07 978.01 193.08 977.99 193.08C974.45 195.24 965.31 199.34 950.6 195.04C949.43 194.7 948.58 196.14 949.46 196.98L952.08 199.48C954.54 201.85 954.39 205.81 951.75 207.97C947.53 211.45 942.24 216.7 942.24 221.21C942.24 228.03 951.75 231.53 961.89 225.06C961.89 225.06 978.91 216.11 983.62 213.61",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.361 223.24C979.041 223.44 978.711 223.59 978.361 223.67C975.491 224.34 973.121 222.59 971.291 220.16",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.99 193.09C982.99 196.54 984.57 206.11 983.62 213.64C983.07 217.99 981.67 221.68 979.6 223.1",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.359 223.24C979.359 223.24 979.369 223.24 979.389 223.23C979.419 223.22 979.499 223.18 979.599 223.1C982.709 221.38 1015.37 203.13 1033 190.1",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.97 81.4503C1052.09 89.0503 1051.27 99.8303 1053.59 111.04C1054.72 116.52 1056.6 122.11 1059.62 127.44",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.48 79.8303C1089.28 92.1603 1084.74 102.62 1071.19 116.59C1067.9 119.98 1064.11 123.57 1059.62 127.45C1058.7 128.25 1057.74 129.06 1056.76 129.89C1053.72 132.44 1051.78 136.05 1051.33 139.99C1049.55 156.05 1048.35 179.22 1050.55 214.51",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.64 218.65C1107.45 218.7 1107.26 218.75 1107.06 218.8C1087.94 223.8 1066.26 220.43 1050.55 214.5C1042.73 211.55 1036.38 207.92 1032.56 204.29C1032.69 200.2 1032.83 195.38 1033 190.1C1033.9 160.94 1035.4 117.84 1037.53 107.52",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.7 79.0802C1065.32 80.2602 1067.2 81.3003 1069.27 82.0903C1069.88 82.3203 1070.55 82.5402 1071.19 82.7202C1077.43 84.5002 1085.1 84.0702 1093.03 78.8102",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.59 111.04C1058.97 100.93 1065.98 88.1103 1069.28 82.0903",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1071.19 82.7303V116.59",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.92 168.96C1063.77 169.7 1062.96 170.16 1062.1 169.98C1061.25 169.8 1060.68 169.06 1060.84 168.31C1060.99 167.58 1061.8 167.13 1062.66 167.31C1063.51 167.47 1064.08 168.22 1063.92 168.96Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.02 194.72C1064.86 195.47 1064.05 195.92 1063.19 195.74C1062.36 195.56 1061.77 194.82 1061.94 194.09C1062.09 193.34 1062.9 192.89 1063.76 193.07C1064.61 193.25 1065.18 193.99 1065.02 194.72Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.16 235.34L885.59 270.34L970.82 319.54L984.39 284.55L899.16 235.34Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.39 284.55L970.82 319.54L997.97 303.87L984.39 284.55Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.82 319.54L997.97 303.87L984.39 284.55L970.82 319.54Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.39 284.55L899.16 235.34L885.59 270.34L970.82 319.54",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.561 308.4L944.151 255.53",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.621 318.25L961.221 265.38",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.93 298.56L928.86 308.59",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.711 286.83L937.651 296.85",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.5 275.09L946.44 285.12",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.291 263.36L955.231 273.38",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.44 356.14C1109.28 355.46 1108.12 354.78 1106.98 354.09C1101.55 350.81 1096.5 347.28 1093.34 342.55C1093.34 342.55 1095.1 342.19 1097.67 341.98C1101.35 341.66 1106.69 341.64 1110.86 343.39C1111.82 343.79 1112.71 344.29 1113.51 344.9C1120.75 350.42 1123.73 356.88 1126.47 367.59C1122.33 363.02 1116.36 359.61 1110.44 356.15V356.14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.85 343.38C1106.69 341.63 1101.35 341.66 1097.66 341.97C1097.8 339.9 1098.48 337.15 1099.57 334.18C1101.24 334.76 1102.82 335.46 1104.26 336.29C1107.74 338.3 1109.94 340.78 1110.84 343.38H1110.85Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072.86 387.59C1069.61 385.72 1067.69 383.37 1067.09 380.93C1067.09 380.93 1067.08 380.92 1067.08 380.91L1066.96 380.25C1066.96 380.25 1066.96 380.24 1066.96 380.23C1066.96 380.2 1066.96 380.18 1066.95 380.15C1066.95 380.13 1066.94 380.12 1066.94 380.09C1066.94 380.07 1066.94 380.06 1066.93 380.04V380.02C1064.93 369.42 1064.36 359.79 1063.25 347.16C1063.66 350.37 1065.99 353.52 1070.24 355.96C1070.54 356.13 1070.84 356.3 1071.15 356.46C1071.42 362.1 1073.1 369.57 1075.16 376.77C1076.76 369.73 1078.62 364.3 1081.02 359.56C1089.05 360.8 1097.98 359.6 1104.28 355.96C1105.29 355.38 1106.19 354.76 1106.98 354.1C1108.13 354.79 1109.28 355.47 1110.44 356.15C1109.53 365.71 1108.55 374.09 1107.08 382.09",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.33 342.54C1096.49 347.27 1101.55 350.8 1106.97 354.08C1106.18 354.74 1105.28 355.35 1104.27 355.94C1097.97 359.58 1089.04 360.78 1081.01 359.54C1084.07 353.5 1088.04 348.58 1093.52 342.9C1093.45 342.78 1093.38 342.67 1093.31 342.56L1093.34 342.54H1093.33Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.33 342.54L1093.3 342.56C1092.55 341.38 1091.72 340.49 1090.81 339.85C1091.4 340.02 1092 340.16 1092.6 340.27C1092.96 336.02 1092.57 332.31 1091.6 329.04C1095.53 322.96 1101.02 319.49 1109.89 317.41C1105.5 321.57 1101.72 328.32 1099.57 334.19C1098.47 337.16 1097.8 339.91 1097.66 341.98C1095.09 342.2 1093.33 342.55 1093.33 342.55V342.54Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.61 329.04C1092.58 332.31 1092.97 336.02 1092.61 340.27C1092 340.16 1091.41 340.02 1090.82 339.85C1089.75 339.08 1088.6 338.67 1087.41 338.53C1084.15 336.94 1081.19 334.52 1078.49 331.65C1069.76 322.39 1063.68 308.46 1058.77 302.81C1070.87 308.42 1087.22 314.15 1091.62 329.03L1091.61 329.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.82 339.85C1089.65 339.51 1088.51 339.07 1087.41 338.53C1088.6 338.67 1089.76 339.08 1090.82 339.85Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.82 339.85C1091.72 340.49 1092.56 341.38 1093.31 342.56C1093.38 342.67 1093.45 342.79 1093.52 342.9C1088.04 348.58 1084.08 353.5 1081.01 359.54C1078.61 364.28 1076.75 369.71 1075.15 376.75C1073.09 369.55 1071.41 362.08 1071.14 356.44C1071.02 353.89 1071.18 351.71 1071.73 350.1C1072.29 348.46 1073.47 346.58 1075.03 344.82C1078.26 341.18 1083.1 338.04 1087.4 338.53C1088.5 339.07 1089.64 339.51 1090.81 339.85H1090.82Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.41 338.53C1083.1 338.04 1078.26 341.17 1075.04 344.82C1073.05 345.35 1070.94 345.73 1068.77 345.82C1066.9 345.9 1065.04 345.64 1063.23 345.15C1055.52 343.1 1049.03 337.09 1049.03 337.09C1055.27 337.85 1068.64 329.79 1078.49 331.66C1081.19 334.53 1084.15 336.95 1087.41 338.54V338.53Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.22 355.94C1065.97 353.5 1063.65 350.35 1063.23 347.14C1063.15 346.47 1063.14 345.8 1063.23 345.14C1065.03 345.63 1066.9 345.89 1068.77 345.81C1070.93 345.72 1073.05 345.35 1075.04 344.81C1073.48 346.57 1072.3 348.45 1071.74 350.09C1071.19 351.7 1071.02 353.88 1071.15 356.43C1070.84 356.27 1070.54 356.1 1070.24 355.93L1070.22 355.94Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.85 343.38C1109.95 340.78 1107.75 338.3 1104.27 336.29C1102.83 335.46 1101.25 334.76 1099.58 334.18",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.23 345.15C1063.15 345.81 1063.15 346.49 1063.23 347.15C1063.64 350.36 1065.97 353.51 1070.22 355.95C1070.52 356.12 1070.82 356.29 1071.13 356.45",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.01 359.54C1089.04 360.78 1097.97 359.58 1104.27 355.94C1105.28 355.36 1106.18 354.74 1106.97 354.08",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.07 382.08C1108.54 374.08 1109.52 365.7 1110.43 356.14",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.24 347.15C1064.35 359.78 1064.92 369.41 1066.92 380.01",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.33 342.54C1096.49 347.27 1101.54 350.81 1106.97 354.08C1108.11 354.77 1109.27 355.45 1110.43 356.13C1116.34 359.59 1122.32 363 1126.46 367.57C1123.71 356.86 1120.74 350.4 1113.5 344.88C1112.7 344.27 1111.81 343.77 1110.85 343.37C1106.69 341.62 1101.35 341.65 1097.66 341.96C1095.09 342.18 1093.33 342.53 1093.33 342.53V342.54Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.3 342.56C1093.37 342.67 1093.44 342.79 1093.51 342.9C1088.03 348.58 1084.07 353.5 1081 359.54C1078.6 364.28 1076.74 369.71 1075.14 376.75C1073.08 369.55 1071.4 362.08 1071.13 356.44C1071.01 353.89 1071.17 351.71 1071.72 350.1C1072.28 348.46 1073.46 346.58 1075.02 344.82C1078.25 341.18 1083.09 338.03 1087.39 338.53C1088.58 338.67 1089.73 339.09 1090.8 339.85C1091.7 340.49 1092.54 341.38 1093.29 342.56H1093.3Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.66 342.07C1097.66 342.07 1097.66 342 1097.66 341.97C1097.84 339.9 1098.48 337.15 1099.57 334.18C1101.73 328.31 1105.5 321.57 1109.89 317.4C1101.02 319.49 1095.53 322.95 1091.6 329.03",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.82 339.85C1091.41 340.02 1092.01 340.16 1092.61 340.27C1092.97 336.02 1092.58 332.31 1091.61 329.04C1087.2 314.16 1070.87 308.43 1058.76 302.82C1063.67 308.47 1069.75 322.4 1078.48 331.66C1081.18 334.53 1084.15 336.94 1087.4 338.54C1088.5 339.08 1089.64 339.52 1090.81 339.86L1090.82 339.85Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.49 331.66C1068.65 329.79 1055.28 337.85 1049.03 337.09C1049.03 337.09 1055.53 343.08 1063.23 345.15C1065.03 345.64 1066.9 345.9 1068.77 345.82C1070.93 345.73 1073.05 345.36 1075.04 344.82",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.071 -89.5301L159.501 -17.9401L-0.0488281 74.1699L28.1712 22.6799L39.0312 25.9599L84.9712 -42.0201L104.871 -38.3701L137.071 -89.5301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.971 -42.0201L39.031 25.9599L28.171 22.6799L18.291 16.9799L29.141 20.2599L75.091 -47.7201L84.971 -42.0201Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1703 22.6799L-0.0496902 74.1699L-9.92969 68.4599L18.2903 16.9799L28.1703 22.6799Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0488281 74.1699L159.501 -17.9401L137.071 -89.5301L104.871 -38.3701L84.9712 -42.0201L39.0312 25.9599L28.1712 22.6799L-0.0488281 74.1699Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.07 -89.5301L127.19 -95.2301L94.9903 -44.0801L75.0903 -47.7201L29.1403 20.2599L18.2903 16.9799L-9.92969 68.4599L-0.0496902 74.1699",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.291 16.9799L28.171 22.6799",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0305 15.6399C99.0305 15.6399 103.08 19.6899 103.08 24.6899C103.08 29.6899 99.0305 33.7399 94.0305 33.7399C89.0305 33.7399 84.9805 29.6899 84.9805 24.6899C84.9805 19.6899 89.0305 15.6399 94.0305 15.6399Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.08 24.6899C103.08 19.6899 99.0305 15.6399 94.0305 15.6399C89.0305 15.6399 84.9805 19.6899 84.9805 24.6899C84.9805 29.6899 89.0305 33.7399 94.0305 33.7399C99.0305 33.7399 103.08 29.6899 103.08 24.6899Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.1 163.4C245.1 177.74 251.08 190.7 260.68 199.9C266.9 205.85 272 212.92 275.16 220.87L275.45 220.76C276.47 222.48 278.18 224.11 280.56 225.48C288.92 230.31 302.48 230.31 310.84 225.48C313.22 224.11 314.92 222.5 315.94 220.78L316.13 220.86C319.29 212.91 324.39 205.85 330.61 199.9C340.21 190.7 346.19 177.74 346.19 163.4C346.19 135.48 323.56 112.85 295.64 112.84C267.72 112.84 245.09 135.48 245.09 163.4H245.1Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.43 232.55C279 235.77 279.33 239.05 279.41 242.37C279.41 244.25 280.61 246.1 282.99 247.65C283.35 247.88 283.74 248.11 284.16 248.33C285.74 249.15 287.58 249.76 289.53 250.18C291.48 250.59 293.56 250.8 295.65 250.8C299.81 250.8 303.96 249.98 307.13 248.34C307.7 248.04 308.22 247.73 308.69 247.4C310.83 245.92 311.89 244.16 311.89 242.38C311.97 239.06 312.3 235.78 312.87 232.56C312 234.02 310.55 235.4 308.53 236.57C301.42 240.67 289.89 240.67 282.78 236.57C280.76 235.4 279.31 234.03 278.44 232.57L278.43 232.55Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.17 248.32C283.75 248.1 283.36 247.88 283 247.64C283.32 254.46 288.95 259.89 295.85 259.89C302.75 259.89 308.52 254.32 308.7 247.38C308.23 247.71 307.71 248.02 307.14 248.32C303.97 249.96 299.82 250.78 295.66 250.78C293.58 250.78 291.5 250.57 289.54 250.16C287.59 249.75 285.75 249.14 284.17 248.31V248.32Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.57 225.48C278.19 224.11 276.48 222.48 275.46 220.76L275.17 220.87C275.58 221.86 275.94 222.87 276.27 223.9C277.08 226.41 277.74 228.96 278.24 231.56H278.25C278.32 231.89 278.38 232.22 278.43 232.55C279.3 234.01 280.75 235.38 282.77 236.55C289.89 240.65 301.41 240.65 308.52 236.55C310.55 235.38 311.99 234.01 312.86 232.54C312.91 232.21 312.98 231.88 313.04 231.55H313.05C313.55 228.95 314.21 226.39 315.02 223.89C315.35 222.86 315.72 221.84 316.13 220.85L315.94 220.77C314.92 222.49 313.22 224.1 310.84 225.47C302.48 230.3 288.92 230.3 280.56 225.47L280.57 225.48Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.169 220.87C271.969 212.93 266.909 205.85 260.689 199.9C251.089 190.7 245.109 177.74 245.109 163.4C245.109 135.48 267.739 112.85 295.659 112.84C323.579 112.84 346.209 135.48 346.209 163.4C346.209 177.74 340.229 190.7 330.629 199.9C324.419 205.85 319.339 212.92 316.149 220.86C315.749 221.86 315.379 222.88 315.039 223.9C314.229 226.41 313.569 228.96 313.069 231.56H313.059C312.999 231.89 312.939 232.21 312.879 232.55C312.329 235.78 311.979 239.06 311.899 242.37C311.899 244.14 310.839 245.91 308.699 247.39C308.229 247.72 307.709 248.03 307.139 248.33C303.969 249.97 299.819 250.79 295.659 250.79C293.579 250.79 291.499 250.58 289.539 250.17C287.589 249.76 285.749 249.15 284.169 248.32C283.749 248.1 283.359 247.88 282.999 247.64C280.619 246.09 279.419 244.24 279.419 242.36C279.339 239.04 278.989 235.77 278.439 232.54C278.379 232.21 278.329 231.88 278.259 231.55H278.249C277.749 228.95 277.089 226.39 276.279 223.89C275.949 222.87 275.579 221.86 275.179 220.86L275.169 220.87Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.04 152.5C312.63 154.47 312.63 161.43 309.21 163.4C305.8 165.38 305.8 158.41 302.39 160.37C298.98 162.34 298.98 169.31 295.57 171.28C292.15 173.25 292.15 166.29 288.74 168.25C285.33 170.22 285.33 177.19 281.91 179.15",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.42 232.53C278.42 232.53 278.42 232.54 278.43 232.55C279.3 234.01 280.75 235.38 282.77 236.55C289.89 240.65 301.41 240.65 308.52 236.55C310.55 235.38 311.99 234.01 312.86 232.54",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.459 220.76C276.479 222.48 278.189 224.11 280.569 225.48C288.929 230.31 302.489 230.31 310.849 225.48C313.229 224.11 314.929 222.5 315.949 220.78",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 247.65C283.32 254.47 288.95 259.9 295.85 259.9C302.75 259.9 308.52 254.33 308.7 247.39",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.57 307.63C409.57 309.9 408.78 311.49 407.49 312.23L352.74 343.84C354.03 343.1 354.82 341.5 354.82 339.24C354.82 337.01 354.05 334.54 352.8 332.34C351.51 330.07 349.71 328.08 347.71 326.93C345.75 325.8 343.97 325.69 342.68 326.44L397.43 294.83C398.72 294.09 400.49 294.19 402.46 295.33C404.45 296.48 406.26 298.47 407.55 300.74C408.8 302.94 409.57 305.41 409.57 307.64V307.63Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.82 339.24C354.82 341.51 354.03 343.1 352.74 343.84C351.45 344.58 349.68 344.47 347.71 343.34C345.75 342.21 343.97 340.26 342.68 338.03C341.39 335.8 340.6 333.29 340.6 331.02C340.6 328.75 341.4 327.16 342.68 326.42C343.97 325.67 345.74 325.78 347.71 326.91C349.7 328.06 351.51 330.05 352.8 332.32C354.05 334.52 354.82 336.99 354.82 339.22V339.24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.68 326.43C343.97 325.69 345.74 325.79 347.71 326.92C349.7 328.07 351.51 330.06 352.8 332.33C354.05 334.53 354.82 337 354.82 339.23C354.82 341.5 354.03 343.09 352.74 343.83C351.45 344.57 349.68 344.46 347.71 343.33C345.75 342.2 343.97 340.25 342.68 338.02C341.39 335.79 340.6 333.28 340.6 331.01C340.6 328.74 341.4 327.15 342.68 326.41V326.43Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.68 326.43L397.43 294.82C398.72 294.08 400.49 294.18 402.46 295.32C404.45 296.47 406.26 298.46 407.55 300.73C408.8 302.93 409.57 305.4 409.57 307.63C409.57 309.9 408.78 311.49 407.49 312.23L352.74 343.84",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.13 -16.5898L1448.14 11.7702L1434.28 19.7702L1423.28 -8.58984L1437.13 -16.5898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.28 -8.58984L1434.28 19.7702L1412.28 7.06015L1423.28 -8.58984Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1434.28 19.7702L1412.28 7.06015L1423.28 -8.58984L1434.28 19.7702Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.28 -8.58984L1437.13 -16.5898L1448.14 11.7702L1434.28 19.7702",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1031.8 245.84L1020.8 274.2L1034.65 282.2L1045.65 253.84L1031.8 245.84Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.65 253.84L1034.65 282.2L1056.65 269.5L1045.65 253.84Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.65 282.2L1056.65 269.5L1045.65 253.84L1034.65 282.2Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.65 253.84L1031.8 245.84L1020.8 274.2L1034.65 282.2",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.9 97.8301L497.9 126.19L511.75 134.18L522.75 105.83L508.9 97.8301Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.75 105.83L511.75 134.18L533.75 121.48L522.75 105.83Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.75 134.18L533.75 121.48L522.75 105.83L511.75 134.18Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.75 105.83L508.9 97.8301L497.9 126.19L511.75 134.18",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1402.27 33.2602V55.7002L1375.72 40.3702V29.9502",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389 48.0402V31.6002",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.89 202.13C386.8 202.13 389.96 205.3 389.96 209.2C389.96 213.1 386.79 216.27 382.89 216.27C378.99 216.27 375.82 213.1 375.82 209.2C375.82 205.3 378.99 202.13 382.89 202.13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.97 209.21C389.97 205.3 386.8 202.14 382.9 202.14C379 202.14 375.83 205.31 375.83 209.21C375.83 213.11 379 216.28 382.9 216.28C386.8 216.28 389.97 213.11 389.97 209.21Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.541 128.11C1000.45 128.11 1003.61 131.28 1003.61 135.18C1003.61 139.08 1000.44 142.25 996.541 142.25C992.641 142.25 989.471 139.08 989.471 135.18C989.471 131.28 992.641 128.11 996.541 128.11Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.62 135.18C1003.62 131.27 1000.45 128.11 996.551 128.11C992.651 128.11 989.48 131.28 989.48 135.18C989.48 139.08 992.651 142.25 996.551 142.25C1000.45 142.25 1003.62 139.08 1003.62 135.18Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1871.79 343.72C1875.7 343.72 1878.86 346.89 1878.86 350.79C1878.86 354.69 1875.69 357.86 1871.79 357.86C1867.89 357.86 1864.72 354.69 1864.72 350.79C1864.72 346.89 1867.89 343.72 1871.79 343.72Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1878.87 350.79C1878.87 346.88 1875.7 343.72 1871.8 343.72C1867.9 343.72 1864.73 346.89 1864.73 350.79C1864.73 354.69 1867.9 357.86 1871.8 357.86C1875.7 357.86 1878.87 354.69 1878.87 350.79Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.84 57.2402C570.75 57.2402 573.909 60.4102 573.909 64.3102C573.909 68.2102 570.74 71.3802 566.84 71.3802C562.94 71.3802 559.77 68.2102 559.77 64.3102C559.77 60.4102 562.94 57.2402 566.84 57.2402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.919 64.3102C573.919 60.4002 570.749 57.2402 566.849 57.2402C562.949 57.2402 559.779 60.4102 559.779 64.3102C559.779 68.2102 562.949 71.3802 566.849 71.3802C570.749 71.3802 573.919 68.2102 573.919 64.3102Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464.26 260.87C1468.17 260.87 1471.33 264.04 1471.33 267.94C1471.33 271.84 1468.16 275.01 1464.26 275.01C1460.36 275.01 1457.19 271.84 1457.19 267.94C1457.19 264.04 1460.36 260.87 1464.26 260.87Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1471.33 267.95C1471.33 264.04 1468.16 260.88 1464.26 260.88C1460.36 260.88 1457.19 264.05 1457.19 267.95C1457.19 271.85 1460.36 275.02 1464.26 275.02C1468.16 275.02 1471.33 271.85 1471.33 267.95Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.21 32.1899C1650.12 32.1899 1653.28 35.3599 1653.28 39.2599C1653.28 43.1599 1650.11 46.3299 1646.21 46.3299C1642.31 46.3299 1639.14 43.1599 1639.14 39.2599C1639.14 35.3599 1642.31 32.1899 1646.21 32.1899Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1653.28 39.2599C1653.28 35.3499 1650.11 32.1899 1646.21 32.1899C1642.31 32.1899 1639.14 35.3599 1639.14 39.2599C1639.14 43.1599 1642.31 46.3299 1646.21 46.3299C1650.11 46.3299 1653.28 43.1599 1653.28 39.2599Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2905 97.5899C18.3905 88.4099 14.4705 115.58 2.48047 119.22L66.1005 155.94C54.1205 138.46 50.2005 106.76 34.2905 97.5799V97.5899Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1005 155.95L2.48047 119.23C14.4605 115.58 18.3905 88.4099 34.2905 97.5999C50.2005 106.78 54.1105 138.48 66.1005 155.96V155.95Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.7793 128.61C-1.7993 124.96 2.1207 97.7899 18.0307 106.98C33.9307 116.16 37.8607 147.86 49.8407 165.34",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.8 3.59985C324.9 10.8498 329.49 17.7598 336.87 23.5098L299.78 44.9198C270.62 32.4598 224.23 33.7798 196.35 44.4598L209.2 51.8798L168.67 54.2798L172.82 30.8798L184.47 37.6098C201.17 28.6998 221.91 23.0498 243.38 20.5998C252.57 19.5598 261.88 19.0898 271.07 19.2198L213.31 -18.3802L201.09 -11.3202L196.94 -34.7202L237.47 -32.3202L225.25 -25.2602L292.46 9.15984C291.07 -5.73016 297.72 -21.3802 312.53 -34.4102C315.97 -37.4402 319.85 -40.3302 324.18 -43.0302L312.53 -49.7602L353.06 -52.1602L348.91 -28.7602L336.06 -36.1802C323.88 -25.5802 318.73 -10.3502 322.79 3.61985L322.8 3.59985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.869 23.5198V42.9298L299.779 64.3398V44.9298L336.869 23.5198Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.07 -36.2002V-16.7902C329.47 -11.0402 324.92 -3.93019 322.8 3.59981C318.73 -10.3702 323.89 -25.6002 336.07 -36.2002Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.78 44.9298V64.3398C274.75 53.6398 237.02 53.0998 209.2 59.9198V51.8898L196.35 44.4698C224.23 33.7798 270.62 32.4698 299.78 44.9298Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.32 -18.3802L271.08 19.2198C261.89 19.0898 252.57 19.5598 243.39 20.5998L213.33 1.02981V-18.3802H213.32Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.319 -18.3802V1.02981L201.109 8.07981V-11.3302L213.319 -18.3802Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.21 59.9198V71.2998L168.67 73.6998V54.2898L209.21 51.8898V59.9198Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.109 -11.3302V8.07983L196.959 -15.3202V-34.7302L201.109 -11.3302Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.079 -52.1802L312.549 -49.7802L324.199 -43.0502C319.879 -40.3502 315.989 -37.4602 312.549 -34.4302C297.739 -21.4002 291.089 -5.7502 292.479 9.1398L225.269 -25.2802L237.489 -32.3402L196.959 -34.7402L201.109 -11.3402L213.329 -18.4002L271.089 19.1998C261.899 19.0698 252.579 19.5298 243.399 20.5798C221.929 23.0198 201.189 28.6898 184.489 37.5898L172.839 30.8598L168.689 54.2598L209.219 51.8598L196.369 44.4398C224.249 33.7498 270.639 32.4398 299.799 44.8998L336.889 23.4898C329.519 17.7398 324.929 10.8198 322.819 3.5798C318.759 -10.3902 323.909 -25.6202 336.089 -36.2202L348.939 -28.8002L353.089 -52.2002L353.079 -52.1802Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.081 -52.1802V-32.7702L348.931 -9.37018L336.081 -16.7902C329.481 -11.0402 324.931 -3.93018 322.811 3.59982",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.959 -34.7302V-15.3202L201.109 8.07977L213.319 1.02977L243.389 20.5998",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.109 -11.3302V8.0798",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.32 -18.3802V1.02981",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.209 59.9198C237.029 53.1098 274.749 53.6498 299.789 64.3398L336.879 42.9298V23.5198",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.21 51.8898V71.2998L168.67 73.6998V54.2898",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.779 44.9298V64.3398",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8105 343.64H173.041",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.43 365.93V327",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.83 259.37C137.83 259.87 137.48 260.37 136.82 260.76C135.47 261.54 133.28 261.54 131.93 260.76C131.25 260.37 130.92 259.86 130.92 259.35C130.92 258.84 131.26 258.33 131.93 257.94C133.28 257.16 135.47 257.16 136.82 257.94C137.51 258.34 137.84 258.86 137.83 259.38V259.37Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.83 259.37V335.27C137.83 335.78 137.49 336.29 136.82 336.68C135.47 337.46 133.28 337.46 131.93 336.68C131.25 336.29 130.92 335.78 130.92 335.27V259.34C130.92 259.85 131.26 260.36 131.93 260.75C133.28 261.53 135.47 261.53 136.82 260.75C137.48 260.37 137.82 259.86 137.83 259.36V259.37Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.83 259.37C137.82 259.87 137.48 260.37 136.82 260.76C135.47 261.54 133.28 261.54 131.93 260.76C131.25 260.37 130.92 259.86 130.92 259.35C130.92 258.84 131.26 258.33 131.93 257.94C133.28 257.16 135.47 257.16 136.82 257.94C137.51 258.34 137.84 258.86 137.83 259.38V259.37Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.83 259.34V335.27C137.83 335.78 137.49 336.29 136.82 336.68C135.47 337.46 133.28 337.46 131.93 336.68C131.25 336.29 130.92 335.78 130.92 335.27V259.34",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.84 140.98V273.23L97.6504 318.37V186.12L175.84 140.98Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.84 273.23L97.6504 318.37V186.12L175.84 140.98V273.23Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.2 202.35C157.2 207.04 156.31 211.96 154.75 216.72L136.74 214.16V186.88C148.03 180.36 157.19 187.28 157.19 202.35H157.2Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.751 214.16L154.761 216.72C151.301 227.25 144.531 236.95 136.751 241.44C125.451 247.96 116.291 241.04 116.291 225.97C116.291 210.9 125.451 193.4 136.751 186.88V214.16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.751 216.72C156.311 211.97 157.201 207.04 157.201 202.35C157.201 187.28 148.041 180.36 136.751 186.88C125.451 193.4 116.291 210.91 116.291 225.97C116.291 241.03 125.451 247.96 136.751 241.44C144.531 236.95 151.301 227.25 154.761 216.72H154.751Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.752 186.88V214.16L154.752 216.72",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.051 261.42L148.441 247.92",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.051 269.93L148.441 256.43",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.82 276.26L144.67 267.11",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.279 257.58C112.829 257.83 112.849 258.6 112.319 258.87L107.389 261.41C106.889 261.67 106.309 261.76 105.749 261.67L95.7392 260.14C93.6791 259.83 91.5791 260.09 89.6591 260.9C81.6491 264.25 75.5291 266.01 66.3991 267.67C63.6591 268.17 60.8692 266.98 59.3192 264.66C57.2792 261.6 55.5491 258.8 53.8691 255.92L65.0692 249.43C65.7092 251.01 66.2291 252.23 66.5491 252.97C66.7591 253.44 67.2192 253.73 67.7392 253.73H92.5891C93.5991 253.73 94.5992 253.57 95.5692 253.31L102.609 251.45C105.329 254.36 108.309 255.81 112.279 257.59V257.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9499 252.55C51.1899 263.31 49.5999 274.41 50.1399 286.09H50.1099C44.3399 293.81 28.0899 299.05 19.8899 298.16C13.8899 297.51 10.8499 295.68 8.35992 293.57C8.35992 293.41 8.35992 293.25 8.35992 293.08C8.80993 293.04 9.25992 292.87 9.66992 292.59C11.1299 291.57 12.3599 290.6 13.5999 289.48C14.6399 288.53 14.7899 286.93 13.8899 285.84C11.8699 283.36 9.81993 281 7.78992 278.71L8.00993 278.51C7.57993 269.9 6.56992 261 4.94992 251.88C1.94992 254.96 -1.80007 259.01 -4.60007 262.75C-7.82008 258.22 -11.1501 255.48 -15.3301 253.74C-4.65008 237.43 6.81992 227.83 23.1999 222.25C23.1899 222.73 23.1699 223.21 23.1599 223.69C25.7599 226.78 30.8999 227.68 34.9399 224.4C34.8099 222.21 34.7299 220.25 34.7399 218.09C36.2399 218.16 37.9999 217.95 39.3299 216.91C44.6399 215.98 53.7799 214.03 56.6499 225.11C58.8399 233.6 62.7899 243.78 65.0899 249.43L53.8899 255.92C53.2499 254.82 52.6099 253.71 51.9699 252.56L51.9499 252.55Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9894 392.31C9.36937 369.97 10.4994 331 8.35938 293.57C10.8394 295.68 13.8794 297.51 19.8894 298.16C28.0894 299.05 44.3394 293.81 50.1094 286.09H50.1394C50.1494 286.44 50.1694 286.78 50.1894 287.13C50.1894 287.13 51.1194 313.57 51.0494 328.75C50.9694 343.92 48.2094 367.57 53.1094 380.44C52.8794 380.68 52.6194 380.91 52.3394 381.12C49.7494 383.14 45.2094 384.23 40.3994 383.72",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9894 392.31C9.36937 369.97 10.4994 331 8.35938 293.57C10.8394 295.68 13.8794 297.51 19.8894 298.16C28.0894 299.05 44.3394 293.81 50.1094 286.09H50.1394C50.1494 286.44 50.1694 286.78 50.1894 287.13C50.1894 287.13 51.1194 313.57 51.0494 328.75C50.9694 343.92 48.2094 367.57 53.1094 380.44C52.8794 380.68 52.6194 380.91 52.3394 381.12C49.7494 383.14 45.2094 384.23 40.3994 383.72",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7209 383.27C35.9509 374.77 37.5709 341.35 36.0209 330.9C35.3909 326.69 33.4508 319.38 31.7908 313.49C26.4708 341.79 25.8609 361.18 25.9109 391.95",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7209 383.27C35.9509 374.77 37.5709 341.35 36.0209 330.9C35.3909 326.69 33.4508 319.38 31.7908 313.49C26.4708 341.79 25.8609 361.18 25.9109 391.95",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3895 190.95C45.1895 195.64 44.0895 198.56 40.6795 200.76C38.9195 201.9 36.5395 202.85 33.4895 203.76C32.3195 204.11 31.3995 205 31.0395 206.17L31.0095 206.26C30.6095 207.58 29.4795 208.56 28.0995 208.77H28.0295C27.0695 208.93 26.2095 209.46 25.6395 210.25L23.2795 213.54C23.2595 210.34 23.1695 207.3 23.0095 204.27C22.7595 199.72 26.0395 195.74 30.5495 195.1C35.8295 194.35 39.7295 193.25 44.3895 190.96V190.95Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7109 218.1C34.7009 220.26 34.7809 222.21 34.9109 224.41C30.8709 227.69 25.7309 226.79 23.1309 223.7C23.1409 223.21 23.1609 222.74 23.1709 222.26C23.2509 219.2 23.3009 216.31 23.2809 213.54L25.6409 210.25C26.2109 209.46 27.0709 208.93 28.0309 208.79H28.1009C29.4709 208.57 30.6008 207.59 31.0108 206.27L31.0408 206.18C31.3908 205.01 32.3109 204.12 33.4909 203.77C36.5409 202.86 38.9208 201.91 40.6808 200.77C40.9808 203.05 41.3008 206.57 41.3708 211.4C41.4109 214.25 40.5409 215.94 39.3009 216.91C37.9709 217.96 36.2109 218.16 34.7109 218.09V218.1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8798 285.85C14.7798 286.94 14.6298 288.54 13.5898 289.49C12.3498 290.61 11.1198 291.58 9.65976 292.6C9.25976 292.88 8.80976 293.04 8.34976 293.09C7.15976 293.21 5.93976 292.58 5.43976 291.37C4.62976 289.48 3.63976 287.57 2.57976 285.66C1.86976 284.38 0.719759 283.4 -0.640242 282.86C-7.76024 280.05 -13.2502 276.82 -18.5102 272.15C-21.4602 269.53 -22.2202 265.21 -20.2602 261.78C-18.6302 258.94 -17.0102 256.26 -15.3602 253.75C-11.1702 255.49 -7.84024 258.23 -4.63024 262.76C-4.89024 263.1 -5.13025 263.43 -5.37025 263.77C-1.50025 268.56 3.07975 273.43 7.76975 278.72C9.79976 281.01 11.8498 283.37 13.8698 285.85H13.8798Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00063 278.52L7.78062 278.72C3.09062 273.43 -1.48938 268.55 -5.35938 263.77C-5.11938 263.44 -4.86938 263.1 -4.61938 262.76C-1.80938 259.03 1.93063 254.97 4.93063 251.89C6.56063 261.02 7.57062 269.91 7.99062 278.52H8.00063Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7191 383.27C35.9491 374.77 37.5691 341.35 36.0191 330.9C35.3891 326.69 33.4491 319.38 31.7891 313.49",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8701 233.97C52.5701 240.09 52.4102 246.26 51.9602 252.55C51.1902 263.31 49.6701 274.41 50.1501 286.09C50.1601 286.44 50.1801 286.78 50.2001 287.13C50.2001 287.13 51.1302 313.57 51.0602 328.75C50.9802 343.92 48.2201 367.57 53.1201 380.44C52.8901 380.68 52.6302 380.91 52.3502 381.12C49.7602 383.14 45.2202 384.23 40.4102 383.72",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1795 222.25C6.79951 227.83 -4.67048 237.43 -15.3505 253.74C-17.0005 256.26 -18.6205 258.93 -20.2505 261.77C-22.2105 265.2 -21.4505 269.53 -18.5005 272.14C-13.2505 276.81 -7.75048 280.04 -0.630476 282.85C0.729524 283.39 1.86952 284.37 2.58952 285.65C3.65952 287.56 4.64952 289.47 5.44952 291.36C5.94952 292.56 7.16952 293.2 8.35952 293.08C8.80952 293.03 9.25952 292.87 9.66952 292.59C11.1295 291.57 12.3595 290.6 13.5995 289.48C14.6395 288.53 14.7895 286.93 13.8895 285.84C11.8695 283.36 9.81952 281 7.78952 278.71C3.09952 273.42 -1.48048 268.54 -5.35048 263.76C-5.11048 263.43 -4.86048 263.09 -4.61048 262.75C-1.80048 259.02 1.93952 254.96 4.93952 251.88C6.56952 261.01 7.57952 269.9 7.99952 278.51",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8991 391.96C25.8491 361.19 26.4691 341.8 31.7791 313.5C31.7791 313.5 33.4391 305.03 34.4291 300.45",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35938 293.09C8.35938 293.25 8.35938 293.42 8.35938 293.58C10.1694 331.02 9.36937 369.98 11.9894 392.32",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36914 293.58C10.8491 295.69 13.8891 297.52 19.8991 298.17C28.0991 299.06 44.3491 293.82 50.1191 286.1",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7095 218.1C34.6995 220.26 34.7795 222.21 34.9095 224.41C30.8695 227.69 25.7295 226.79 23.1295 223.7C23.1395 223.21 23.1595 222.74 23.1695 222.26C23.2495 219.2 23.2895 216.31 23.2795 213.54C23.2595 210.34 23.1695 207.3 23.0095 204.27C22.7595 199.72 26.0395 195.74 30.5495 195.1C35.8295 194.35 39.7295 193.25 44.3895 190.96C45.1895 195.65 44.0995 198.57 40.6795 200.77C38.9195 201.91 36.5395 202.86 33.4895 203.77C32.3195 204.12 31.3995 205.01 31.0395 206.18L31.0095 206.27C30.6095 207.59 29.4795 208.57 28.0995 208.78H28.0295C27.0695 208.94 26.2095 209.47 25.6395 210.26L23.2795 213.55",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5195 217.54C31.5195 217.54 32.9495 218.02 34.7095 218.1C36.2095 218.17 37.9695 217.96 39.2995 216.92C40.5395 215.95 41.4195 214.26 41.3695 211.41C41.2895 206.57 40.9695 203.06 40.6795 200.78",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3105 216.91C44.6205 215.98 53.7606 214.03 56.6306 225.11C58.8206 233.6 62.7706 243.78 65.0706 249.43C65.7106 251.01 66.2306 252.23 66.5506 252.97C66.7606 253.44 67.2206 253.73 67.7406 253.73H92.5905C93.6005 253.73 94.6006 253.57 95.5706 253.31L102.611 251.45C105.331 254.36 108.311 255.81 112.281 257.59C112.831 257.84 112.851 258.61 112.321 258.88L107.391 261.42C106.891 261.68 106.311 261.77 105.751 261.68L95.7406 260.15C93.6806 259.84 91.5806 260.1 89.6606 260.91C81.6506 264.26 75.5305 266.02 66.4005 267.68C63.6605 268.18 60.8706 266.99 59.3206 264.67C57.2806 261.61 55.5505 258.81 53.8705 255.93C53.2305 254.83 52.5905 253.72 51.9505 252.57",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8691 255.92L65.0692 249.43",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463.57 168.13C1463.55 169.12 1462.89 170.1 1461.58 170.85C1458.93 172.38 1454.63 172.38 1451.98 170.85C1450.65 170.08 1449.99 169.08 1449.99 168.08C1449.99 167.08 1450.65 166.07 1451.98 165.31C1454.63 163.78 1458.93 163.78 1461.58 165.31C1462.93 166.09 1463.59 167.11 1463.57 168.13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463.57 168.13V214.77C1463.57 215.77 1462.91 216.78 1461.58 217.54C1458.93 219.07 1454.63 219.07 1451.98 217.54C1450.65 216.78 1449.99 215.77 1449.99 214.77V168.08C1449.99 169.08 1450.65 170.08 1451.98 170.85C1454.63 172.38 1458.93 172.38 1461.58 170.85C1462.88 170.1 1463.55 169.11 1463.57 168.13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463.57 168.13C1463.55 169.12 1462.89 170.1 1461.58 170.85C1458.93 172.38 1454.63 172.38 1451.98 170.85C1450.65 170.08 1449.99 169.08 1449.99 168.08C1449.99 167.08 1450.65 166.07 1451.98 165.31C1454.63 163.78 1458.93 163.78 1461.58 165.31C1462.93 166.09 1463.59 167.11 1463.57 168.13Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463.57 168.08V214.77C1463.57 215.77 1462.91 216.78 1461.58 217.54C1458.93 219.07 1454.63 219.07 1451.98 217.54C1450.65 216.78 1449.99 215.77 1449.99 214.77V168.08",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.689 35.8401C997.669 36.8301 997.009 37.8101 995.699 38.5601C993.049 40.0901 988.749 40.0901 986.099 38.5601C984.769 37.7901 984.109 36.7901 984.109 35.7901C984.109 34.7901 984.769 33.7801 986.099 33.0201C988.749 31.4901 993.049 31.4901 995.699 33.0201C997.049 33.8001 997.709 34.8201 997.689 35.8401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.689 35.84V82.48C997.689 83.48 997.029 84.49 995.699 85.25C993.049 86.78 988.749 86.78 986.099 85.25C984.769 84.49 984.109 83.48 984.109 82.48V35.79C984.109 36.79 984.769 37.79 986.099 38.56C988.749 40.09 993.049 40.09 995.699 38.56C996.999 37.81 997.669 36.82 997.689 35.84Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.689 35.8401C997.669 36.8301 997.009 37.8101 995.699 38.5601C993.049 40.0901 988.749 40.0901 986.099 38.5601C984.769 37.7901 984.109 36.7901 984.109 35.7901C984.109 34.7901 984.769 33.7801 986.099 33.0201C988.749 31.4901 993.049 31.4901 995.699 33.0201C997.049 33.8001 997.709 34.8201 997.689 35.8401Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.689 35.8V82.4901C997.689 83.4901 997.029 84.5001 995.699 85.2601C993.049 86.7901 988.749 86.7901 986.099 85.2601C984.769 84.5001 984.109 83.4901 984.109 82.4901V35.8",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785.3 247.4C1785.28 248.39 1784.62 249.37 1783.31 250.12C1780.66 251.65 1776.36 251.65 1773.71 250.12C1772.38 249.35 1771.72 248.35 1771.72 247.35C1771.72 246.35 1772.38 245.34 1773.71 244.58C1776.36 243.05 1780.66 243.05 1783.31 244.58C1784.66 245.36 1785.32 246.38 1785.3 247.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785.3 247.4V294.04C1785.3 295.04 1784.64 296.05 1783.31 296.81C1780.66 298.34 1776.36 298.34 1773.71 296.81C1772.38 296.05 1771.72 295.04 1771.72 294.04V247.35C1771.72 248.35 1772.38 249.35 1773.71 250.12C1776.36 251.65 1780.66 251.65 1783.31 250.12C1784.61 249.37 1785.28 248.38 1785.3 247.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785.3 247.4C1785.28 248.39 1784.62 249.37 1783.31 250.12C1780.66 251.65 1776.36 251.65 1773.71 250.12C1772.38 249.35 1771.72 248.35 1771.72 247.35C1771.72 246.35 1772.38 245.34 1773.71 244.58C1776.36 243.05 1780.66 243.05 1783.31 244.58C1784.66 245.36 1785.32 246.38 1785.3 247.4Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785.3 247.35V294.04C1785.3 295.04 1784.64 296.05 1783.31 296.81C1780.66 298.34 1776.36 298.34 1773.71 296.81C1772.38 296.05 1771.72 295.04 1771.72 294.04V247.35",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.73 -27.97V18.67C595.73 19.67 595.07 20.68 593.74 21.44C591.09 22.97 586.79 22.97 584.14 21.44C582.81 20.68 582.15 19.67 582.15 18.67V-28.02C582.15 -27.02 582.81 -26.02 584.14 -25.25C586.79 -23.72 591.09 -23.72 593.74 -25.25C595.04 -26 595.71 -26.99 595.73 -27.97Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.73 -28.01V18.68C595.73 19.68 595.07 20.69 593.74 21.45C591.09 22.98 586.79 22.98 584.14 21.45C582.81 20.69 582.15 19.68 582.15 18.68V-28.01",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.23 326.33V335.93L238.8 326.94V317.34L223.23 326.33Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.91 296.11L223.23 326.33L238.8 317.34L275.3 338.41L296.85 325.97L260.36 304.9L275.92 296.11H223.91Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.801 317.34V326.94L275.301 348.02V338.41L238.801 317.34Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.361 304.9L268.671 309.7L275.921 305.51V296.11L260.361 304.9Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.301 338.41V348.02L296.851 335.57V325.97L275.301 338.41Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.23 326.33L223.91 296.11H275.92L260.36 304.9L296.85 325.97L275.3 338.41L238.8 317.34L223.23 326.33Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.801 317.34V326.94",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.301 338.41V348.02",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.85 325.97V335.57L275.3 348.02L238.8 326.94L223.23 335.93V326.33",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.92 296.11V305.51L268.67 309.7",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.43 296.29V306.25L1638.16 330.34V320.39L1596.43 296.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.43 296.29L1638.16 320.39L1658.93 308.4L1617.2 284.31L1596.43 296.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1638.16 320.39V330.34L1658.93 318.36V308.4L1638.16 320.39Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1658.93 308.4L1617.2 284.31L1596.43 296.29L1638.16 320.39L1658.93 308.4Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1638.16 320.39V330.34",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1658.93 308.4V318.36L1638.16 330.34L1596.43 306.25V296.29",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1965.15 127.71L1944.37 139.7L1902.65 115.61L1923.41 103.61L1965.15 127.71Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1944.37 139.7V155.42L1902.65 131.33V115.61L1944.37 139.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1965.15 127.71L1923.41 103.61L1902.65 115.61L1944.37 139.7L1965.15 127.71Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1965.15 127.71V143.43L1944.37 155.42L1902.65 131.33V115.61",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1902.84 100.01V115.72L1923.6 127.71V111.99L1902.84 100.01Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1902.84 100.01L1923.6 111.99L1965.34 87.9002L1944.58 75.9102L1902.84 100.01Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1923.6 111.99L1902.84 100.01L1944.58 75.9102L1965.34 87.9002",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1902.84 100.01V115.72L1923.6 127.71",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1877.31 23.0002L1893.43 13.6902C1897.56 11.3002 1904.26 11.3002 1908.39 13.6902L1925.25 23.4202C1929.38 25.8102 1936.08 25.8102 1940.21 23.4202L1966.5 8.24023",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1870.69 26.8202C1868.86 25.7702 1868.86 24.0602 1870.69 23.0002C1872.52 21.9502 1875.48 21.9502 1877.31 23.0002C1879.14 24.0502 1879.14 25.7602 1877.31 26.8202C1875.48 27.8702 1872.52 27.8702 1870.69 26.8202Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1924.54 263.44V274.49L1915.84 269.46V258.41L1924.54 263.44Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1924.17 246.54L1924.54 263.44L1915.84 258.41L1892.15 272.09L1915.84 285.77L1924.54 280.74L1924.17 297.64H1895.08L1903.79 292.73L1880.1 279.05L1856.41 292.73L1865.12 297.64H1836.04L1835.65 280.74L1844.36 285.77L1868.04 272.09L1844.36 258.41L1835.65 263.44L1836.04 246.54H1865.12L1856.41 251.45L1880.1 265.13L1903.79 251.45L1895.08 246.54H1924.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1924.16 297.64H1895.08V308.69H1924.16V297.64Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1915.84 258.41V269.46L1901.72 277.61L1892.15 272.09L1915.84 258.41Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1903.79 251.45L1895.08 256.48V246.54L1903.79 251.45Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1868.04 272.09L1858.48 277.61L1844.36 269.46V258.41L1868.04 272.09Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1895.08 297.64V298.75L1880.1 290.1L1865.12 298.75V297.64L1856.41 292.73L1880.1 279.05L1903.79 292.73L1895.08 297.64Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1865.12 298.75V308.69H1836.04V297.64H1865.12V298.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1865.12 246.54V256.48L1856.41 251.45L1865.12 246.54Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1844.36 258.41V269.46L1835.65 274.49V263.44L1844.36 258.41Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1835.65 263.44V274.49L1844.36 269.46L1858.48 277.61",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1924.54 263.44V274.49L1915.84 269.46L1901.72 277.61",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1865.12 298.75L1880.1 290.1L1895.08 298.75",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1895.08 256.48L1880.1 265.13L1856.41 251.45L1865.12 246.54H1836.04L1835.65 263.44L1844.36 258.41L1868.04 272.09L1844.36 285.77L1835.65 280.74L1836.04 297.64H1865.12L1856.41 292.73L1880.1 279.05L1903.79 292.73L1895.08 297.64H1924.17L1924.54 280.74L1915.84 285.77L1892.15 272.09L1915.84 258.41L1924.54 263.44L1924.17 246.54H1895.08L1903.79 251.45L1895.08 256.48Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1865.12 246.54V256.48",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1895.08 246.54V256.48",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1844.36 258.41V269.46",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1915.84 258.41V269.46",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1865.12 297.64V308.69H1836.04V297.64",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1895.08 297.64V308.69H1924.17V297.64",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.89 95.4298C373.94 99.5598 373.77 107.07 378.52 111.39C382.63 115.13 388.94 115.04 392.94 111.19L440.33 65.6098C441.55 62.3898 440.77 58.5798 438.04 56.0998C435.05 53.3898 430.63 53.1098 427.35 55.3198L427.25 55.1998L378.9 95.4398L378.89 95.4298Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.229 55.1898L427.329 55.3098C430.619 53.1098 435.039 53.3898 438.019 56.0898C440.749 58.5698 441.529 62.3798 440.309 65.5998L444.079 61.9798C444.389 61.6798 444.669 61.3698 444.919 61.0398C447.379 57.7998 447.029 53.0998 443.909 50.2698C441.609 48.1798 438.389 47.6598 435.609 48.7298C434.819 49.0398 434.069 49.4698 433.379 50.0398L427.209 55.1798L427.229 55.1898Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.929 50.2698C447.049 53.1098 447.409 57.7998 444.939 61.0398L445.669 61.3298C445.669 61.3298 445.749 61.3898 445.789 61.4098L458.149 68.5398C450.659 63.8898 446.059 54.3298 446.059 40.8798C446.059 13.2998 465.429 -20.2502 489.309 -34.0402C501.019 -40.7902 511.639 -41.5602 519.429 -37.3302L506.959 -44.5302C499.139 -49.0502 488.319 -48.4002 476.379 -41.5002C470.359 -38.0402 464.629 -33.3102 459.419 -27.7402C443.949 -11.2002 433.119 12.7698 433.119 33.4098C433.119 34.3898 433.139 35.3598 433.199 36.2998C433.439 40.9898 434.269 45.1498 435.619 48.7398C438.389 47.6598 441.609 48.1798 443.919 50.2798L443.929 50.2698Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.16 68.5398C450.67 63.8898 446.07 54.3298 446.07 40.8798C446.07 13.2998 465.44 -20.2502 489.32 -34.0402C501.03 -40.7902 511.65 -41.5602 519.44 -37.3302L519.9 -37.0702C527.73 -32.5602 532.58 -22.8702 532.58 -9.07019C532.58 -4.03019 531.93 1.20981 530.73 6.48981C525.36 30.1098 508.85 54.5798 489.33 65.8498C477.14 72.8898 466.13 73.4298 458.27 68.5998L458.17 68.5398H458.16ZM489.32 55.3098C508.17 44.4298 523.45 17.9598 523.45 -3.8002C523.45 -18.5002 516.47 -27.2902 506.13 -28.0802C501.17 -28.4802 495.44 -27.0202 489.32 -23.5002C470.47 -12.6202 455.19 13.8498 455.19 35.6098C455.19 42.6598 456.79 48.3498 459.6 52.4498C465.46 61.0298 476.57 62.6798 489.32 55.3098Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.189 35.6098C455.189 42.6598 456.789 48.3498 459.599 52.4498C465.459 61.0298 476.569 62.6798 489.319 55.3098C508.169 44.4298 523.449 17.9598 523.449 -3.80021C523.449 -18.5002 516.469 -27.2902 506.129 -28.0802C501.169 -28.4802 495.439 -27.0202 489.319 -23.5002C470.469 -12.6202 455.189 13.8498 455.189 35.6098Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.26 68.5998C466.12 73.4198 477.13 72.8898 489.32 65.8498C508.85 54.5798 525.35 30.1098 530.72 6.48981C531.92 1.20981 532.57 -4.03019 532.57 -9.07019C532.57 -22.8602 527.73 -32.5602 519.89 -37.0702",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.44 -37.3302C511.65 -41.5602 501.03 -40.7902 489.32 -34.0402C465.43 -20.2502 446.07 13.2998 446.07 40.8798C446.07 54.3298 450.67 63.8898 458.16 68.5398",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.129 -28.0902C501.169 -28.4902 495.439 -27.0302 489.319 -23.5102C470.469 -12.6302 455.189 13.8398 455.189 35.5998C455.189 42.6498 456.789 48.3398 459.599 52.4398C465.459 61.0198 476.569 62.6698 489.319 55.2998C508.169 44.4198 523.449 17.9498 523.449 -3.81021C523.449 -18.5102 516.469 -27.3002 506.129 -28.0902Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.899 -37.0702L506.969 -44.5402C499.149 -49.0602 488.329 -48.4102 476.389 -41.5102C470.369 -38.0502 464.639 -33.3202 459.429 -27.7502C443.959 -11.2102 433.129 12.7598 433.129 33.3998C433.129 34.3798 433.149 35.3498 433.209 36.2898C433.449 40.9798 434.279 45.1398 435.629 48.7298",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.67 61.3298C445.67 61.3298 445.75 61.3898 445.79 61.4098L458.73 68.8698",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.33 65.6098L392.94 111.19C388.94 115.05 382.62 115.13 378.52 111.39C373.77 107.07 373.94 99.5598 378.89 95.4298L433.41 50.0398C434.1 49.4698 434.85 49.0398 435.64 48.7298C438.41 47.6498 441.63 48.1698 443.94 50.2698C447.06 53.1098 447.42 57.7998 444.95 61.0398C444.7 61.3698 444.41 61.6798 444.11 61.9798L440.34 65.5998L440.33 65.6098Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.34 55.3098C430.63 53.1098 435.05 53.3898 438.03 56.0898C440.76 58.5698 441.54 62.3798 440.32 65.5998",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.959 84.0498C149.869 88.6798 146.759 93.2898 140.639 96.8198C128.199 104 108.049 104 95.6191 96.8198C89.3991 93.2298 86.2891 88.5298 86.2891 83.8298C86.2891 79.1298 89.3991 74.4198 95.6091 70.8298C108.049 63.6498 128.199 63.6498 140.629 70.8298C146.939 74.4798 150.049 79.2698 149.949 84.0498H149.959Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.959 84.0498V98.1498C149.959 102.85 146.849 107.56 140.639 111.14C128.199 118.32 108.049 118.32 95.6191 111.14C89.3991 107.55 86.2891 102.85 86.2891 98.1498V83.8298C86.2891 88.5298 89.3991 93.2298 95.6191 96.8198C108.049 104 128.199 104 140.639 96.8198C146.759 93.2898 149.869 88.6698 149.959 84.0498Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.959 84.0498C149.869 88.6798 146.759 93.2898 140.639 96.8198C128.199 104 108.049 104 95.6191 96.8198C89.3991 93.2298 86.2891 88.5298 86.2891 83.8298C86.2891 79.1298 89.3991 74.4198 95.6091 70.8298C108.049 63.6498 128.199 63.6498 140.629 70.8298C146.939 74.4798 150.049 79.2698 149.949 84.0498H149.959Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.959 83.8398V98.1598C149.959 102.86 146.849 107.57 140.639 111.15C128.199 118.33 108.049 118.33 95.6191 111.15C89.3991 107.56 86.2891 102.86 86.2891 98.1598V83.8398",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.46 71.4398V90.2498H105.02V85.4098H119.06V71.4398H127.46Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.46 71.4398H119.06V85.4098H105.02V90.2498H127.46V71.4398Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.481 194.84V292.2C530.481 295.88 528.511 299.28 525.341 301.11L394.481 376.66C393.251 377.37 392.131 377.41 391.281 376.92L391.241 376.9C390.201 376.3 389.561 374.91 389.561 372.94V275.92L530.471 194.56V194.83L530.481 194.84Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.8 179.42C529.84 180.02 530.48 181.41 530.48 183.38V194.57L389.57 275.93V264.74C389.57 261.13 391.77 256.92 394.49 255.35L525.58 179.67C526.77 178.99 527.86 178.92 528.72 179.38L528.8 179.42Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.531 174.08L528.721 179.39C527.861 178.93 526.771 178.99 525.581 179.68L394.491 255.36C391.771 256.93 389.571 261.13 389.571 264.75V372.96C389.571 374.93 390.221 376.32 391.251 376.92L381.901 371.52C380.871 370.92 380.221 369.53 380.221 367.56V259.35C380.221 255.74 382.421 251.53 385.131 249.96L516.221 174.28C517.421 173.6 518.511 173.52 519.371 173.99L519.531 174.08Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.371 173.98C518.511 173.51 517.421 173.58 516.221 174.27L385.131 249.95C382.421 251.52 380.221 255.72 380.221 259.34V367.55C380.221 369.52 380.871 370.91 381.901 371.51",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.291 376.93C392.141 377.42 393.261 377.38 394.491 376.67L525.351 301.12C528.531 299.28 530.491 295.89 530.491 292.21V183.39C530.491 181.42 529.841 180.03 528.811 179.43",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.72 179.38C527.86 178.92 526.77 178.98 525.58 179.67L394.49 255.35C391.77 256.92 389.57 261.12 389.57 264.74V372.95C389.57 374.92 390.22 376.31 391.25 376.91",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.57 275.93L530.48 194.57",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.371 173.98L528.801 179.42",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.371 253.19C414.371 254.77 415.481 255.41 416.851 254.62C418.221 253.83 419.331 251.91 419.331 250.33C419.331 248.75 418.221 248.11 416.851 248.9C415.481 249.69 414.371 251.61 414.371 253.19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.611 258.25C405.611 259.83 406.721 260.47 408.091 259.68C409.461 258.89 410.571 256.97 410.571 255.39C410.571 253.81 409.461 253.17 408.091 253.96C406.721 254.75 405.611 256.67 405.611 258.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.84 263.31C396.84 264.89 397.95 265.53 399.32 264.74C400.69 263.95 401.8 262.03 401.8 260.45C401.8 258.87 400.69 258.23 399.32 259.02C397.95 259.81 396.84 261.73 396.84 263.31Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.791 236.65C515.401 235.72 516.711 236.48 516.711 238.34C516.711 239.28 516.381 240.32 515.851 241.23C515.331 242.14 514.591 242.94 513.791 243.41L497.301 252.93C495.681 253.87 494.381 253.11 494.381 251.23C494.381 250.3 494.701 249.27 495.231 248.35C495.761 247.43 496.491 246.63 497.301 246.16L513.791 236.64V236.65Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.731 252.14C512.341 251.21 513.661 251.96 513.661 253.83C513.661 254.76 513.331 255.79 512.801 256.71C512.271 257.63 511.541 258.42 510.731 258.89L466.141 284.64C464.521 285.58 463.211 284.83 463.211 282.96C463.211 282.02 463.541 280.99 464.061 280.07C464.591 279.16 465.331 278.35 466.141 277.88L510.731 252.13V252.14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.3 280.99C509.91 280.06 511.23 280.81 511.23 282.67C511.23 283.61 510.9 284.64 510.37 285.56C509.85 286.47 509.11 287.27 508.3 287.74L500.151 292.45C498.541 293.38 497.23 292.63 497.23 290.76C497.23 289.82 497.551 288.8 498.081 287.88C498.611 286.97 499.341 286.17 500.151 285.7L508.3 280.99Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.53 268.87C507.14 267.94 508.46 268.69 508.46 270.55C508.46 271.49 508.13 272.52 507.6 273.44C507.07 274.36 506.34 275.16 505.53 275.63L471.35 295.36C469.74 296.29 468.42 295.53 468.42 293.67C468.42 292.74 468.75 291.7 469.28 290.79C469.81 289.87 470.54 289.07 471.35 288.6L505.53 268.87Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.011 228.01C506.621 227.08 507.931 227.83 507.931 229.7C507.931 230.63 507.611 231.66 507.071 232.58C506.541 233.51 505.811 234.3 505.011 234.77L476.551 251.2C474.941 252.13 473.621 251.38 473.621 249.52C473.621 248.58 473.951 247.55 474.481 246.63C475.011 245.71 475.741 244.92 476.551 244.45L505.011 228.02V228.01Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.91 291.61C491.52 290.68 492.84 291.43 492.84 293.29C492.84 294.23 492.51 295.26 491.98 296.18C491.45 297.1 490.72 297.89 489.91 298.36L471.35 309.08C469.74 310.01 468.42 309.27 468.42 307.4C468.42 306.46 468.75 305.44 469.28 304.51C469.81 303.6 470.54 302.8 471.35 302.33L489.91 291.61Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.781 252.24C488.391 251.31 489.711 252.07 489.711 253.92C489.711 254.86 489.381 255.9 488.851 256.81C488.321 257.72 487.591 258.52 486.781 258.99L472.381 267.3C470.771 268.23 469.451 267.48 469.451 265.61C469.451 264.68 469.781 263.65 470.311 262.73C470.841 261.81 471.571 261.01 472.381 260.54L486.781 252.23V252.24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.03 312.09L444.41 295.7L430.22 279.71L416.03 312.09ZM430.22 304.9C426.86 306.84 424.13 311.55 424.13 315.43C424.13 319.31 426.85 320.88 430.22 318.94C433.59 317 436.31 312.28 436.31 308.4C436.31 304.52 433.59 302.95 430.22 304.89V304.9ZM452.03 257.27V320.16L408.4 345.35V282.46L452.03 257.27Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.221 279.71L444.411 295.7L416.031 312.09L430.221 279.71Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.411 295.7L430.221 279.71L416.031 312.09L444.411 295.7Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.011 234.76L476.551 251.19C474.941 252.12 473.621 251.37 473.621 249.51C473.621 248.57 473.951 247.54 474.481 246.62C475.011 245.7 475.741 244.91 476.551 244.44L505.011 228.01C506.621 227.08 507.931 227.83 507.931 229.7C507.931 230.63 507.611 231.66 507.071 232.58C506.541 233.51 505.811 234.3 505.011 234.77V234.76Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.781 259.01L472.381 267.32C470.771 268.25 469.451 267.5 469.451 265.63C469.451 264.7 469.781 263.67 470.311 262.75C470.841 261.83 471.571 261.03 472.381 260.56L486.781 252.25C488.391 251.32 489.711 252.08 489.711 253.93C489.711 254.87 489.381 255.91 488.851 256.82C488.321 257.73 487.591 258.53 486.781 259V259.01Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.791 243.41L497.301 252.93C495.681 253.87 494.381 253.11 494.381 251.23C494.381 250.3 494.701 249.27 495.231 248.35C495.761 247.43 496.491 246.63 497.301 246.16L513.791 236.64C515.401 235.71 516.711 236.47 516.711 238.33C516.711 239.27 516.381 240.31 515.851 241.22C515.331 242.13 514.591 242.93 513.791 243.4V243.41Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.731 258.89L466.141 284.64C464.521 285.58 463.211 284.83 463.211 282.96C463.211 282.02 463.541 280.99 464.061 280.07C464.591 279.16 465.331 278.35 466.141 277.88L510.731 252.13C512.341 251.2 513.661 251.95 513.661 253.82C513.661 254.75 513.331 255.78 512.801 256.7C512.271 257.62 511.541 258.41 510.731 258.88V258.89Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.53 275.63L471.35 295.36C469.74 296.29 468.42 295.53 468.42 293.67C468.42 292.74 468.75 291.7 469.28 290.79C469.81 289.87 470.54 289.07 471.35 288.6L505.53 268.87C507.14 267.94 508.46 268.69 508.46 270.55C508.46 271.49 508.13 272.52 507.6 273.44C507.07 274.36 506.34 275.16 505.53 275.63Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.91 298.36L471.35 309.08C469.74 310.01 468.42 309.27 468.42 307.4C468.42 306.46 468.75 305.44 469.28 304.51C469.81 303.6 470.54 302.8 471.35 302.33L489.91 291.61C491.52 290.68 492.84 291.43 492.84 293.29C492.84 294.23 492.51 295.26 491.98 296.18C491.45 297.1 490.72 297.89 489.91 298.36Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.3 287.74L500.151 292.45C498.541 293.38 497.23 292.63 497.23 290.76C497.23 289.82 497.551 288.8 498.081 287.88C498.611 286.97 499.341 286.17 500.151 285.7L508.3 280.99C509.91 280.06 511.23 280.81 511.23 282.67C511.23 283.61 510.9 284.64 510.37 285.56C509.85 286.47 509.11 287.27 508.3 287.74Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.03 320.16L408.4 345.36V282.47L452.03 257.27V320.16Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.78 207.65C1101.32 209.06 1099.67 214.94 1098.58 223.42C1097.78 229.67 1097.26 237.33 1096.94 245.66C1096.67 252.26 1096.54 259.27 1096.47 266.33C1096.98 266.39 1097.5 266.45 1098.02 266.55C1099.83 266.87 1101.66 267.45 1103.5 268.27C1108.28 270.4 1113.12 274.13 1117.67 279.08C1118.01 270.83 1118.19 259.48 1117.6 248.23C1116.72 230 1113.84 212 1106.44 207.78C1105.47 207.23 1104.57 207.21 1103.77 207.65H1103.78Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.62 248.23H1117.61C1118.2 259.48 1118.02 270.83 1117.68 279.08L1180.79 243.4C1181.08 234.99 1181.24 223.7 1180.73 212.55H1180.72L1156.66 226.17L1156.88 227.36C1157.19 228.83 1156.96 230.4 1156.13 231.65C1155.74 232.24 1155.24 232.74 1154.74 233.04L1150 235.71C1148.7 236.46 1147.66 235.65 1147.67 233.92L1147.2 231.51L1117.62 248.21V248.23Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.26 182.48L1103.78 207.65C1104.58 207.21 1105.48 207.23 1106.45 207.78C1113.85 212 1116.73 230 1117.61 248.23H1117.62L1147.2 231.53L1146.5 227.84L1155.95 222.49L1156.66 226.18L1180.72 212.56H1180.73C1179.86 194.09 1177.09 176.02 1169.89 171.91C1168.9 171.36 1168.02 171.34 1167.2 171.78L1148.26 182.48Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.5 227.84L1147.67 233.94C1147.66 235.67 1148.7 236.48 1150 235.73L1154.74 233.06C1155.24 232.76 1155.74 232.26 1156.13 231.67C1156.96 230.41 1157.19 228.84 1156.88 227.38L1155.96 222.5L1146.51 227.85L1146.5 227.84Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.33 180.15C1147.99 179.95 1147.79 179.54 1147.79 178.95C1147.79 177.12 1146.55 176.33 1145 177.12C1145 177.2 1145 177.27 1145 177.34C1145 177.93 1145.2 178.35 1145.54 178.54L1148.32 180.14L1148.33 180.15Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.8 178.95C1147.8 179.54 1148 179.95 1148.34 180.15C1148.68 180.35 1149.14 180.32 1149.66 180.02C1150.68 179.43 1151.51 177.98 1151.51 176.8C1151.51 174.67 1150.76 173.17 1149.55 172.47L1146.77 170.86C1145.55 170.16 1143.88 170.26 1142.03 171.33L1132.32 176.93C1128.63 179.06 1125.63 184.26 1125.63 188.53C1125.63 189.12 1125.84 189.54 1126.18 189.73L1128.88 191.29C1129.22 191.54 1129.72 191.53 1130.27 191.21C1131.3 190.61 1132.13 189.18 1132.13 187.99C1132.13 186.09 1133.47 183.77 1135.11 182.82C1135.11 182.82 1144.95 177.14 1145.01 177.11C1146.58 176.36 1147.8 177.11 1147.8 178.94V178.95Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.78 207.65C1101.31 209.04 1099.67 214.94 1098.58 223.42C1097.78 229.67 1097.26 237.33 1096.94 245.66C1096.67 252.26 1096.54 259.27 1096.47 266.33C1096.98 266.39 1097.5 266.45 1098.02 266.55C1099.83 266.87 1101.66 267.45 1103.5 268.27C1108.28 270.4 1113.12 274.13 1117.67 279.08C1118.01 270.83 1118.17 259.48 1117.6 248.23C1116.68 230 1113.84 212 1106.44 207.78C1105.47 207.23 1104.56 207.2 1103.77 207.65H1103.78Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.68 279.09L1180.79 243.41C1181.08 235 1181.25 223.71 1180.73 212.56C1179.86 194.09 1177.09 176.02 1169.89 171.91C1168.9 171.36 1168.02 171.34 1167.2 171.78L1103.78 207.65",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.71 212.56L1156.66 226.18",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.2 231.53L1117.62 248.23",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.2 231.53L1147.67 233.94C1147.66 235.67 1148.7 236.48 1150 235.73L1154.74 233.06C1155.24 232.76 1155.74 232.26 1156.13 231.67C1156.96 230.41 1157.19 228.84 1156.88 227.38L1155.96 222.5L1146.51 227.85L1147.21 231.54L1147.2 231.53Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.26 185.62V180.1",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.33 180.15L1145.55 178.55C1145.21 178.35 1145.01 177.93 1145.01 177.35C1145.01 177.27 1145.01 177.2 1145.01 177.13",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.87 196.82V191.3C1129.21 191.55 1129.71 191.54 1130.26 191.22C1131.29 190.62 1132.12 189.19 1132.12 188C1132.12 186.1 1133.46 183.78 1135.1 182.83C1135.1 182.83 1144.94 177.15 1145 177.12C1146.57 176.37 1147.79 177.12 1147.79 178.95C1147.79 179.54 1147.99 179.95 1148.33 180.15C1148.67 180.35 1149.13 180.32 1149.65 180.02C1150.67 179.43 1151.5 177.98 1151.5 176.8C1151.5 174.67 1150.75 173.17 1149.54 172.47L1146.76 170.86C1145.54 170.16 1143.87 170.26 1142.02 171.33L1132.31 176.93C1128.62 179.06 1125.62 184.26 1125.62 188.53C1125.62 189.12 1125.83 189.54 1126.17 189.73L1128.95 191.34",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.259 399.74C912.129 391 909.329 380.34 904.369 373.89C912.299 372.21 920.369 370.11 928.559 367.64C930.509 367.04 932.109 365.59 932.919 363.7L935.229 358.19C936.299 357.03 938.149 357.09 939.139 358.32L939.159 358.34C940.779 360.38 943.539 361.12 945.959 360.18L956.219 356.26C956.699 356.06 957.219 355.98 957.719 355.98C959.339 355.98 960.889 356.94 961.569 358.51C962.019 359.6 962.019 360.81 961.539 361.89L957.519 370.76C955.889 374.4 953.029 377.33 949.439 379.1L936.889 385.23",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.259 399.74C912.129 391 909.329 380.34 904.369 373.89C912.299 372.21 920.369 370.11 928.559 367.64C930.509 367.04 932.109 365.59 932.919 363.7L935.229 358.19C936.299 357.03 938.149 357.09 939.139 358.32L939.159 358.34C940.779 360.38 943.539 361.12 945.959 360.18L956.219 356.26C956.699 356.06 957.219 355.98 957.719 355.98C959.339 355.98 960.889 356.94 961.569 358.51C962.019 359.6 962.019 360.81 961.539 361.89L957.519 370.76C955.889 374.4 953.029 377.33 949.439 379.1L936.889 385.23",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.859 391C821.659 399.82 792.239 393.42 778.279 373.7C778.429 373.31 780.399 368.1 781.159 365.99C790.449 378.49 819.339 393.04 847.169 381.36C848.299 384.78 849.529 388.03 850.859 391Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.86 391C849.53 388.02 848.3 384.78 847.17 381.36C819.33 393.04 790.44 378.49 781.16 365.99C783.63 359.07 785.44 352.99 785.44 347.9C785.44 338.65 781.67 321.35 778.37 307.95C774.69 325.28 773.38 345.7 778.5 371.43C778.24 371.66 777.98 371.86 777.71 372.07C767.41 379.84 752.54 373.22 751.03 360.42C750.38 354.89 749.94 349.45 749.63 344.3C749.59 343.56 745.84 247.92 798.55 254.83C803.81 255.51 809.65 257.22 816.11 260.16C817.62 260.86 819.25 261.61 820.97 262.48C835.73 269.91 856.52 283.85 861.88 305.24C866.75 324.77 871.45 361.28 872.98 373.93C873.29 376.4 875.49 378.19 877.94 377.97C886.6 377.16 895.41 375.79 904.38 373.9C909.34 380.36 912.13 391.02 906.27 399.75",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843.599 206.09C844.279 212.56 844.599 221.26 843.409 231.09C840.889 251.89 821.639 248.77 821.639 248.77L820.959 262.48C819.249 261.61 817.619 260.85 816.099 260.16C809.629 257.23 803.799 255.51 798.539 254.83V254.81C799.779 250.03 801.239 244.13 802.459 238.19C804.709 237.92 807.189 237.02 809.759 235.35C818.709 229.52 815.799 218.44 824.949 214.55C830.619 212.14 838.299 209.8 843.599 206.08V206.09Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.47 238.18C796.86 238.86 792.78 235.51 793.06 230.1C793.35 224.37 788.13 212.06 791.62 200C782.42 198.76 775.35 191.19 775.35 182.07C775.35 172.05 783.83 163.95 794.3 163.95C804.77 163.95 813.21 172.03 813.24 181.99C829.97 180.35 850.49 190.39 849.64 197.43C849.2 201.04 846.85 203.83 843.6 206.08C838.3 209.8 830.62 212.14 824.95 214.55C815.8 218.44 818.71 229.52 809.76 235.35C807.19 237.01 804.7 237.92 802.46 238.18H802.47Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.37 307.95C774.69 325.28 773.19 345.74 778.5 371.43C778.58 371.8 778.65 372.17 778.73 372.54",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.87 385.23L949.42 379.1C953.01 377.33 955.87 374.4 957.5 370.76L961.52 361.89C962.01 360.81 962.01 359.6 961.55 358.51C960.87 356.93 959.32 355.98 957.7 355.98C957.2 355.98 956.68 356.06 956.2 356.26L945.94 360.18C943.52 361.11 940.76 360.37 939.14 358.34L939.12 358.32C938.14 357.09 936.28 357.03 935.21 358.19L932.9 363.7C932.09 365.59 930.49 367.04 928.54 367.64C920.35 370.11 912.28 372.21 904.35 373.89C895.39 375.78 886.57 377.15 877.91 377.96C875.46 378.19 873.26 376.39 872.95 373.92C871.42 361.28 866.72 324.76 861.85 305.23C856.49 283.84 835.69 269.92 820.94 262.47C819.22 261.6 817.6 260.84 816.08 260.15C809.61 257.22 803.78 255.51 798.52 254.82C745.8 247.97 749.55 343.55 749.6 344.29C749.91 349.44 750.35 354.87 751 360.41C752.51 373.21 767.38 379.83 777.68 372.06C777.95 371.86 778.21 371.65 778.47 371.42",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.27 319.79C837.02 332.89 840.279 360.48 847.169 381.37C848.299 384.79 849.529 388.04 850.859 391.01",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.16 365.99C790.45 378.49 819.34 393.04 847.17 381.36",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.961 262.47L821.641 248.76C821.641 248.76 840.891 251.88 843.411 231.08C844.601 221.25 844.281 212.54 843.601 206.08",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.551 254.81C799.791 250.03 801.251 244.13 802.471 238.19",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.96 191.06C812.54 187.97 813.25 184.91 813.24 182C813.19 172.04 804.75 163.96 794.3 163.96C783.85 163.96 775.35 172.06 775.35 182.08C775.35 191.2 782.42 198.76 791.62 200.01C795.54 200.54 799.84 199.92 804.15 197.8",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.62 200C788.14 212.06 793.35 224.37 793.06 230.1C792.78 235.5 796.85 238.84 802.47 238.18C804.71 237.91 807.2 237.01 809.77 235.35C818.72 229.52 815.81 218.44 824.96 214.55C830.63 212.14 838.3 209.79 843.61 206.08C846.85 203.82 849.21 201.04 849.65 197.43C850.5 190.39 829.98 180.36 813.25 181.99",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.48 289.36C773.48 289.36 775.78 297.46 778.36 307.95C781.65 321.35 785.43 338.65 785.43 347.9C785.43 352.99 783.621 359.07 781.151 365.99C780.391 368.1 778.421 373.31 778.271 373.7C792.241 393.42 821.65 399.81 850.85 391",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.01 95.46V109.53C1354.01 112.08 1352.33 114.62 1348.96 116.56C1342.24 120.44 1331.33 120.44 1324.6 116.56C1321.24 114.62 1319.56 112.08 1319.56 109.53V95.46C1319.56 98 1321.24 100.55 1324.6 102.49C1331.33 106.37 1342.23 106.37 1348.96 102.49C1352.32 100.54 1354.01 98 1354.01 95.46Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.01 81.38V95.46C1354.01 98 1352.33 100.55 1348.96 102.49C1342.24 106.37 1331.33 106.37 1324.6 102.49C1321.24 100.54 1319.56 98 1319.56 95.46V81.38C1319.56 83.94 1321.24 86.48 1324.6 88.42C1331.33 92.3 1342.23 92.3 1348.96 88.42C1352.32 86.48 1354.01 83.94 1354.01 81.38Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.01 67.31V81.38C1354.01 83.94 1352.33 86.48 1348.96 88.42C1342.24 92.3 1331.33 92.3 1324.6 88.42C1321.24 86.48 1319.56 83.94 1319.56 81.38V67.31C1319.56 69.85 1321.24 72.4 1324.6 74.34C1331.33 78.22 1342.23 78.22 1348.96 74.34C1352.32 72.39 1354.01 69.85 1354.01 67.31Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.01 57.86V67.31C1354.01 69.85 1352.33 72.4 1348.96 74.34C1342.24 78.22 1331.33 78.22 1324.6 74.34C1321.24 72.39 1319.56 69.85 1319.56 67.31V53.44C1319.56 55.98 1321.24 58.53 1324.6 60.47C1331.33 64.35 1342.23 64.35 1348.96 60.47C1352.32 58.52 1354.01 55.98 1354.01 53.44V57.86Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1348.96 46.41C1352.32 48.36 1354.01 50.9 1354.01 53.44C1354.01 55.98 1352.33 58.53 1348.96 60.47C1342.24 64.35 1331.33 64.35 1324.6 60.47C1321.24 58.52 1319.56 55.98 1319.56 53.44C1319.56 50.9 1321.24 48.35 1324.6 46.41C1331.33 42.53 1342.23 42.53 1348.96 46.41Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.01 53.44C1354.01 55.98 1352.33 58.53 1348.96 60.47C1342.24 64.35 1331.33 64.35 1324.6 60.47C1321.24 58.52 1319.56 55.98 1319.56 53.44C1319.56 50.9 1321.24 48.35 1324.6 46.41C1331.33 42.53 1342.23 42.53 1348.96 46.41C1352.32 48.36 1354.01 50.9 1354.01 53.44Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.01 67.31C1354.01 69.85 1352.33 72.4 1348.96 74.34C1342.24 78.22 1331.33 78.22 1324.6 74.34C1321.24 72.39 1319.56 69.85 1319.56 67.31",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.01 81.38C1354.01 83.94 1352.33 86.48 1348.96 88.42C1342.24 92.3 1331.33 92.3 1324.6 88.42C1321.24 86.48 1319.56 83.94 1319.56 81.38",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.01 95.46C1354.01 98 1352.33 100.55 1348.96 102.49C1342.24 106.37 1331.33 106.37 1324.6 102.49C1321.24 100.54 1319.56 98 1319.56 95.46",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.01 53.44V109.53C1354.01 112.08 1352.33 114.62 1348.96 116.56C1342.24 120.44 1331.33 120.44 1324.6 116.56C1321.24 114.62 1319.56 112.08 1319.56 109.53V53.44",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.62 212.58V226.18L586.84 250.87V228.72L629.62 204.02V212.58Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.891 227.18L586.841 266.46L518.801 227.18L544.071 212.58V226.18L586.841 250.87L629.621 226.18V212.58L654.891 227.18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.84 228.72V250.87L544.07 226.18V204.02L586.84 228.72Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.801 383.81V227.18L586.841 266.46V423.1",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.84 423.1V266.46L654.89 227.18V383.81",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.239 197.9C599.579 200.41 599.579 204.48 595.239 206.99C590.899 209.5 583.849 209.5 579.489 206.99C575.149 204.48 575.149 200.42 579.489 197.9C583.839 195.39 590.889 195.39 595.239 197.9Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.62 204.02L586.84 228.71L544.07 204.02L586.84 179.32L629.62 204.02ZM595.24 206.99C599.58 204.48 599.58 200.42 595.24 197.9C590.9 195.39 583.85 195.39 579.49 197.9C575.15 200.41 575.15 204.48 579.49 206.99C583.84 209.5 590.89 209.5 595.24 206.99Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.441 236.78L518.801 227.18L544.071 212.58",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.62 212.58L654.89 227.18L586.84 266.46L572.24 258.02",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.84 266.46V423.1",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.801 383.81V227.18",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.891 227.18V383.81",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.62 204.02L586.84 228.72L544.07 204.02L586.84 179.32L629.62 204.02Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.84 228.72V250.87",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.62 204.02V226.18L586.84 250.87L544.07 226.18V204.02",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.239 197.9C599.579 200.41 599.579 204.48 595.239 206.99C590.899 209.5 583.849 209.5 579.489 206.99C575.149 204.48 575.149 200.42 579.489 197.9C583.839 195.39 590.889 195.39 595.239 197.9Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.239 258.02L535.439 236.78",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.56 288.74L534.76 267.49",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.56 310.24L534.76 288.99",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.56 331.74L534.76 310.49",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.56 353.24L534.76 331.99",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.56 374.74L534.76 353.49",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.289 400.51L643.369 351.96L727.449 400.51",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.709 400.51L643.369 362.78L578.029 400.51",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.989 407.84L643.369 376.96V362.78L708.709 400.51",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.029 400.51L643.369 362.78V376.96L590.749 407.84",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.029 400.51L643.369 362.78V376.96L590.749 407.84",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.289 400.51L643.369 351.96L727.449 400.51",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.029 400.51L643.369 362.78L708.709 400.51",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.369 362.78V376.96",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.941 391.46C533.941 374.53 520.221 360.81 503.291 360.81C486.361 360.81 472.641 374.53 472.641 391.46",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.941 391.46C533.941 374.53 520.221 360.81 503.291 360.81C486.361 360.81 472.641 374.53 472.641 391.46",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.279 305.9C622.169 306.7 622.109 307.5 622.109 308.27C622.109 311.98 623.439 314.56 625.579 315.7L634.669 320.58C633.099 319.71 631.979 318.06 631.509 315.76C631.349 314.98 631.269 314.12 631.269 313.18C631.269 305.94 636.349 297.12 642.629 293.5C643.049 293.26 643.459 293.05 643.859 292.87C644.739 284.29 650.699 274.62 657.929 270.45C659.399 269.6 660.819 269.04 662.149 268.75C664.219 268.29 666.079 268.5 667.629 269.27L658.609 264.43C656.059 263.06 652.589 263.31 648.759 265.53C641.539 269.7 635.579 279.38 634.699 287.95C634.289 288.13 633.889 288.34 633.469 288.58C630.539 290.27 627.859 293.1 625.839 296.37C623.999 299.35 622.719 302.69 622.269 305.88L622.279 305.9Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.27 313.18C631.27 314.12 631.36 314.98 631.51 315.76C631.98 318.06 633.1 319.71 634.67 320.58L634.73 320.61C635.76 321.17 636.98 321.39 638.33 321.25C639.32 321.15 640.39 320.84 641.5 320.33C641.87 320.16 642.24 319.96 642.62 319.74L671.51 303.06C676.88 299.96 681.24 292.41 681.24 286.2C681.24 279.99 677.17 277.65 672.04 280.29C672.04 280.29 672.03 280.29 672.02 280.29C672.02 280.25 672.02 280.21 672.03 280.17C672.07 279.65 672.09 279.13 672.09 278.62C672.09 274 670.43 270.78 667.76 269.34L667.62 269.26C666.08 268.48 664.21 268.28 662.14 268.74C660.81 269.03 659.39 269.59 657.92 270.44C650.7 274.61 644.74 284.29 643.85 292.86C643.44 293.05 643.03 293.25 642.62 293.49C636.35 297.11 631.26 305.93 631.26 313.17L631.27 313.18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.63 269.28L667.77 269.36C670.44 270.79 672.1 274.01 672.1 278.64C672.1 279.15 672.07 279.67 672.04 280.19C672.04 280.23 672.04 280.27 672.03 280.31C672.03 280.31 672.04 280.31 672.05 280.31C677.18 277.67 681.25 280.22 681.25 286.22C681.25 292.22 676.9 299.97 671.52 303.08C671.52 303.08 641.88 320.17 641.51 320.34C640.4 320.86 639.34 321.16 638.34 321.26C636.99 321.4 635.77 321.18 634.74 320.62L634.68 320.59",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.629 269.28C666.089 268.5 664.219 268.3 662.149 268.76C660.819 269.05 659.399 269.61 657.929 270.46C650.709 274.63 644.749 284.31 643.859 292.88C643.449 293.07 643.039 293.27 642.629 293.51C636.359 297.13 631.269 305.95 631.269 313.19C631.269 314.13 631.359 314.99 631.509 315.77C631.979 318.07 633.099 319.72 634.669 320.59L625.579 315.71C623.439 314.56 622.109 311.98 622.109 308.28C622.109 307.5 622.169 306.71 622.279 305.91C622.719 302.72 624.009 299.38 625.849 296.4C627.859 293.13 630.539 290.3 633.479 288.61C633.899 288.37 634.299 288.16 634.709 287.98C635.589 279.4 641.549 269.73 648.769 265.56C652.599 263.35 656.069 263.09 658.619 264.46L667.639 269.3L667.629 269.28Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.42 45.0998C717.19 46.7398 717.08 48.3598 717.08 49.9498C717.08 57.5198 719.8 62.7798 724.17 65.1298L742.73 75.0998C739.52 73.3198 737.23 69.9498 736.27 65.2498C735.95 63.6498 735.77 61.8898 735.77 59.9798C735.77 45.1898 746.15 27.1998 758.96 19.7998C759.81 19.3098 760.65 18.8898 761.48 18.5098C763.28 0.999817 775.45 -18.7502 790.19 -27.2602C793.2 -28.9902 796.09 -30.1402 798.81 -30.7202C803.03 -31.6502 806.84 -31.2402 810 -29.6502L791.59 -39.5302C786.39 -42.3202 779.3 -41.8102 771.48 -37.2902C756.74 -28.7802 744.57 -9.02018 742.78 8.47982C741.95 8.84982 741.12 9.28981 740.27 9.76981C734.28 13.2298 728.81 18.9998 724.7 25.6798C720.95 31.7598 718.32 38.5798 717.42 45.0998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.78 59.9798C735.78 61.8898 735.96 63.6498 736.28 65.2498C737.24 69.9498 739.53 73.3198 742.74 75.0998L742.87 75.1598C744.98 76.2998 747.47 76.7498 750.22 76.4598C752.25 76.2498 754.42 75.6298 756.68 74.5698C757.43 74.2198 758.2 73.8198 758.96 73.3698L817.95 39.3298C828.92 32.9898 837.81 17.5798 837.81 4.9198C837.81 -7.7402 829.5 -12.5402 819.03 -7.1402C819.02 -7.1302 819.01 -7.1202 818.99 -7.1202C819 -7.2102 819.01 -7.28019 819.01 -7.38019C819.08 -8.44019 819.13 -9.5002 819.13 -10.5502C819.13 -19.9902 815.74 -26.5702 810.28 -29.4902L809.99 -29.6502C806.84 -31.2402 803.03 -31.6502 798.8 -30.7202C796.08 -30.1402 793.19 -28.9902 790.18 -27.2602C775.43 -18.7502 763.27 1.00981 761.47 18.5098C760.64 18.8898 759.8 19.3198 758.95 19.7998C746.14 27.1898 735.76 45.1898 735.76 59.9798H735.78Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810 -29.6502L810.29 -29.4902C815.75 -26.5602 819.14 -19.9902 819.14 -10.5502C819.14 -9.50022 819.09 -8.4402 819.02 -7.3802C819.02 -7.2902 819.01 -7.21021 819 -7.12021C819.02 -7.12021 819.03 -7.12021 819.04 -7.14021C829.51 -12.5302 837.82 -7.33022 837.82 4.91978C837.82 17.1698 828.93 32.9898 817.96 39.3298C817.96 39.3298 757.44 74.2198 756.69 74.5698C754.43 75.6198 752.26 76.2498 750.23 76.4598C747.47 76.7498 744.99 76.2998 742.88 75.1598L742.75 75.0998",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810 -29.6502C806.85 -31.2402 803.04 -31.6502 798.81 -30.7202C796.09 -30.1402 793.2 -28.9902 790.19 -27.2602C775.44 -18.7502 763.28 1.00982 761.48 18.5098C760.65 18.8898 759.81 19.3198 758.96 19.7998C746.15 27.1898 735.77 45.1898 735.77 59.9798C735.77 61.8898 735.95 63.6498 736.27 65.2498C737.23 69.9498 739.52 73.3198 742.73 75.0998L724.17 65.1298C719.79 62.7898 717.08 57.5198 717.08 49.9498C717.08 48.3598 717.19 46.7398 717.42 45.0998C718.33 38.5798 720.96 31.7598 724.7 25.6798C728.81 18.9998 734.28 13.2198 740.27 9.76981C741.12 9.27981 741.95 8.84982 742.78 8.47982C744.58 -9.03018 756.74 -28.7802 771.48 -37.2902C779.3 -41.8102 786.38 -42.3202 791.59 -39.5302L810 -29.6502Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.26 157.02V179.06L667.18 194.11V183.87",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.219 186.58V170.45",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.85 4.44977V13.7998C970.85 15.3598 969.82 16.9198 967.76 18.0998L934.25 37.4598C930.14 39.8298 923.47 39.8298 919.35 37.4598L885.83 18.0998C883.77 16.9198 882.75 15.3598 882.75 13.7998V4.33978C882.75 5.89978 883.77 7.44977 885.83 8.63977L919.35 27.9898C923.46 30.3698 930.13 30.3698 934.25 27.9898L967.76 8.63977C969.78 7.47977 970.81 5.95977 970.85 4.44977Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.85 4.33979V4.44978C970.81 5.96978 969.79 7.47978 967.76 8.63978L934.25 27.9898C930.14 30.3698 923.47 30.3698 919.35 27.9898L885.83 8.63978C883.77 7.44978 882.75 5.89979 882.75 4.33979C882.75 2.77979 883.77 1.22979 885.83 0.0397873L917.47 -18.2202C916.56 -13.5802 914.95 -8.17022 912.15 -3.17022C912.15 -3.17022 912.15 -3.15022 912.13 -3.14022C911.69 -2.58022 911.34 -2.00021 911.1 -1.41021C911.1 -1.41021 911.1 -1.41022 911.1 -1.39022C909.85 1.64978 911.29 4.97979 915.39 7.33979C921.69 10.9798 931.91 10.9798 938.21 7.33979C942.32 4.96979 943.74 1.64978 942.5 -1.39022C942.5 -1.39022 942.5 -1.39021 942.5 -1.41021C942.26 -2.01021 941.91 -2.60022 941.45 -3.17022C938.64 -8.17022 937.04 -13.5802 936.13 -18.2202L967.76 0.0397873C969.82 1.22979 970.85 2.77979 970.85 4.33979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.511 -1.40019C943.751 1.63981 942.321 4.9698 938.221 7.3298C931.921 10.9698 921.701 10.9698 915.401 7.3298C911.291 4.9598 909.861 1.63981 911.111 -1.40019C911.111 -1.40019 911.111 -1.4002 911.111 -1.4202C911.471 -1.9902 911.811 -2.56019 912.141 -3.15019C912.141 -3.15019 912.141 -3.17019 912.161 -3.18019C914.961 -8.18019 916.571 -13.5902 917.481 -18.2302C918.791 -24.9202 918.691 -30.0102 918.691 -30.0102C921.341 -29.5802 924.051 -29.3602 926.811 -29.3602C929.571 -29.3602 932.271 -29.5802 934.931 -30.0102C934.931 -30.0102 934.811 -24.9102 936.141 -18.2302C937.051 -13.5902 938.671 -8.19019 941.461 -3.18019C941.791 -2.59019 942.131 -2.0002 942.511 -1.4202C942.511 -1.4202 942.511 -1.42019 942.511 -1.40019Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.85 4.44978C970.81 5.96978 969.79 7.47978 967.76 8.63978L934.25 27.9898C930.14 30.3698 923.47 30.3698 919.35 27.9898L885.83 8.63978C883.77 7.44978 882.75 5.89979 882.75 4.33979C882.75 2.77979 883.77 1.22979 885.83 0.0397873L917.47 -18.2202",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.131 -18.2202L967.761 0.0397873C969.821 1.22979 970.851 2.77979 970.851 4.33979",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.85 4.33978V13.7998C970.85 15.3598 969.82 16.9198 967.76 18.0998L934.25 37.4598C930.14 39.8298 923.47 39.8298 919.35 37.4598L885.83 18.0998C883.77 16.9198 882.75 15.3598 882.75 13.7998V4.33978",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.111 -1.41019C911.351 -2.00019 911.701 -2.5802 912.141 -3.1402",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.511 -1.40021C943.751 1.63979 942.321 4.96979 938.221 7.32979C931.921 10.9698 921.701 10.9698 915.401 7.32979C911.291 4.95979 909.861 1.63979 911.111 -1.40021",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.451 -3.17023C941.901 -2.60023 942.261 -2.02022 942.501 -1.41022",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.93 -30.0002C934.93 -30.0002 934.82 -24.9002 936.14 -18.2202C937.05 -13.5802 938.67 -8.18019 941.46 -3.17019C941.79 -2.58019 942.13 -1.99018 942.51 -1.41018C942.51 -1.41018 942.51 -1.41019 942.51 -1.39019",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.682 -30.0002C918.682 -30.0002 918.792 -24.9002 917.472 -18.2202C916.562 -13.5802 914.952 -8.17019 912.152 -3.17019C912.152 -3.17019 912.152 -3.15019 912.132 -3.14019C911.802 -2.55019 911.462 -1.98018 911.102 -1.41018C911.102 -1.41018 911.102 -1.41019 911.102 -1.39019",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.06 199.46V222.05L1389.05 223.75V217.25L1380.24 211.51L1383.81 202.44L1396.06 199.46Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350.88 212.02C1352.79 210.48 1354.39 208.77 1355.61 206.92C1356.3 205.9 1356.86 204.83 1357.3 203.72C1362.24 191.19 1348.64 178.73 1326.94 175.89C1305.24 173.04 1283.65 180.89 1278.71 193.41C1276.87 198.09 1277.62 202.76 1280.4 206.91C1281.61 208.72 1283.2 210.43 1285.13 212C1290.67 216.52 1299 219.92 1309.08 221.24C1325.44 223.39 1341.74 219.45 1350.88 212V212.02ZM1394.5 189.57L1396.06 199.46L1383.81 202.43L1380.24 211.5L1389.05 217.24L1380.24 225.77L1367.31 224.02L1355.18 230.15L1356.47 237.78L1340.65 241.69L1331.97 235.89L1315.91 236.74L1309.19 243.35L1292.41 241.15L1291.29 233.51L1277.45 228.74L1265.27 231.8L1253.93 224.33L1260.81 217.77L1254.47 209.22L1241.49 207.57L1239.94 197.67L1252.18 194.7L1255.75 185.63L1246.94 179.89L1255.75 171.36L1268.68 173.11L1280.81 166.97L1279.51 159.34L1295.34 155.43L1304.01 161.23L1320.07 160.39L1326.79 153.78L1343.57 155.98L1344.69 163.62L1358.53 168.39L1370.71 165.32L1382.05 172.8L1375.17 179.36L1381.52 187.91L1382.03 187.97H1382.04L1394.49 189.56L1394.5 189.57Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.05 217.25V239.83L1380.24 248.36V225.78L1389.05 217.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.06 172.8V187.98H1382.04L1381.53 187.92L1375.18 179.37L1382.06 172.8Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.24 234.09V248.36L1367.31 246.61L1356.47 252.09V237.79L1355.18 230.16L1367.31 224.03L1380.24 225.78V234.09Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.93 175.89C1348.63 178.73 1362.22 191.19 1357.29 203.72C1356.86 204.83 1356.29 205.89 1355.6 206.92C1354.38 208.77 1352.78 210.48 1350.87 212.02C1345.33 207.51 1337 204.11 1326.93 202.79C1310.57 200.64 1294.26 204.58 1285.12 212.01C1283.19 210.44 1281.6 208.73 1280.39 206.92C1277.61 202.77 1276.87 198.1 1278.7 193.42C1283.64 180.89 1305.22 173.04 1326.93 175.9V175.89Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.47 252.09V260.38L1340.65 264.29V241.7L1356.47 237.79V252.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.65 241.7V264.29L1331.97 258.48L1315.91 259.32L1309.19 265.95V243.36L1315.91 236.75L1331.97 235.9L1340.65 241.7Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1309.19 243.36V265.95L1292.41 263.74V241.16L1309.19 243.36Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.41 241.16V263.74L1291.29 256.09L1277.45 251.33L1265.28 254.4V231.81L1277.45 228.75L1291.29 233.52L1292.41 241.16Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265.28 231.81V254.4L1253.94 246.92V224.34L1265.28 231.81Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.02 195.96L1246.95 195.97V195.96V179.89L1255.76 185.64L1252.19 194.7L1247.02 195.96Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.5 207.58L1254.48 209.23L1260.82 217.78L1253.94 224.34V231.74L1241.5 230.16L1239.94 220.26V197.68L1241.5 207.58Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.05 217.25L1380.24 211.51L1383.81 202.44L1396.06 199.46L1394.5 189.57L1382.06 187.98H1382.04L1381.53 187.92L1375.18 179.37L1382.06 172.8L1370.72 165.33L1358.55 168.4L1344.71 163.63L1343.59 155.99L1326.81 153.79L1320.09 160.4L1304.02 161.24L1295.35 155.43L1279.52 159.35L1280.82 166.98L1268.69 173.12L1255.76 171.36L1246.95 179.89L1255.76 185.64L1252.19 194.7L1239.94 197.68L1241.5 207.58L1254.48 209.23L1260.82 217.78L1253.94 224.34L1265.28 231.81L1277.45 228.75L1291.29 233.52L1292.41 241.16L1309.19 243.36L1315.91 236.75L1331.97 235.9L1340.65 241.7L1356.47 237.79L1355.18 230.16L1367.31 224.03L1380.24 225.78L1389.05 217.25Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.12 212.01C1283.19 210.44 1281.6 208.73 1280.39 206.92C1277.61 202.77 1276.87 198.1 1278.7 193.42C1283.64 180.89 1305.22 173.04 1326.93 175.9C1348.63 178.74 1362.22 191.2 1357.29 203.73C1356.86 204.84 1356.29 205.9 1355.6 206.93C1354.38 208.78 1352.78 210.48 1350.87 212.03C1341.71 219.46 1325.43 223.41 1309.07 221.27C1298.99 219.95 1290.66 216.55 1285.12 212.03V212.01Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.12 212.02C1294.26 204.59 1310.57 200.64 1326.93 202.79C1337.01 204.11 1345.34 207.51 1350.87 212.02",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.94 197.68V220.26L1241.5 230.16L1253.94 231.74",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.95 179.89V195.96",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265.28 231.81V254.4",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.41 241.16V263.74",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1309.19 243.36V265.95",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.65 241.7V264.29",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.47 237.79V260.38L1340.65 264.29L1331.97 258.48L1315.91 259.32L1309.19 265.95L1292.41 263.74L1291.29 256.09L1277.45 251.33L1265.28 254.4L1253.94 246.92V224.34",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.06 199.46V222.05L1389.05 223.75",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.24 225.78V248.36",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.05 217.25V239.83L1380.24 248.36L1367.31 246.61L1356.47 252.09",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.06 172.8V187.98",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1359.4 409.7L1253.64 348.63C1253.39 348.49 1253.27 348.3 1253.27 348.1V355.71C1253.27 355.91 1253.39 356.1 1253.64 356.25L1359.4 417.32",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1359.4 409.7L1253.64 348.63C1253.39 348.49 1253.27 348.3 1253.27 348.1V355.71C1253.27 355.91 1253.39 356.1 1253.64 356.25L1359.4 417.32",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.51 417.22L1430.81 377.21C1431.16 377.01 1431.33 376.76 1431.33 376.52V368.9C1431.33 369.14 1431.15 369.39 1430.81 369.59L1361.51 409.6",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.51 417.22L1430.81 377.21C1431.16 377.01 1431.33 376.76 1431.33 376.52V368.9C1431.33 369.14 1431.15 369.39 1430.81 369.59L1361.51 409.6",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1359.4 409.7L1253.64 348.63C1253.39 348.49 1253.27 348.3 1253.27 348.1C1253.27 347.86 1253.45 347.6 1253.8 347.4L1323.1 307.39C1323.72 307.03 1324.66 306.99 1325.21 307.3L1430.59 368.14H1430.61L1430.99 368.36C1431.23 368.5 1431.36 368.69 1431.36 368.89C1431.36 369.13 1431.18 369.38 1430.84 369.58L1361.54 409.59",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.96 346.54C1294.4 346.8 1295.17 346.76 1295.68 346.47L1300.4 343.75C1300.91 343.45 1300.96 343.01 1300.52 342.75L1295.56 339.88C1295.12 339.63 1294.35 339.66 1293.84 339.95L1289.12 342.68C1288.61 342.97 1288.56 343.42 1289 343.67L1293.97 346.54H1293.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1314.89 346.79C1315.33 347.04 1316.1 347.01 1316.61 346.72L1321.33 344C1321.84 343.71 1321.89 343.26 1321.45 343.01L1305.8 333.97C1305.36 333.72 1304.59 333.75 1304.08 334.04L1299.36 336.77C1298.85 337.06 1298.8 337.5 1299.24 337.76L1314.89 346.8V346.79Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.65 352.71C1305.09 352.96 1305.87 352.93 1306.37 352.64L1311.09 349.92C1311.6 349.62 1311.65 349.18 1311.21 348.92L1306.24 346.05C1305.8 345.79 1305.03 345.83 1304.52 346.12L1299.8 348.85C1299.29 349.14 1299.24 349.59 1299.68 349.84L1304.64 352.71H1304.65Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.69 377.56C1348.13 377.82 1348.9 377.78 1349.41 377.49L1354.13 374.77C1354.64 374.47 1354.7 374.03 1354.25 373.77L1316.94 352.23C1316.5 351.97 1315.73 352.01 1315.22 352.3L1310.5 355.03C1309.99 355.32 1309.93 355.77 1310.38 356.02L1347.69 377.56Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.39 334.18C1315.83 334.43 1316.6 334.4 1317.11 334.1L1321.83 331.38C1322.34 331.08 1322.39 330.64 1321.95 330.38L1316.98 327.51C1316.54 327.26 1315.77 327.29 1315.26 327.58L1310.54 330.31C1310.03 330.6 1309.98 331.04 1310.42 331.3L1315.38 334.18H1315.39Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.65 353C1326.09 353.25 1326.86 353.22 1327.37 352.93L1332.09 350.21C1332.6 349.91 1332.66 349.47 1332.21 349.21L1327.24 346.34C1326.8 346.08 1326.03 346.12 1325.52 346.41L1320.8 349.14C1320.28 349.43 1320.23 349.88 1320.68 350.14L1325.64 353.01L1325.65 353Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.11 340.36C1326.55 340.62 1327.32 340.58 1327.83 340.29L1332.55 337.56C1333.06 337.27 1333.11 336.82 1332.67 336.57L1327.71 333.7C1327.27 333.45 1326.5 333.48 1325.99 333.77L1321.27 336.49C1320.76 336.79 1320.71 337.23 1321.15 337.49L1326.12 340.36H1326.11Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.58 327.72C1327.01 327.97 1327.79 327.94 1328.3 327.64L1333.02 324.92C1333.53 324.62 1333.58 324.18 1333.14 323.92L1328.17 321.05C1327.73 320.8 1326.96 320.83 1326.45 321.12L1321.73 323.85C1321.22 324.14 1321.17 324.58 1321.61 324.84L1326.58 327.72Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336.37 359.19C1336.81 359.44 1337.58 359.41 1338.08 359.12L1342.8 356.39C1343.31 356.1 1343.37 355.66 1342.92 355.4L1337.95 352.53C1337.51 352.27 1336.74 352.3 1336.24 352.6L1331.52 355.33C1331.01 355.62 1330.96 356.07 1331.4 356.32L1336.37 359.19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336.83 346.55C1337.27 346.8 1338.04 346.77 1338.55 346.48L1343.27 343.76C1343.78 343.46 1343.83 343.02 1343.39 342.76L1338.42 339.89C1337.98 339.63 1337.21 339.67 1336.71 339.96L1331.99 342.69C1331.47 342.98 1331.42 343.43 1331.87 343.69L1336.83 346.56V346.55Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337.29 333.9C1337.73 334.16 1338.5 334.12 1339.01 333.83L1343.73 331.1C1344.24 330.81 1344.29 330.36 1343.85 330.11L1338.88 327.24C1338.44 326.99 1337.67 327.02 1337.16 327.31L1332.44 330.03C1331.93 330.33 1331.88 330.77 1332.32 331.03L1337.29 333.9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.09 365.38C1347.53 365.63 1348.3 365.6 1348.81 365.3L1353.53 362.58C1354.04 362.29 1354.09 361.85 1353.65 361.59L1348.68 358.72C1348.24 358.47 1347.47 358.5 1346.96 358.8L1342.24 361.52C1341.73 361.82 1341.68 362.26 1342.12 362.52L1347.09 365.39V365.38Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.55 352.74C1347.99 352.99 1348.76 352.96 1349.26 352.67L1353.98 349.94C1354.5 349.65 1354.55 349.2 1354.1 348.95L1349.13 346.08C1348.7 345.82 1347.92 345.85 1347.42 346.15L1342.7 348.88C1342.19 349.17 1342.13 349.62 1342.58 349.87L1347.55 352.74Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1348.02 340.09C1348.45 340.34 1349.23 340.31 1349.73 340.02L1354.45 337.3C1354.96 337 1355.01 336.56 1354.57 336.3L1349.6 333.43C1349.16 333.17 1348.39 333.21 1347.89 333.5L1343.17 336.23C1342.65 336.52 1342.6 336.97 1343.05 337.23L1348.02 340.1V340.09Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.81 371.57C1358.26 371.82 1359.02 371.79 1359.53 371.5L1364.25 368.77C1364.76 368.48 1364.81 368.04 1364.37 367.78L1359.4 364.91C1358.96 364.66 1358.19 364.69 1357.68 364.98L1352.96 367.71C1352.45 368 1352.4 368.44 1352.84 368.7L1357.8 371.57H1357.81Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.27 358.93C1358.71 359.18 1359.48 359.15 1359.99 358.85L1364.71 356.13C1365.22 355.84 1365.27 355.4 1364.83 355.14L1359.86 352.27C1359.42 352.02 1358.65 352.05 1358.14 352.35L1353.42 355.07C1352.91 355.37 1352.86 355.81 1353.3 356.07L1358.27 358.94V358.93Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.74 346.28C1359.18 346.53 1359.95 346.5 1360.45 346.21L1365.17 343.48C1365.69 343.19 1365.74 342.74 1365.29 342.49L1360.33 339.62C1359.89 339.36 1359.12 339.39 1358.61 339.69L1353.89 342.42C1353.38 342.71 1353.32 343.16 1353.77 343.41L1358.74 346.28Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1368.99 365.12C1369.43 365.37 1370.2 365.34 1370.71 365.05L1375.43 362.32C1375.94 362.03 1375.99 361.59 1375.55 361.33L1370.58 358.46C1370.14 358.21 1369.37 358.24 1368.86 358.53L1364.14 361.26C1363.63 361.55 1363.58 361.99 1364.02 362.25L1368.99 365.12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.45 352.47C1369.89 352.72 1370.66 352.69 1371.17 352.39L1375.89 349.67C1376.4 349.38 1376.45 348.93 1376.01 348.68L1371.04 345.81C1370.6 345.56 1369.83 345.59 1369.32 345.89L1364.6 348.61C1364.09 348.91 1364.04 349.35 1364.48 349.61L1369.44 352.48L1369.45 352.47Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1379.71 371.31C1380.15 371.56 1380.92 371.53 1381.43 371.24L1386.15 368.51C1386.66 368.22 1386.72 367.77 1386.27 367.51L1381.3 364.64C1380.86 364.39 1380.09 364.42 1379.58 364.72L1374.86 367.44C1374.35 367.73 1374.29 368.18 1374.74 368.43L1379.71 371.3V371.31Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.17 358.66C1380.61 358.91 1381.38 358.88 1381.89 358.59L1386.61 355.86C1387.12 355.57 1387.17 355.13 1386.73 354.87L1381.77 352C1381.32 351.75 1380.56 351.78 1380.05 352.07L1375.33 354.8C1374.82 355.09 1374.77 355.53 1375.21 355.79L1380.18 358.66H1380.17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.89 364.85C1391.33 365.1 1392.1 365.07 1392.61 364.78L1397.33 362.05C1397.84 361.76 1397.89 361.31 1397.45 361.05L1392.48 358.18C1392.04 357.93 1391.27 357.96 1390.76 358.26L1386.04 360.98C1385.53 361.27 1385.47 361.72 1385.92 361.98L1390.88 364.85H1390.89Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1401.62 371.04C1402.06 371.29 1402.83 371.27 1403.33 370.97L1408.05 368.25C1408.56 367.95 1408.62 367.51 1408.17 367.25L1403.2 364.38C1402.76 364.13 1401.99 364.16 1401.49 364.45L1396.77 367.18C1396.26 367.47 1396.2 367.91 1396.65 368.17L1401.62 371.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1289.12 342.68C1288.61 342.97 1288.56 343.42 1289 343.67L1293.97 346.54C1294.41 346.8 1295.18 346.76 1295.69 346.47L1300.41 343.75C1300.92 343.45 1300.97 343.01 1300.53 342.75L1295.57 339.88C1295.13 339.63 1294.36 339.66 1293.85 339.95L1289.13 342.68H1289.12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.37 336.77C1298.86 337.06 1298.81 337.5 1299.25 337.76L1314.9 346.8C1315.34 347.05 1316.11 347.02 1316.62 346.73L1321.34 344.01C1321.85 343.72 1321.9 343.27 1321.46 343.02L1305.81 333.98C1305.37 333.73 1304.6 333.76 1304.09 334.05L1299.37 336.78V336.77Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.8 348.85C1299.29 349.14 1299.24 349.59 1299.68 349.84L1304.64 352.71C1305.08 352.96 1305.86 352.93 1306.36 352.64L1311.08 349.92C1311.59 349.62 1311.64 349.18 1311.2 348.92L1306.23 346.05C1305.79 345.79 1305.02 345.83 1304.51 346.12L1299.79 348.85H1299.8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.5 355.02C1309.99 355.31 1309.93 355.76 1310.38 356.01L1347.69 377.55C1348.13 377.81 1348.9 377.77 1349.41 377.48L1354.13 374.76C1354.64 374.46 1354.7 374.02 1354.25 373.76L1316.94 352.22C1316.5 351.96 1315.73 352 1315.22 352.29L1310.5 355.02Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.55 330.31C1310.04 330.6 1309.99 331.04 1310.43 331.3L1315.39 334.18C1315.83 334.43 1316.6 334.4 1317.11 334.1L1321.83 331.38C1322.34 331.08 1322.39 330.64 1321.95 330.38L1316.98 327.51C1316.54 327.26 1315.77 327.29 1315.26 327.58L1310.54 330.31H1310.55Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.81 349.14C1320.29 349.43 1320.24 349.88 1320.69 350.14L1325.65 353.01C1326.09 353.26 1326.86 353.23 1327.37 352.94L1332.09 350.22C1332.6 349.92 1332.66 349.48 1332.21 349.22L1327.24 346.35C1326.8 346.09 1326.03 346.13 1325.52 346.42L1320.8 349.15L1320.81 349.14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321.27 336.49C1320.76 336.79 1320.71 337.23 1321.15 337.49L1326.12 340.36C1326.56 340.62 1327.33 340.58 1327.84 340.29L1332.56 337.56C1333.07 337.27 1333.12 336.82 1332.68 336.57L1327.72 333.7C1327.28 333.45 1326.51 333.48 1326 333.77L1321.28 336.49H1321.27Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321.73 323.86C1321.22 324.15 1321.17 324.59 1321.61 324.85L1326.58 327.73C1327.01 327.98 1327.79 327.95 1328.3 327.65L1333.02 324.93C1333.53 324.63 1333.58 324.19 1333.14 323.93L1328.17 321.06C1327.73 320.81 1326.96 320.84 1326.45 321.13L1321.73 323.86Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324.56 224.6H1324.58C1324.75 224.5 1324.96 224.52 1325.2 224.65L1430.58 285.49C1430.58 285.49 1430.59 285.5 1430.6 285.49L1430.98 285.71C1431.23 285.85 1431.45 286.1 1431.62 286.4C1431.83 286.76 1431.96 287.19 1431.96 287.59V367.61C1431.96 368 1431.83 368.28 1431.62 368.41C1431.45 368.51 1431.22 368.5 1430.98 368.36L1430.6 368.14C1430.6 368.14 1430.59 368.14 1430.58 368.14L1325.2 307.3C1324.96 307.16 1324.74 306.91 1324.57 306.61C1324.36 306.25 1324.22 305.81 1324.22 305.42V225.4C1324.22 225.01 1324.35 224.73 1324.56 224.6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1329.03 222.02L1324.58 224.59C1324.75 224.5 1324.96 224.52 1325.2 224.65L1430.58 285.49C1430.58 285.49 1430.59 285.5 1430.6 285.49L1430.98 285.71C1431.23 285.85 1431.45 286.1 1431.62 286.4C1431.83 286.76 1431.96 287.19 1431.96 287.59V367.61C1431.96 368 1431.83 368.28 1431.62 368.41L1436.09 365.83C1436.3 365.71 1436.43 365.43 1436.43 365.03V285.01C1436.43 284.61 1436.3 284.18 1436.09 283.82C1435.92 283.52 1435.69 283.28 1435.44 283.13L1435.06 282.91C1435.06 282.91 1435.06 282.91 1435.04 282.91L1329.66 222.07C1329.42 221.93 1329.19 221.92 1329.02 222.02H1329.03Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.53 355.33C1331.02 355.62 1330.97 356.07 1331.41 356.32L1336.38 359.19C1336.82 359.44 1337.59 359.41 1338.09 359.12L1342.81 356.39C1343.32 356.1 1343.38 355.66 1342.93 355.4L1337.96 352.53C1337.52 352.27 1336.75 352.3 1336.25 352.6L1331.53 355.33Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.99 342.69C1331.47 342.98 1331.42 343.43 1331.87 343.69L1336.83 346.56C1337.27 346.81 1338.04 346.78 1338.55 346.49L1343.27 343.77C1343.78 343.47 1343.83 343.03 1343.39 342.77L1338.42 339.9C1337.98 339.64 1337.21 339.68 1336.71 339.97L1331.99 342.7V342.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332.45 330.04C1331.94 330.34 1331.89 330.78 1332.33 331.04L1337.3 333.91C1337.74 334.17 1338.51 334.13 1339.02 333.84L1343.74 331.11C1344.25 330.82 1344.3 330.37 1343.86 330.12L1338.89 327.25C1338.45 327 1337.68 327.03 1337.17 327.32L1332.45 330.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342.24 361.52C1341.73 361.82 1341.68 362.26 1342.12 362.52L1347.09 365.39C1347.53 365.64 1348.3 365.61 1348.81 365.31L1353.53 362.59C1354.04 362.3 1354.09 361.86 1353.65 361.6L1348.68 358.73C1348.24 358.48 1347.47 358.51 1346.96 358.81L1342.24 361.53V361.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342.71 348.88C1342.2 349.17 1342.14 349.62 1342.59 349.87L1347.56 352.74C1348 352.99 1348.77 352.96 1349.27 352.67L1353.99 349.94C1354.51 349.65 1354.56 349.2 1354.11 348.95L1349.14 346.08C1348.71 345.82 1347.93 345.85 1347.43 346.15L1342.71 348.88Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343.17 336.23C1342.65 336.52 1342.6 336.97 1343.05 337.23L1348.02 340.1C1348.45 340.35 1349.23 340.32 1349.73 340.03L1354.45 337.31C1354.96 337.01 1355.01 336.57 1354.57 336.31L1349.6 333.44C1349.16 333.18 1348.39 333.22 1347.89 333.51L1343.17 336.24V336.23Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1352.97 367.71C1352.46 368 1352.41 368.44 1352.85 368.7L1357.81 371.57C1358.26 371.82 1359.02 371.79 1359.53 371.5L1364.25 368.77C1364.76 368.48 1364.81 368.04 1364.37 367.78L1359.4 364.91C1358.96 364.66 1358.19 364.69 1357.68 364.98L1352.96 367.71H1352.97Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.43 355.07C1352.92 355.37 1352.87 355.81 1353.31 356.07L1358.28 358.94C1358.72 359.19 1359.49 359.16 1360 358.86L1364.72 356.14C1365.23 355.85 1365.28 355.41 1364.84 355.15L1359.87 352.28C1359.43 352.03 1358.66 352.06 1358.15 352.36L1353.43 355.08V355.07Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.89 342.42C1353.38 342.71 1353.32 343.16 1353.77 343.41L1358.74 346.28C1359.18 346.53 1359.95 346.5 1360.45 346.21L1365.17 343.48C1365.69 343.19 1365.74 342.74 1365.29 342.49L1360.33 339.62C1359.89 339.36 1359.12 339.39 1358.61 339.69L1353.89 342.42Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.15 361.26C1363.64 361.55 1363.59 361.99 1364.03 362.25L1369 365.12C1369.44 365.37 1370.21 365.34 1370.72 365.05L1375.44 362.32C1375.95 362.03 1376 361.59 1375.56 361.33L1370.59 358.46C1370.15 358.21 1369.38 358.24 1368.87 358.53L1364.15 361.26Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.61 348.61C1364.1 348.91 1364.05 349.35 1364.49 349.61L1369.45 352.48C1369.89 352.73 1370.66 352.7 1371.17 352.4L1375.89 349.68C1376.4 349.39 1376.45 348.94 1376.01 348.69L1371.04 345.82C1370.6 345.57 1369.83 345.6 1369.32 345.9L1364.6 348.62L1364.61 348.61Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.87 367.45C1374.36 367.74 1374.3 368.19 1374.75 368.44L1379.72 371.31C1380.16 371.56 1380.93 371.53 1381.44 371.24L1386.16 368.51C1386.67 368.22 1386.73 367.77 1386.28 367.51L1381.31 364.64C1380.87 364.39 1380.1 364.42 1379.59 364.72L1374.87 367.44V367.45Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.33 354.8C1374.82 355.09 1374.77 355.53 1375.21 355.79L1380.18 358.66C1380.62 358.91 1381.39 358.88 1381.9 358.59L1386.62 355.86C1387.13 355.57 1387.18 355.13 1386.74 354.87L1381.78 352C1381.33 351.75 1380.57 351.78 1380.06 352.07L1375.34 354.8H1375.33Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.05 360.99C1385.54 361.28 1385.48 361.73 1385.93 361.99L1390.89 364.86C1391.33 365.11 1392.1 365.08 1392.61 364.79L1397.33 362.06C1397.84 361.77 1397.89 361.32 1397.45 361.06L1392.48 358.19C1392.04 357.94 1391.27 357.97 1390.76 358.27L1386.04 360.99H1386.05Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.77 367.18C1396.26 367.47 1396.2 367.91 1396.65 368.17L1401.62 371.04C1402.06 371.29 1402.83 371.27 1403.33 370.97L1408.05 368.25C1408.56 367.95 1408.62 367.51 1408.17 367.25L1403.2 364.38C1402.76 364.13 1401.99 364.16 1401.49 364.45L1396.77 367.18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.51 417.22L1430.81 377.21C1431.16 377.01 1431.33 376.76 1431.33 376.52V368.9",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.26 348.1V355.71C1253.26 355.91 1253.38 356.1 1253.63 356.25L1359.39 417.32",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.51 409.6L1430.81 369.59C1431.16 369.39 1431.33 369.14 1431.33 368.9C1431.33 368.7 1431.21 368.51 1430.96 368.37L1430.58 368.15C1430.58 368.15 1430.57 368.15 1430.56 368.15L1325.18 307.31C1324.64 307 1323.69 307.04 1323.07 307.4L1253.77 347.41C1253.42 347.61 1253.24 347.86 1253.24 348.11C1253.24 348.31 1253.36 348.5 1253.61 348.64L1359.37 409.71",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324.56 224.6C1324.35 224.72 1324.22 225 1324.22 225.4V305.42C1324.22 305.82 1324.36 306.26 1324.57 306.61C1324.74 306.91 1324.96 307.15 1325.2 307.3H1325.21",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1430.97 368.37C1431.21 368.51 1431.44 368.52 1431.61 368.42C1431.82 368.3 1431.95 368.02 1431.95 367.62V287.6C1431.95 287.2 1431.82 286.78 1431.61 286.41C1431.44 286.11 1431.22 285.87 1430.97 285.72L1430.59 285.5C1430.59 285.5 1430.59 285.5 1430.57 285.5L1325.19 224.66C1324.95 224.53 1324.74 224.51 1324.57 224.6",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324.56 224.6L1329.03 222.02C1329.2 221.92 1329.43 221.93 1329.67 222.07L1435.05 282.91C1435.05 282.91 1435.06 282.92 1435.07 282.91L1435.45 283.13C1435.7 283.27 1435.92 283.52 1436.1 283.82C1436.31 284.18 1436.44 284.6 1436.44 285.01V365.03C1436.44 365.43 1436.31 365.71 1436.1 365.83L1431.63 368.41",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1314.89 346.79L1299.24 337.75C1298.8 337.5 1298.85 337.05 1299.36 336.76L1304.08 334.03C1304.6 333.74 1305.36 333.7 1305.8 333.96L1321.45 343C1321.89 343.25 1321.83 343.7 1321.33 343.99L1316.61 346.71C1316.1 347 1315.33 347.04 1314.89 346.78V346.79Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.65 353L1320.69 350.13C1320.24 349.87 1320.3 349.43 1320.81 349.13L1325.53 346.4C1326.04 346.11 1326.81 346.07 1327.25 346.33L1332.22 349.2C1332.66 349.45 1332.61 349.9 1332.1 350.2L1327.38 352.92C1326.87 353.21 1326.1 353.25 1325.66 352.99L1325.65 353Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336.37 359.19L1331.4 356.32C1330.96 356.07 1331.01 355.62 1331.52 355.33L1336.24 352.6C1336.75 352.31 1337.52 352.27 1337.95 352.53L1342.92 355.4C1343.36 355.65 1343.31 356.1 1342.8 356.39L1338.08 359.12C1337.57 359.41 1336.8 359.44 1336.37 359.19Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.09 365.38L1342.12 362.51C1341.68 362.26 1341.74 361.81 1342.24 361.51L1346.96 358.79C1347.47 358.49 1348.24 358.46 1348.68 358.71L1353.65 361.58C1354.09 361.84 1354.03 362.28 1353.53 362.57L1348.81 365.29C1348.3 365.59 1347.53 365.62 1347.09 365.37V365.38Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.81 371.57L1352.85 368.7C1352.41 368.44 1352.47 368 1352.97 367.71L1357.69 364.98C1358.2 364.69 1358.97 364.65 1359.41 364.91L1364.38 367.78C1364.82 368.04 1364.76 368.48 1364.26 368.77L1359.54 371.5C1359.03 371.79 1358.26 371.83 1357.82 371.57H1357.81Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.39 334.18L1310.43 331.3C1309.99 331.05 1310.05 330.6 1310.55 330.31L1315.27 327.58C1315.78 327.29 1316.55 327.25 1316.99 327.51L1321.96 330.38C1322.4 330.63 1322.34 331.08 1321.84 331.38L1317.12 334.1C1316.61 334.4 1315.83 334.43 1315.4 334.18H1315.39Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.11 340.36L1321.14 337.49C1320.7 337.24 1320.76 336.79 1321.26 336.49L1325.98 333.77C1326.49 333.48 1327.26 333.45 1327.7 333.7L1332.66 336.57C1333.1 336.82 1333.05 337.27 1332.54 337.56L1327.82 340.29C1327.3 340.58 1326.54 340.62 1326.1 340.36H1326.11Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336.83 346.55L1331.87 343.68C1331.43 343.42 1331.48 342.98 1331.99 342.68L1336.71 339.95C1337.22 339.66 1337.99 339.62 1338.42 339.88L1343.39 342.75C1343.83 343 1343.78 343.45 1343.27 343.75L1338.55 346.47C1338.04 346.76 1337.27 346.8 1336.83 346.54V346.55Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.55 352.74L1342.58 349.87C1342.14 349.62 1342.19 349.17 1342.7 348.88L1347.42 346.15C1347.93 345.86 1348.7 345.82 1349.13 346.08L1354.1 348.95C1354.54 349.2 1354.49 349.65 1353.98 349.94L1349.26 352.67C1348.75 352.96 1347.98 352.99 1347.55 352.74Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.27 358.93L1353.3 356.06C1352.87 355.81 1352.92 355.36 1353.42 355.06L1358.14 352.34C1358.66 352.04 1359.42 352.01 1359.86 352.26L1364.83 355.13C1365.27 355.39 1365.21 355.83 1364.71 356.12L1359.99 358.84C1359.48 359.14 1358.71 359.17 1358.27 358.92V358.93Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1368.99 365.12L1364.02 362.25C1363.58 361.99 1363.64 361.55 1364.14 361.26L1368.86 358.53C1369.37 358.24 1370.14 358.2 1370.58 358.46L1375.55 361.33C1375.99 361.59 1375.93 362.03 1375.43 362.32L1370.71 365.05C1370.2 365.34 1369.43 365.38 1368.99 365.12Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1379.71 371.31L1374.74 368.44C1374.3 368.19 1374.35 367.74 1374.86 367.45L1379.58 364.73C1380.09 364.43 1380.86 364.4 1381.3 364.65L1386.27 367.52C1386.71 367.77 1386.66 368.22 1386.15 368.52L1381.43 371.25C1380.92 371.54 1380.15 371.58 1379.71 371.32V371.31Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1326.58 327.72L1321.61 324.84C1321.17 324.59 1321.23 324.14 1321.73 323.85L1326.45 321.12C1326.96 320.83 1327.73 320.79 1328.17 321.05L1333.14 323.92C1333.58 324.17 1333.52 324.62 1333.02 324.92L1328.3 327.64C1327.79 327.94 1327.01 327.97 1326.58 327.72Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337.29 333.9L1332.32 331.03C1331.88 330.78 1331.94 330.33 1332.44 330.03L1337.16 327.31C1337.67 327.02 1338.44 326.99 1338.88 327.24L1343.85 330.11C1344.28 330.36 1344.23 330.81 1343.73 331.1L1339.01 333.83C1338.49 334.12 1337.73 334.16 1337.29 333.9Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1348.02 340.09L1343.05 337.22C1342.61 336.96 1342.66 336.52 1343.17 336.22L1347.89 333.49C1348.4 333.2 1349.17 333.16 1349.6 333.42L1354.57 336.29C1355.01 336.54 1354.96 336.99 1354.45 337.29L1349.73 340.01C1349.22 340.3 1348.45 340.34 1348.02 340.08V340.09Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.74 346.28L1353.77 343.41C1353.33 343.16 1353.38 342.71 1353.89 342.42L1358.61 339.69C1359.12 339.4 1359.89 339.36 1360.33 339.62L1365.29 342.49C1365.73 342.74 1365.68 343.19 1365.17 343.48L1360.45 346.21C1359.94 346.5 1359.17 346.53 1358.74 346.28Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369.45 352.47L1364.49 349.6C1364.05 349.35 1364.1 348.9 1364.61 348.6L1369.33 345.88C1369.85 345.58 1370.61 345.55 1371.05 345.8L1376.02 348.67C1376.46 348.92 1376.4 349.37 1375.9 349.66L1371.18 352.38C1370.67 352.68 1369.89 352.71 1369.46 352.46L1369.45 352.47Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1380.17 358.66L1375.2 355.79C1374.76 355.53 1374.82 355.09 1375.32 354.8L1380.04 352.07C1380.55 351.78 1381.32 351.74 1381.76 352L1386.72 354.87C1387.16 355.13 1387.1 355.57 1386.6 355.86L1381.88 358.59C1381.37 358.88 1380.6 358.92 1380.16 358.66H1380.17Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.89 364.85L1385.93 361.98C1385.48 361.72 1385.54 361.27 1386.05 360.98L1390.77 358.26C1391.28 357.96 1392.05 357.93 1392.49 358.18L1397.46 361.05C1397.9 361.3 1397.85 361.75 1397.34 362.05L1392.62 364.78C1392.11 365.07 1391.34 365.11 1390.9 364.85H1390.89Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1401.62 371.04L1396.65 368.17C1396.21 367.92 1396.26 367.47 1396.77 367.18L1401.49 364.45C1402 364.16 1402.77 364.13 1403.2 364.38L1408.17 367.25C1408.61 367.5 1408.56 367.95 1408.05 368.25L1403.33 370.97C1402.82 371.27 1402.05 371.3 1401.62 371.04Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.96 346.54L1288.99 343.67C1288.55 343.42 1288.61 342.97 1289.11 342.68L1293.83 339.95C1294.34 339.66 1295.11 339.63 1295.55 339.88L1300.51 342.75C1300.95 343 1300.9 343.45 1300.39 343.75L1295.67 346.47C1295.15 346.76 1294.39 346.8 1293.95 346.54H1293.96Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.65 352.71L1299.69 349.84C1299.25 349.59 1299.3 349.14 1299.81 348.85L1304.53 346.12C1305.05 345.83 1305.82 345.79 1306.25 346.05L1311.22 348.92C1311.66 349.17 1311.6 349.62 1311.1 349.92L1306.38 352.64C1305.87 352.93 1305.1 352.96 1304.66 352.71H1304.65Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.69 377.56L1310.38 356.02C1309.94 355.77 1309.99 355.32 1310.5 355.03L1315.22 352.3C1315.73 352.01 1316.5 351.97 1316.94 352.23L1354.25 373.77C1354.7 374.02 1354.64 374.47 1354.13 374.77L1349.41 377.49C1348.9 377.78 1348.13 377.82 1347.69 377.56Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1349.34 258.7V300.62L1356.95 305.01V263.09L1349.34 258.7Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.42 273.48V307.59L1369.03 311.98V277.87L1361.42 273.48Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373.51 287.58V314.57L1381.11 318.96V291.97L1373.51 287.58Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385.59 285.06V321.54L1393.19 325.93V289.45L1385.59 285.06Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1397.67 308.6V328.52L1405.27 332.91V312.99L1397.67 308.6Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1397.67 328.52L1405.27 332.91V312.99L1397.67 308.6V328.52Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385.59 321.54L1393.19 325.93V289.45L1385.59 285.06V321.54Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373.51 314.57L1381.11 318.96V291.97L1373.51 287.58V314.57Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.42 307.59L1369.03 311.98V277.87L1361.42 273.48V307.59Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1349.34 300.62L1356.95 305.01V263.09L1349.34 258.7V300.62Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.58 404.79C1671.77 397.4 1665.37 387.71 1665.37 378.03V361.36C1665.37 371.05 1671.77 380.73 1684.58 388.13",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.58 404.79C1671.77 397.4 1665.37 387.71 1665.37 378.03V361.36C1665.37 371.05 1671.77 380.73 1684.58 388.13",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777.3 388.14C1790.09 380.74 1796.5 371.06 1796.5 361.37V378.04C1796.5 387.72 1790.09 397.41 1777.3 404.8",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777.3 388.14C1790.09 380.74 1796.5 371.06 1796.5 361.37V378.04C1796.5 387.72 1790.09 397.41 1777.3 404.8",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.17 341.29C1676.96 352.38 1676.96 370.36 1696.17 381.44C1715.37 392.53 1746.5 392.53 1765.71 381.44C1784.9 370.36 1784.9 352.38 1765.71 341.29C1756.15 335.78 1743.63 333.01 1731.1 332.98C1718.47 332.95 1705.81 335.72 1696.17 341.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.58 388.14C1671.77 380.74 1665.37 371.06 1665.37 361.37C1665.37 351.68 1671.77 342 1684.58 334.61C1697.42 327.2 1714.24 323.51 1731.06 323.53C1747.8 323.54 1764.53 327.24 1777.3 334.61C1790.09 341.99 1796.5 351.68 1796.5 361.37C1796.5 371.06 1790.09 380.74 1777.3 388.14",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1731.14 342.45C1722.68 342.42 1714.2 344.26 1707.75 347.99C1694.96 355.37 1694.96 367.36 1707.75 374.75C1720.56 382.15 1741.31 382.15 1754.12 374.75C1766.92 367.36 1766.92 355.38 1754.12 347.99C1747.77 344.33 1739.46 342.48 1731.14 342.45ZM1731.1 332.98C1743.63 333.01 1756.15 335.78 1765.71 341.29C1784.9 352.38 1784.9 370.36 1765.71 381.44C1746.5 392.53 1715.37 392.53 1696.17 381.44C1676.96 370.36 1676.96 352.38 1696.17 341.29C1705.81 335.72 1718.47 332.95 1731.1 332.98Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1731.19 351.91C1726.91 351.87 1722.61 352.79 1719.35 354.67C1712.96 358.37 1712.96 364.36 1719.35 368.06C1725.75 371.76 1736.13 371.76 1742.53 368.06C1748.94 364.36 1748.94 358.37 1742.53 354.67C1739.39 352.86 1735.3 351.94 1731.19 351.91ZM1754.12 347.99C1766.92 355.37 1766.92 367.36 1754.12 374.75C1741.31 382.15 1720.56 382.15 1707.75 374.75C1694.96 367.36 1694.96 355.38 1707.75 347.99C1714.21 344.26 1722.68 342.41 1731.14 342.45C1739.46 342.48 1747.76 344.33 1754.12 347.99Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.52 354.68C1748.93 358.38 1748.93 364.37 1742.52 368.07C1736.12 371.77 1725.74 371.77 1719.34 368.07C1712.95 364.37 1712.95 358.38 1719.34 354.68C1722.6 352.8 1726.9 351.87 1731.18 351.92C1735.29 351.95 1739.38 352.88 1742.52 354.68Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.64 225.44V257.96L1730.76 275.22V240.47L1742.64 225.44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730.76 240.47V275.22L1730.68 275.45L1718.72 271.76V239.24L1730.76 240.47Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.52 368.07C1748.93 364.37 1748.93 358.38 1742.52 354.68C1739.38 352.87 1735.29 351.95 1731.18 351.92C1726.9 351.88 1722.6 352.8 1719.34 354.68C1712.95 358.38 1712.95 364.37 1719.34 368.07C1725.74 371.77 1736.12 371.77 1742.52 368.07Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754.12 374.75C1766.92 367.36 1766.92 355.38 1754.12 347.99C1747.77 344.33 1739.46 342.48 1731.14 342.45C1722.68 342.42 1714.2 344.26 1707.75 347.99C1694.96 355.37 1694.96 367.36 1707.75 374.75C1720.56 382.15 1741.31 382.15 1754.12 374.75Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.71 381.44C1784.9 370.36 1784.9 352.38 1765.71 341.29C1756.15 335.78 1743.63 333.01 1731.1 332.98C1718.47 332.95 1705.81 335.72 1696.17 341.29C1676.96 352.38 1676.96 370.36 1696.17 381.44C1715.37 392.53 1746.5 392.53 1765.71 381.44Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777.3 388.14C1790.09 380.74 1796.5 371.06 1796.5 361.37C1796.5 351.68 1790.09 342 1777.3 334.61C1764.53 327.24 1747.81 323.54 1731.06 323.53C1714.24 323.51 1697.42 327.2 1684.58 334.61C1671.77 342 1665.37 351.69 1665.37 361.37C1665.37 371.05 1671.77 380.74 1684.58 388.14",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777.3 404.79C1790.09 397.4 1796.5 387.71 1796.5 378.03V361.36",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.37 361.37V378.04C1665.37 387.72 1671.77 397.41 1684.58 404.8",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730.76 360.7V240.47",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730.76 275.22L1730.68 275.45L1718.72 271.76V239.24L1730.76 240.47L1742.64 225.44V257.96L1730.76 275.22Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1936.96 381.94L1953.37 372.46C1956.75 370.51 1959.04 371.44 1959.26 374.85C1959.46 378.26 1961.75 379.18 1965.14 377.23L1971.96 373.29L1966.04 346.67L1901.36 384.01",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1971.97 373.29L1966.05 346.67L1901.36 384.01",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1594.01 220.88C1594.01 222.71 1593.36 223.99 1592.32 224.59L1588.47 226.81C1589.46 226.19 1590.07 224.94 1590.07 223.16C1590.07 219.52 1587.52 215.09 1584.36 213.27C1582.78 212.36 1581.36 212.27 1580.33 212.87L1584.27 210.59C1585.3 209.99 1586.73 210.07 1588.31 210.99C1591.46 212.81 1594.02 217.24 1594.02 220.88H1594.01Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1584.35 213.27C1587.5 215.09 1590.06 219.52 1590.06 223.16C1590.06 224.94 1589.45 226.19 1588.46 226.81L1588.38 226.86C1587.35 227.46 1585.93 227.38 1584.35 226.46C1581.2 224.64 1578.64 220.21 1578.64 216.57C1578.64 214.75 1579.28 213.47 1580.31 212.88C1581.34 212.28 1582.76 212.36 1584.34 213.28L1584.35 213.27Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1584.35 217.71C1585.38 218.31 1586.21 219.75 1586.21 220.94C1586.21 221.52 1586.01 221.93 1585.69 222.13H1585.67C1585.33 222.34 1584.87 222.31 1584.35 222.02C1583.32 221.42 1582.49 219.98 1582.49 218.79C1582.49 218.2 1582.7 217.78 1583.04 217.58C1583.38 217.38 1583.84 217.41 1584.36 217.71H1584.35Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1588.46 226.8C1589.45 226.18 1590.06 224.93 1590.06 223.15C1590.06 219.51 1587.51 215.08 1584.35 213.26C1582.77 212.35 1581.35 212.27 1580.32 212.86C1579.29 213.46 1578.65 214.74 1578.65 216.55C1578.65 220.19 1581.2 224.62 1584.36 226.44C1585.94 227.35 1587.36 227.44 1588.39 226.84",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1588.38 226.85L1592.31 224.59C1593.36 224 1594 222.71 1594 220.88C1594 217.24 1591.45 212.81 1588.29 210.99C1586.71 210.08 1585.28 209.99 1584.25 210.59L1580.31 212.87",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1644.24 249.88C1644.24 251.71 1643.59 252.99 1642.55 253.59L1638.7 255.81C1639.69 255.19 1640.3 253.94 1640.3 252.16C1640.3 248.52 1637.75 244.09 1634.59 242.27C1633.01 241.36 1631.59 241.27 1630.56 241.87L1634.5 239.59C1635.53 238.99 1636.96 239.07 1638.54 239.99C1641.69 241.81 1644.25 246.24 1644.25 249.88H1644.24Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.59 242.27C1637.74 244.09 1640.3 248.52 1640.3 252.16C1640.3 253.94 1639.69 255.19 1638.7 255.81L1638.62 255.86C1637.59 256.46 1636.17 256.38 1634.59 255.46C1631.44 253.64 1628.88 249.21 1628.88 245.57C1628.88 243.75 1629.52 242.47 1630.55 241.88C1631.58 241.28 1633 241.36 1634.58 242.28L1634.59 242.27Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.59 246.71C1635.62 247.31 1636.45 248.75 1636.45 249.94C1636.45 250.52 1636.25 250.93 1635.93 251.13H1635.91C1635.57 251.34 1635.11 251.31 1634.59 251.02C1633.56 250.42 1632.73 248.98 1632.73 247.79C1632.73 247.2 1632.94 246.78 1633.28 246.58C1633.62 246.38 1634.08 246.41 1634.6 246.71H1634.59Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1638.7 255.81C1639.69 255.19 1640.3 253.94 1640.3 252.16C1640.3 248.52 1637.75 244.09 1634.59 242.27C1633.01 241.36 1631.59 241.28 1630.56 241.87C1629.53 242.47 1628.89 243.75 1628.89 245.56C1628.89 249.2 1631.44 253.63 1634.6 255.45C1636.18 256.36 1637.6 256.45 1638.63 255.85",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1638.62 255.85L1642.55 253.59C1643.6 253 1644.24 251.71 1644.24 249.88C1644.24 246.24 1641.69 241.81 1638.53 239.99C1636.95 239.08 1635.52 238.99 1634.49 239.59L1630.55 241.87",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.53 229.81L1634.61 236.78C1631.06 235.31 1628.28 237.03 1627.95 241L1574.24 209.99V201.93L1622.53 229.81Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.61 236.78C1631.06 235.31 1628.28 237.03 1627.95 241L1574.24 209.99V201.93L1634.61 236.79V236.78Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1654.67 173.03V211.05L1618.82 231.75V193.73L1654.67 173.03Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1654.67 173.03L1618.82 193.73L1566.36 163.45L1602.22 142.74L1654.67 173.03Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618.82 193.73V231.75L1566.36 201.47V163.45L1618.82 193.73Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1566.36 163.45L1602.22 142.74L1654.67 173.03L1618.82 193.73L1566.36 163.45Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618.82 193.73V231.75",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1566.36 163.45V201.47L1618.82 231.75L1654.67 211.05V173.03",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1667.5 189.55L1637.72 206.75L1622.53 197.98L1652.31 180.79L1667.5 189.55Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1683.29 219.73L1653.5 236.92C1653.48 236.59 1653.45 236.27 1653.43 235.93L1652.12 221.4C1651.77 217.58 1649.13 213.32 1645.97 211.5L1637.72 206.74L1667.5 189.55L1675.75 194.31C1678.9 196.13 1681.55 200.4 1681.89 204.21C1681.89 204.21 1683.26 219.4 1683.28 219.72L1683.29 219.73Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1653.69 251.37V241.78C1653.69 240.2 1653.63 238.58 1653.5 236.93L1683.29 219.74C1683.42 221.39 1683.48 223 1683.48 224.59V234.18C1683.48 235.42 1683.04 236.29 1682.34 236.7L1652.56 253.89C1653.26 253.48 1653.7 252.61 1653.7 251.37H1653.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1653.43 235.94C1653.46 236.27 1653.49 236.6 1653.5 236.93L1646.15 232.69C1642.08 230.34 1638.71 224.75 1638.44 219.9L1637.71 206.75L1645.96 211.51C1649.12 213.33 1651.76 217.6 1652.11 221.41L1653.42 235.94H1653.43Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.15 232.68L1653.5 236.92C1653.63 238.57 1653.69 240.18 1653.69 241.77V251.36C1653.69 252.6 1653.26 253.47 1652.55 253.88C1651.85 254.29 1650.88 254.23 1649.8 253.61L1643.44 249.94C1643.07 245.16 1639.74 239.67 1635.69 237.32C1635.32 237.11 1634.96 236.93 1634.6 236.78L1622.52 229.81V197.98L1637.71 206.75L1638.44 219.9C1638.7 224.74 1642.08 230.33 1646.15 232.69V232.68Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1653.5 236.93C1653.63 238.58 1653.69 240.19 1653.69 241.78V251.37C1653.69 252.61 1653.25 253.48 1652.55 253.89C1651.85 254.3 1650.88 254.24 1649.8 253.62L1643.44 249.95C1643.07 245.17 1639.74 239.68 1635.69 237.33C1635.32 237.12 1634.96 236.94 1634.6 236.79L1622.52 229.82V197.99L1637.71 206.76",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1653.5 236.93L1683.29 219.73",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1653.5 236.93L1646.15 232.69C1642.08 230.34 1638.71 224.75 1638.44 219.9L1637.71 206.75L1645.96 211.51C1649.12 213.33 1651.76 217.6 1652.11 221.41C1652.11 221.41 1653.48 236.6 1653.5 236.92V236.93Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.53 197.98L1652.31 180.79L1675.75 194.32C1678.9 196.14 1681.55 200.41 1681.89 204.22C1681.89 204.22 1683.26 219.41 1683.28 219.73C1683.4 221.38 1683.47 222.99 1683.47 224.58V234.17C1683.47 235.41 1683.03 236.28 1682.33 236.69L1652.55 253.88",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1637.72 206.75L1667.5 189.55",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.33 6.2002V32.2402L1523.95 42.2702V16.2302L1541.33 6.2002Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1541.33 6.20021L1523.95 16.2302L1506.56 6.20021L1523.95 -3.83978L1541.33 6.20021Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.95 16.2302V42.2702L1506.56 32.2402V6.2002L1523.95 16.2302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1506.56 6.20021L1523.95 -3.83978L1541.33 6.20021L1523.95 16.2302L1506.56 6.20021Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.95 16.2302V42.2702",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1506.56 6.2002V32.2402L1523.95 42.2702L1541.33 32.2402V6.2002",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.34 -5.73975V50.1503L1554.96 60.1803V4.30025L1572.34 -5.73975Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.34 -5.73978L1554.96 4.30022L1537.58 -5.73978L1554.96 -15.7798L1572.34 -5.73978Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1554.96 4.30025V60.1803L1537.58 50.1503V-5.73975L1554.96 4.30025Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537.58 -5.73978L1554.96 -15.7798L1572.34 -5.73978L1554.96 4.30022L1537.58 -5.73978Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1554.96 4.30023V60.1802",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537.58 -5.73975V50.1503L1554.96 60.1803L1572.34 50.1503V-5.73975",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.36 24.1102V68.0502L1585.98 78.0902V34.1402L1603.36 24.1102Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.36 24.1102L1585.98 34.1402L1568.59 24.1102L1585.98 14.0702L1603.36 24.1102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1585.98 34.1402V78.0902L1568.59 68.0502V24.1102L1585.98 34.1402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1568.59 24.1102L1585.98 14.0702L1603.36 24.1102L1585.98 34.1402L1568.59 24.1102Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1585.98 34.1402V78.0902",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1568.59 24.1102V68.0502L1585.98 78.0902L1603.36 68.0502V24.1102",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.33 149.78L1858.17 91.5698V135.62L1757.15 193.95V149.89L1757.33 149.78ZM1838.14 126.53V118.62L1814.75 132.13V140.04L1838.14 126.53ZM1803.88 146.31V138.4L1780.49 151.91V159.82L1803.88 146.31Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1838.14 118.62V126.53L1814.75 140.04V132.12L1838.14 118.62Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.63 37.9898L1833.62 105.74L1809.08 119.91L1754.08 52.1598L1778.63 37.9898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1803.88 138.39V146.31L1780.49 159.81V151.9L1803.88 138.39Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1803.18 23.8198L1778.81 37.8798L1723.36 41.8598L1747.72 27.7998L1803.18 23.8198Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1729.54 66.3198L1784.53 134.08L1757.33 149.78L1702.34 82.0298L1729.54 66.3198Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.81 37.8798L1753.68 52.3898L1698.22 56.3698L1723.35 41.8598L1778.81 37.8798Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.81 37.8798L1803.18 23.8198L1858.17 91.5698L1833.62 105.74L1778.63 37.9898L1778.81 37.8798Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.15 149.89V193.95L1728.81 177.58V149.06L1675.04 118.01V146.54L1646.69 130.17V86.1098L1702.15 82.1298L1757.14 149.88L1757.15 149.89ZM1702.83 114.47C1704.74 114.3 1705.39 111.87 1704.29 109.03C1703.19 106.2 1700.75 104.04 1698.85 104.21C1696.94 104.38 1696.29 106.81 1697.39 109.65C1698.49 112.48 1700.93 114.64 1702.83 114.47Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754.08 52.1598L1809.08 119.91L1784.53 134.08L1729.54 66.3198L1754.08 52.1598Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1753.68 52.3898L1729.56 66.3098L1674.1 70.2898L1698.22 56.3698L1753.68 52.3898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674.1 70.2898L1729.56 66.3098L1702.16 82.1398L1646.7 86.1198L1674.1 70.2898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1728.81 149.06V177.58L1701.92 162.06V133.53L1728.81 149.06Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1704.29 109.03C1705.38 111.87 1704.74 114.3 1702.83 114.47C1700.93 114.64 1698.5 112.48 1697.39 109.65C1696.3 106.81 1696.94 104.38 1698.85 104.21C1700.75 104.04 1703.18 106.2 1704.29 109.03Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1702.34 82.0298L1757.33 149.78L1757.15 149.89L1702.16 82.1398L1702.34 82.0298Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701.92 162.06L1675.04 146.54V118.01L1701.92 133.53V162.06Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.15 193.94L1646.7 130.17V86.1198L1702.16 82.1398L1757.15 149.89V193.94Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1728.81 177.58V149.06L1675.04 118.01V146.53",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701.92 133.53V162.06",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1723.35 41.8598L1646.7 86.1198",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1803.18 23.8198L1747.72 27.7998L1723.36 41.8598",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.15 193.94L1858.17 135.62V91.5698",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.15 149.89L1858.17 91.5698",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1702.16 82.1398L1803.18 23.8198",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1704.29 109.03C1705.38 111.87 1704.74 114.3 1702.83 114.47C1700.93 114.64 1698.5 112.48 1697.39 109.65C1696.3 106.81 1696.94 104.38 1698.85 104.21C1700.75 104.04 1703.18 106.2 1704.29 109.03Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1803.88 146.31L1780.49 159.81V151.9L1803.88 138.39V146.31Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1838.14 126.53L1814.75 140.04V132.12L1838.14 118.62V126.53Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1858.17 91.5698L1803.18 23.8198",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1833.62 105.74L1778.63 37.9898",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1809.08 119.91L1754.08 52.1598",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784.53 134.08L1729.54 66.3198",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.33 149.78L1702.34 82.0298",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674.1 70.2898L1729.56 66.3098",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1698.22 56.3698L1753.68 52.3898",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1723.35 41.8598L1778.81 37.8798",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1969.13 77.6702C1969.13 64.5702 1958.51 53.9502 1945.41 53.9502C1932.31 53.9502 1921.69 64.5702 1921.69 77.6702C1921.69 90.7702 1932.31 101.39 1945.41 101.39C1958.51 101.39 1969.13 90.7702 1969.13 77.6702Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.04 375.94L804.51 369.29L777.68 415.76",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1891.66 160.64C1897.88 164.23 1902.92 172.97 1902.92 180.15C1902.92 187.33 1897.96 190.2 1891.81 186.74L1892.33 186.28C1893.5 185.34 1894.19 183.67 1894.19 181.4C1894.19 176.26 1890.58 170 1886.12 167.43C1883.84 166.11 1882 166.33 1880.39 166.78C1880.55 159.86 1885.53 157.1 1891.65 160.63L1891.66 160.64Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1894.19 181.4C1894.19 183.66 1893.49 185.33 1892.33 186.28C1892.14 186.44 1891.94 186.57 1891.72 186.69L1891.81 186.74L1884.72 193.03C1885.09 191.99 1885.29 190.77 1885.29 189.38C1885.29 182.56 1880.5 174.27 1874.6 170.86C1873.53 170.24 1872.5 169.83 1871.52 169.6C1871.52 169.6 1880.2 166.85 1880.4 166.79C1882.01 166.33 1883.85 166.12 1886.13 167.44C1890.59 170.01 1894.2 176.27 1894.2 181.41L1894.19 181.4Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1892.33 186.28L1891.81 186.74L1891.72 186.69C1891.94 186.57 1892.14 186.44 1892.33 186.28Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1885.28 189.38C1885.28 190.78 1885.08 192 1884.71 193.03C1884.16 194.57 1883.24 195.7 1882.06 196.35L1875.88 199.75C1877.87 198.66 1879.1 196.24 1879.1 192.78C1879.1 185.96 1874.31 177.67 1868.41 174.26C1865.51 172.59 1862.89 172.4 1860.96 173.45L1867.11 170.07C1868.33 169.4 1869.83 169.23 1871.5 169.62C1872.47 169.84 1873.51 170.26 1874.58 170.88C1880.49 174.29 1885.27 182.58 1885.27 189.4L1885.28 189.38Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1860.85 190.95C1858.92 187.6 1857.72 183.83 1857.72 180.42C1857.72 177.01 1858.96 174.54 1860.95 173.44H1860.97C1862.9 172.38 1865.52 172.57 1868.42 174.24C1874.33 177.65 1879.11 185.94 1879.11 192.76C1879.11 196.22 1877.88 198.64 1875.89 199.73C1873.96 200.79 1871.33 200.61 1868.42 198.93C1865.46 197.22 1862.78 194.29 1860.85 190.93V190.95Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1860.95 173.45C1858.96 174.54 1857.72 176.96 1857.72 180.43C1857.72 183.9 1858.91 187.61 1860.85 190.96C1862.79 194.32 1865.46 197.25 1868.42 198.96C1871.33 200.64 1873.96 200.82 1875.89 199.76C1877.88 198.66 1879.11 196.25 1879.11 192.79C1879.11 185.97 1874.32 177.68 1868.42 174.27C1865.52 172.6 1862.9 172.41 1860.97 173.46H1860.95V173.45Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1860.95 173.45L1867.12 170.05C1868.34 169.38 1869.84 169.21 1871.51 169.6C1872.48 169.83 1873.52 170.24 1874.59 170.86C1880.5 174.27 1885.28 182.56 1885.28 189.38C1885.28 190.78 1885.08 192 1884.71 193.03C1884.16 194.57 1883.24 195.7 1882.06 196.35L1875.88 199.75",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1892.33 186.28L1884.72 193.03",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1871.51 169.6C1871.51 169.6 1880.19 166.85 1880.39 166.79C1882 166.33 1883.84 166.12 1886.12 167.44C1890.58 170.01 1894.19 176.27 1894.19 181.41C1894.19 183.67 1893.49 185.34 1892.33 186.29C1892.14 186.45 1891.94 186.58 1891.72 186.7C1891.75 186.72 1891.78 186.73 1891.81 186.75C1897.98 190.17 1902.92 187.29 1902.92 180.16C1902.92 173.03 1897.88 164.24 1891.66 160.65C1885.54 157.12 1880.56 159.87 1880.4 166.8",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1868.48 186.83L1842.47 200.87",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.45 14.4798V40.1398C1185.45 42.6498 1184.59 44.4398 1183.19 45.3098L1183.08 45.3798C1181.62 46.2298 1179.6 46.1098 1177.37 44.8198L1132.8 19.0898L1116.99 21.2998L1120.65 12.0798L1115.11 8.87981C1110.65 6.2998 1107.03 0.029808 1107.03 -5.13019V-30.7902C1107.03 -33.3702 1107.94 -35.1802 1109.4 -36.0202C1110.86 -36.8702 1112.88 -36.7502 1115.11 -35.4502L1177.36 0.489807C1181.82 3.06981 1185.44 9.33981 1185.44 14.4898L1185.45 14.4798ZM1167.81 18.1698L1171.99 16.8698L1166.72 13.6698L1164.96 6.9198L1163.2 11.6298L1157.93 8.7498L1162.11 14.8698L1160.62 19.8398L1164.97 18.9098L1169.31 24.8598L1167.82 18.1598L1167.81 18.1698ZM1149.52 7.59981L1153.69 6.2998L1148.43 3.09981L1146.67 -3.65019L1144.91 1.0598L1139.64 -1.82019L1143.82 4.2998L1142.33 9.26981L1146.67 8.33981L1151.02 14.2898L1149.53 7.58981L1149.52 7.59981ZM1131.22 -2.96019L1135.39 -4.26019L1130.12 -7.46019L1128.36 -14.2102L1126.6 -9.5002L1121.34 -12.3802L1125.51 -6.26019L1124.02 -1.29019L1128.36 -2.23019L1132.7 3.7198L1131.21 -2.98019L1131.22 -2.96019Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.99 16.8698L1167.81 18.1698L1169.31 24.8598L1164.97 18.9098L1160.62 19.8398L1162.11 14.8798L1157.94 8.75981L1163.2 11.6298L1164.97 6.9198L1166.73 13.6698L1171.99 16.8698Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.69 6.29985L1149.52 7.59985L1151.01 14.2999L1146.66 8.34985L1142.32 9.27985L1143.82 4.30984L1139.64 -1.81015L1144.9 1.06985L1146.66 -3.65015L1148.43 3.09985L1153.69 6.29985Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.39 -4.2602L1131.22 -2.9602L1132.71 3.7298L1128.36 -2.22021L1124.02 -1.2902L1125.51 -6.2602L1121.34 -12.3802L1126.6 -9.50021L1128.36 -14.2102L1130.12 -7.4602L1135.39 -4.2602Z",
    fill: "#FBB93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.4 -36.0302L1115.12 -39.3402C1116.58 -40.1802 1118.61 -40.0602 1120.85 -38.7702L1183.1 -2.83019C1187.56 -0.250191 1191.18 6.01981 1191.18 11.1698V36.8298C1191.18 39.4098 1190.27 41.2198 1188.81 42.0598L1183.2 45.2998C1184.6 44.4298 1185.46 42.6498 1185.46 40.1298V14.4698C1185.46 9.30981 1181.84 3.04981 1177.38 0.469814L1115.13 -35.4702C1112.9 -36.7602 1110.87 -36.8802 1109.42 -36.0402L1109.4 -36.0302Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183.2 45.2998C1184.6 44.4298 1185.46 42.6498 1185.46 40.1298V14.4698C1185.46 9.3098 1181.84 3.0498 1177.38 0.469799L1115.13 -35.4702C1112.9 -36.7602 1110.88 -36.8802 1109.42 -36.0402C1107.96 -35.1902 1107.05 -33.3802 1107.05 -30.8102V-5.15019C1107.05 0.00980568 1110.67 6.2798 1115.13 8.8598L1120.67 12.0598L1117.01 21.2798L1132.82 19.0698L1177.39 44.7998C1179.62 46.0898 1181.65 46.2098 1183.1 45.3598",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.71 3.7298L1128.36 -2.22021L1124.02 -1.2902L1125.51 -6.2602L1121.34 -12.3802L1126.6 -9.50021L1128.36 -14.2102L1130.12 -7.4602L1135.39 -4.2602L1131.22 -2.9602L1132.71 3.7298Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.01 14.2999L1146.66 8.34985L1142.32 9.27985L1143.82 4.30984L1139.64 -1.81015L1144.9 1.06985L1146.66 -3.65015L1148.43 3.09985L1153.69 6.29985L1149.52 7.59985L1151.01 14.2999Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1169.31 24.8598L1164.97 18.9098L1160.62 19.8398L1162.11 14.8798L1157.94 8.75981L1163.2 11.6298L1164.97 6.9198L1166.73 13.6698L1171.99 16.8698L1167.81 18.1698L1169.31 24.8598Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.4 -36.0302L1115.12 -39.3402C1116.58 -40.1802 1118.61 -40.0602 1120.85 -38.7702L1183.1 -2.83019C1187.56 -0.250189 1191.18 6.01981 1191.18 11.1698V36.8298C1191.18 39.4098 1190.27 41.2198 1188.81 42.0598L1183.08 45.3598",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany1Dark);
export default __webpack_public_path__ + "static/media/Company1Dark.bcb36068dd9c8227b6ee42102e1d3ebb.svg";
export { ForwardRef as ReactComponent };